import { Component, OnInit } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UserService } from 'src/app/core/services/user.service';
import { BaseService } from 'src/app/core/services/base.service';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Config } from "../../../config/constants";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import * as pay from '../../../../assets/external.js'
// import { ReCaptchaV3Service } from 'ng-recaptcha';

declare var pay: any;
@Component({
  selector: 'app-quotes-purchase',
  templateUrl: './quotes-purchase.component.html',
  styleUrls: ['./quotes-purchase.component.scss'],
  providers: [DatePipe],
})
export class QuotesPurchaseComponent implements OnInit {
  displayCardNumber: string = '';
  showMaskedCard: boolean = false;
  @BlockUI() blockUI: NgBlockUI;
  tripsChecked: boolean = false;
  visitorsToCanadaChecked: boolean = false;
  visitorsToCanadaChecked1: boolean = false;
  visitorsToCanadaChecked2: boolean = false;
  studAccidentIncChecked: boolean = false;
  intStudPlanChecked: boolean = false;
  showChooseQuote: boolean = true;
  showIntStudPlan: boolean = false;
  numberOFInsured = 1;
  arrivalDateInCanada: any;
  showarrivalDateInCanadaPopup: boolean = false;
  showIntStudPlanStep1: boolean = false;
  showIntStudPlanPlanOption: boolean = false;
  showQuestionnaire: boolean = false;
  showQuestionnaireQue: boolean = false;
  showDeclarationQuestionnaire: boolean = false;
  showContactInfo: boolean = false;
  showPayment: boolean = false;
  showPaymentsDetails: boolean = false;
  finalizePaymentPopup: boolean = false;
  showResidentLanguagePopup: boolean = false;
  checkPayInFull: boolean = false;
  checkPayInMonthly: boolean = false;
  agentId: string;
  showChooseQuoteval: any;
  showSaveQuotesVal: any;
  showOkButton: boolean = false;
  privacystatementpopup: boolean = false;
  notEligibleQuestions: any = [];
  questionNumbers: number = 0;
  matProgressValue: number = 6;
  qestionInfoArrayShow = [];
  declaration = false;
  queIndex: any;
  travellerDetailsToSend: any = [];
  travellerInformationArray: any = [];
  minDateDOB = new Date();
  minDateDOB120 = new Date(new Date().setDate(new Date().getDate() - 43830))
  maxDatestart = new Date(new Date().setDate(new Date().getDate() + 1095))
  startDateSelected: string;
  expiryDateSelected: string;
  address1: any;
  address2: any;
  City: any;
  Province: any;
  PostalCode: any;
  purchaserAddressSame: boolean = false;
  step2headerclick: boolean = false;
  step3headerclick: boolean = false;
  step4headerclick: boolean = false;
  planNameToShow: string = "";
  savedQuotesID: any;
  showNextquesbtn: boolean = false;
  travelllerDetailsPersonArray: any;
  leadsId: string;
  tootltipForYou = 'Means the person(s) named as insured person(s) on your confirmation of coverage, for whom insurance coverage was applied and the required premium received by us.';
  tootltipForstudent = 'a) whose home country is not Canada and who is residing in Canada on a temporary basis; and b) who: i) is registered at a school, college, university or other governmentally accredited educational institutionin Canada and attends classes as a full-time student, as defined by the institution; or ii) remains in Canada for up to one year immediately after completion of studies as described above, and who is working or has applied to work in a field related to the studies completed.';
  tootltipForspouse = 'Means the person who is legally married to you or the person who has been living with you for a continuous period of at least one (1) year and is publicly represented as your domestic partner.';
  tootltipFordependent = 'Means your unmarried natural, adopted or step-children who are dependent on you for maintenance and support, or your grandchild(ren), who are travelling with you or joining you during your trip, and who are at least thirty (30) days of age and either (i) under twenty one (21) years of age or (ii) under twenty five (25) years of age and in full-time attendance at a recognized institution of higher learning in Canada. Dependent child(ren) also includes children 21 years of age or over who are permanently mentally or physically challenged and incapable of self-support.';
  checknotEligibleQuestions: any;
  tootltipForphysician = 'Means a person other than you, your immediate family member or your travel companion, who is licensed in the jurisdiction where the services are provided, to prescribe and administer medical treatment.  A physician does not include a naturopath, herbalist or homeopath.';
  tootltipForGovernmenthealthInsurancePlan = 'Means the health insurance coverage that a Canadian provincial or territorial government provides to its residents.';
  travellerInfoStep1: any[];
  SavedQuotetravellerDetailsToSend: any[];
  hideQuotePurchase: any;
  paymentTokenNew: any;
  PopupShowProvince: boolean = false;
  ArrivalDateFlagValid: boolean = false;
  primaryAddress1c: any;
  purchaserAddress1c: any;
  UrlBoxPolicy: any;
  UrlBoxPolicyDownload: any;
  showcheckbox: boolean = false;
  purchaserNonResidentCountryName: any;
  loggedInUserName: any;
  leadEmailInfo: any;
  loggedInphoneNumber: any;
  checkOVRInAgencyCode: any;
  agentIdActive: string;
  formattedDate: string;
  leadStatus: any;
  currentTime: string;
  constructor(public user: UserService, private datePipe: DatePipe, private base: BaseService, private config: Config, private router: Router) { }

  ngOnInit(): void {

    this.showChooseQuoteval = localStorage.getItem("gotoChangePolicy");
    this.showSaveQuotesVal = localStorage.getItem('ShowSavedQuotes');
    this.savedQuotesID = localStorage.getItem('savedQuotesID');
    this.hideQuotePurchase = sessionStorage.getItem('hideQuotePurchase');
    this.checkOVRInAgencyCode = sessionStorage.getItem('checkOVRInAgencyCode');
    this.leadsId = sessionStorage.getItem('leadId');
    this.leadEmailInfo = JSON.parse(sessionStorage.getItem('leadEmailInfo'));
    this.loggedInUserName = sessionStorage.getItem("username");
    this.loggedInphoneNumber = JSON.parse(sessionStorage.getItem('loggedInphoneNumber'));
    this.agentId = sessionStorage.getItem('agentIdSalesPortal');
    this.getLeadAgentsCodes();
    if (this.showSaveQuotesVal == "true") {
      localStorage.removeItem("ShowSavedQuotes");
      this.showChooseQuote = false;
      this.showIntStudPlan = true;
      this.showIntStudPlanStep1 = true;
      this.showResidentLanguagePopup = false;
      this.getQuoteData();
    } else {
      localStorage.removeItem("ShowSavedQuotes");
      localStorage.removeItem("savedQuotesID");
      this.savedQuotesID = null;
      this.showChooseQuote = true;
      this.showIntStudPlan = false;
      this.showIntStudPlanStep1 = false;
      this.addFirstValueTraveller();
    }
    // if(this.showChooseQuoteval=="true"){
    //   localStorage.removeItem("gotoChangePolicy");
    //   this.showChooseQuote=false;
    //   this.showIntStudPlan=true;
    //   this.showIntStudPlanStep1=true;
    // }else{
    //   localStorage.removeItem("gotoChangePolicy");
    //   this.showChooseQuote=true;
    //   this.showIntStudPlan=false;
    //   this.showIntStudPlanStep1=false;
    // }
    this.minDate.setHours(0, 0, 0, 0);
    this.minDate1.setHours(0, 0, 0, 0);
    this.minDateArrival.setHours(0, 0, 0, 0);
    this.getAllProvinces();
    this.getAllProvinces1();
    this.getAllLanguages();
    // this.insuredPerson();
    this.getcountryListing();
    this.getcountryListing1();
    const dateToAdd = new Date(new Date(this.saveQuoteDate).setDate(this.saveQuoteDate.getDate() + 21));
    this.saveQuoteDate = dateToAdd;
  }
  onClickTrips(event) {
    var checked = event.target.checked;
    if (checked == true) {
      this.tripsChecked = true;
      this.visitorsToCanadaChecked = false;
      this.intStudPlanChecked = false;
      this.studAccidentIncChecked = false;
    }
    else {
      this.tripsChecked = false;
    }
  }
  onClickvisitorsToCanada(event) {
    var checked = event.target.checked;
    if (checked == true) {
      this.visitorsToCanadaChecked = true;
      this.visitorsToCanadaChecked1 = true;
      this.visitorsToCanadaChecked2 = true;
      this.tripsChecked = false;
      this.intStudPlanChecked = false;
      this.studAccidentIncChecked = false;
    }
    else {
      this.visitorsToCanadaChecked = false;
      this.visitorsToCanadaChecked1 = false;
      this.visitorsToCanadaChecked2 = false;
    }
  }
  onClickvisitorsToCanada1(event) {

    var checked = event.target.checked;
    if (checked == true) {
      if (this.visitorsToCanadaChecked2 == true) {
        this.visitorsToCanadaChecked = true;
      }
      this.visitorsToCanadaChecked1 = true;
      this.tripsChecked = false;
      this.intStudPlanChecked = false;
      this.studAccidentIncChecked = false;
    }
    else {
      this.visitorsToCanadaChecked1 = false;
      this.visitorsToCanadaChecked = false;
    }
  }
  onClickvisitorsToCanada2(event) {

    var checked = event.target.checked;
    if (checked == true) {
      if (this.visitorsToCanadaChecked1 == true) {
        this.visitorsToCanadaChecked = true;
      }
      this.visitorsToCanadaChecked2 = true;
      this.tripsChecked = false;

      this.intStudPlanChecked = false;
      this.studAccidentIncChecked = false;
    }
    else {
      this.visitorsToCanadaChecked2 = false;
      this.visitorsToCanadaChecked = false;
    }
  }
  onClickstudAccidentInc(event) {
    var checked = event.target.checked;
    if (checked == true) {
      this.studAccidentIncChecked = true;
      this.tripsChecked = false;
      this.visitorsToCanadaChecked = false;
      this.intStudPlanChecked = false;
    }
    else {
      this.studAccidentIncChecked = false;
    }
  }
  onClickIntStudPlan(event){
    var checked =event.target.checked;
    if(checked==true){
      this.planNameToShow="All"
      this.intStudPlanChecked=true;
      this.intStudPlanChecked1=true;
      this.intStudPlanChecked2=true;
      this.visitorsToCanadaChecked=false;
      this.visitorsToCanadaChecked1=false;
      this.visitorsToCanadaChecked2=false;
      this.tripsChecked=false;
      this.visitorsToCanadaChecked=false;
      this.studAccidentIncChecked=false;
    }
    else {
      this.planNameToShow = ""
      this.intStudPlanChecked = false;
      this.intStudPlanChecked2 = false
      this.intStudPlanChecked1 = false;
    }
  }
  intStudPlanChecked1: boolean=false;
  intStudPlanChecked2: boolean=false;
  onClickIntStudPlan1(event){
    var checked =event.target.checked;
    if(checked==true){
      if(this.intStudPlanChecked2==true){
        this.intStudPlanChecked=true;
      }
      this.visitorsToCanadaChecked=false;
      this.visitorsToCanadaChecked1=false;
      this.visitorsToCanadaChecked2=false;
      this.planNameToShow="International Student Smart Plan"
      this.intStudPlanChecked1=true;
      this.tripsChecked=false;
      this.visitorsToCanadaChecked=false;
      this.studAccidentIncChecked=false;
      if(this.intStudPlanChecked2==true){
        this.intStudPlanChecked=true;
        this.planNameToShow="All"
      }
    }
    else {
      this.intStudPlanChecked1 = false;
      this.intStudPlanChecked = false;
      this.intStudPlanChecked1 = false;
    }
  }
  onClickIntStudPlan2(event){
    var checked =event.target.checked;
    if(checked==true){
      if(this.intStudPlanChecked1==true){
        this.intStudPlanChecked=true;
      }
      this.visitorsToCanadaChecked=false;
      this.visitorsToCanadaChecked1=false;
      this.visitorsToCanadaChecked2=false;
      this.visitorsToCanadaChecked=false;
      this.visitorsToCanadaChecked1=false;
      this.visitorsToCanadaChecked2=false;
      this.planNameToShow="International Student Smart-Plus Plan"
      this.intStudPlanChecked2=true;
      this.tripsChecked=false;
      this.visitorsToCanadaChecked=false;
      this.studAccidentIncChecked=false;
      if(this.intStudPlanChecked1==true){
        this.intStudPlanChecked=true;
        this.planNameToShow="All"
      }
    }
    else {
      this.intStudPlanChecked2 = false;
      this.intStudPlanChecked = false;
      this.intStudPlanChecked2 = false;
    }
  }
  onClickSelectPlanContinue() {

    // this.visitorsToCanadaChecked=false;
    // this.visitorsToCanadaChecked1=false;
    // this.visitorsToCanadaChecked2=false;
    if (this.visitorsToCanadaChecked == true) {

      sessionStorage.setItem('visitorsToCanadaChecked', 'true');
      // sessionStorage.setItem('visitorsToCanadaChecked1', 'true');
      // sessionStorage.setItem('visitorsToCanadaChecked2', 'true');
    }
    // else{
    if (this.visitorsToCanadaChecked1 == true) {

      sessionStorage.setItem('visitorsToCanadaChecked1', 'true');
    }
    if (this.visitorsToCanadaChecked2 == true) {

      sessionStorage.setItem('visitorsToCanadaChecked2', 'true');
    }
    // }

    localStorage.removeItem('responseID');
    localStorage.removeItem('ssl_first_name');
    localStorage.removeItem('transactionID');
    localStorage.removeItem('ssl_last_name');
    localStorage.removeItem('amount');
    localStorage.removeItem('ssl_merchant_initiated_unscheduled');
    localStorage.removeItem('ssl_issuer_response');
    localStorage.removeItem('ssl_partner_app_id');
    localStorage.removeItem('ssl_card_number');
    localStorage.removeItem('ssl_transaction_type');
    localStorage.removeItem('ssl_transaction_reference_number');
    localStorage.removeItem('ssl_result');
    localStorage.removeItem('ssl_approval_code');
    localStorage.removeItem('ssl_txn_time');
    localStorage.removeItem('ssl_amount');
    localStorage.removeItem('ssl_transaction_currency');
    localStorage.removeItem('ssl_account_balance');
    localStorage.removeItem('ssl_ps2000_data');
    localStorage.removeItem('ssl_exp_date');
    localStorage.removeItem('ssl_result_message');
    localStorage.removeItem('ssl_card_short_description');
    localStorage.removeItem('ssl_get_token');
    localStorage.removeItem('ssl_token_response');
    localStorage.removeItem('ssl_card_type');
    localStorage.removeItem('ssl_cvv2_response');
    localStorage.removeItem('ssl_add_token_response');
    localStorage.removeItem('ssl_avs_response');
    localStorage.removeItem('ssl_first_name');
    localStorage.removeItem('ssl_last_name');
    localStorage.removeItem('ssl_oar_data');
    localStorage.removeItem('ssl_get_token');
    localStorage.removeItem('ssl_salestax');
    localStorage.removeItem('ssl_token');
    localStorage.removeItem('savedQuotesID');
    localStorage.removeItem('ssl_avs_address');
    localStorage.removeItem('ssl_avs_zip');
    window.scrollTo(0, 0);
    
    if(this.intStudPlanChecked==true || this.intStudPlanChecked1==true || this.intStudPlanChecked2==true){
      this.showResidentLanguagePopup=true;
      this.showChooseQuote=false;
      this.showIntStudPlan=true;
      this.showIntStudPlanStep1=true;
      this.showIntStudPlanPlanOption=false;
      this.showQuestionnaire=false;
      this.showContactInfo=false;
      this.showPayment=false;
      this.showPaymentsDetails=false;
    }
    if (this.studAccidentIncChecked == true) {
      this.showChooseQuote = false;
      this.showStudAccidentInsure = true;
      this.showStudAccidentInsureStep1 = true;
      this.showStudAccidentInsurePlanOption = false;
    }
    
    if(this.visitorsToCanadaChecked==true || this.visitorsToCanadaChecked1==true || this.visitorsToCanadaChecked2==true){
      this.router.navigateByUrl('/dashboard/vtc');
      // this.showChooseQuote=false;
      // this.showStudAccidentInsure=true;
      // this.showStudAccidentInsureStep1=true;
      // this.showStudAccidentInsurePlanOption=false;
    }
    this.showChooseQuote=false;
    this.showIntStudPlan=true;
    this.showIntStudPlanStep1=true;
    this.showIntStudPlanPlanOption=false;
    this.showQuestionnaire=false;
    this.showContactInfo=false;
    this.showPayment=false;
    this.showPaymentsDetails=false;
  }
  onClickSelectLanguageResident() {
    this.showResidentLanguagePopup = false;
    // this.showChooseQuote=false;
    // this.showIntStudPlan=true;
    // this.showIntStudPlanStep1=true;
    // this.showIntStudPlanPlanOption=false;
    // this.showQuestionnaire=false;
    // this.showContactInfo=false;
    // this.showPayment=false;
    // this.showPaymentsDetails=false;
  }

  showRemove: boolean = false;
  insuredCount = 1;
  incNumberOfInsured() {
    if (this.insuredCount != 9) {
      this.insuredCount++
      this.numberOFInsured = this.insuredCount;
      this.addFirstValueTraveller();
      if (this.insuredCount > 1) {
        this.showRemove = true;
      } else {
        this.showRemove = false;
      }
    }
  }
  minusNumberOfInsured() {
    if (this.insuredCount < 10 && this.insuredCount > 1) {
      this.numberOFInsured = this.insuredCount
      this.insuredCount--
      this.travellerInfo.splice(this.insuredCount, 1);
      this.travellerInformation.splice(this.insuredCount, 1)
      if (this.insuredCount > 1) {
        this.showRemove = true;
      } else {
        this.showRemove = false;
      }
    }
  }

  minusNumberOfInsuredShort(i) {
    if (this.insuredCount < 10 && this.insuredCount > 0) {
      this.numberOFInsured--;
      this.insuredCount--
      this.travellerInfo.splice(i, 1);
      this.travellerInformation.splice(i, 1)
      if (this.insuredCount > 1) {
        this.showRemove = true;
      } else {
        this.showRemove = false;
      }
    }
  }

  openDialog2() {
    this.privacystatementpopup = true
  }
  onClickToShowPlanInfo1() {
    for (let k = 0; k < this.travellerInfo.length; k++) {
      if (this.travellerInfo[k].arrivalDateOfCanada == "" || this.travellerInfo[k].arrivalDateOfCanada == null) {
        this.arrivalDateCanadaFlag = true
        this.travellerInfo[k].arrivalDateCanadaFlag = true
      }
      else {
        this.arrivalDateCanadaFlag = false
        this.travellerInfo[k].arrivalDateCanadaFlag = false
      }
      // this.travellerInfo[k].dateOfBirth = this.datePipe.transform(this.travellerInfo[k].dateOfBirth, "yyyy-MM-dd");
      if (this.travellerInfo[k].dateOfBirth == "" || this.travellerInfo[k].dateOfBirth == null) {
        this.dobFlag = true;
        this.travellerInfo[k].dobFlag = true
      }
      else {
        this.dobFlag = false;
        this.travellerInfo[k].dobFlag = false
      }
    }
    //     if(!this.expiryDate){this.expiryDateFlag=true}else{this.expiryDateFlag=false;this.expiryDateFlagValid=false}
    // if(!this.startDate){this.startDateFlag=true}else{this.startDateFlag=false;this.startDateFlagValid=false}
    // if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true}else{this.arrivalDateCanadaFlag=false}
    // if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true}else{this.dobFlag=false}
  }
  onClickToShowPlanInfo() {
    window.scrollTo(0, 0);
    var flag = true;


    console.log(this.expiryDate)
    if (!this.expiryDate) { this.expiryDateFlag = true; flag = false } else { this.expiryDateFlag = false; this.expiryDateFlagValid = false }
    if (!this.startDate) { this.startDateFlag = true; flag = false } else { this.startDateFlag = false; this.startDateFlagValid = false }
    // if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false;flag=true}
    // if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false;flag=true}
    for (let k = 0; k < this.travellerInfo.length; k++) {
      if (this.travellerInfo[k].arrivalDateOfCanada == "" || this.travellerInfo[k].arrivalDateOfCanada == null) {
        this.arrivalDateCanadaFlag = true; flag = false
        this.travellerInfo[k].arrivalDateCanadaFlag = true
      }
      else {
        this.arrivalDateCanadaFlag = false;
        this.travellerInfo[k].arrivalDateCanadaFlag = false
      }
      // this.travellerInfo[k].dateOfBirth = this.datePipe.transform(this.travellerInfo[k].dateOfBirth, "yyyy-MM-dd");
      if (this.travellerInfo[k].dateOfBirth == "" || this.travellerInfo[k].dateOfBirth == null) {
        this.dobFlag = true; flag = false
        this.travellerInfo[k].dobFlag = true
      }
      else {
        this.dobFlag = false;
        this.travellerInfo[k].dobFlag = false
      }
    }

    //  for(let i=0;i<this.travellerInfo.length;i++){
    //   this.travellerInfo[i].arrivalDateOfCanada = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    //   this.travellerInfo[i].dateOfBirth = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd");
    //  }

    if (flag == true) {
      this.expiryDateSelected = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
      this.startDateSelected = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
      this.travellerInfoStep1 = []
      for (let i = 0; i < this.travellerInfo.length; i++) {
        var obj = {};
        obj["dateOfBirth"] = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd")
        obj["age"] = this.travellerInfo[i].age;
        obj["arrivalDateOfCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
        obj["waitPeroid"] = this.travellerInfo[i].waitPeroid;
        obj["eligable"] = true,
          this.travellerInfoStep1.push(obj);
      }
      // if(this.showSaveQuotesVal!="true"){
      this.travellerInformation = []
      for (let i = 0; i < this.travellerInfo.length; i++) {
        var obj = {};
        obj["age"] = this.travellerInfo[i].age;
        obj["arrivalDateInCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
        obj["arrivalDateOfCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
        obj["country"] = ""
        obj["dateOfBirth"] = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd")
        obj["dayTimePhone"] = ""
        obj["deductableOptionId"] = 0
        obj["departureCity"] = ""
        obj["eligable"] = true
        obj["emailAddress"] = ""
        obj["firstName"] = ""
        obj["insitute"] = ""
        obj["insurancePremium"] = ""
        obj["insuredId"] = 0;
        obj["language"] = ""
        obj["lastName"] = ""
        obj["premium"] = 0
        obj["tripCost"] = ""
        obj["waitPeroid"] = this.travellerInfo[i].waitPeroid;
        obj["questionsansers"] =
          [
            {
              "answer": "",
              "question": "",
              "quetionId": 0,
              "quetionAnswerId": 0,
            },
            {
              "answer": "",
              "question": "",
              "quetionId": 0,
              "quetionAnswerId": 0,
            },
            {
              "answer": "",
              "question": "",
              "quetionId": 0,
              "quetionAnswerId": 0,
            },
            {
              "answer": "",
              "question": "",
              "quetionId": 0,
              "quetionAnswerId": 0,
            },
          ]
        this.travellerInformation.push(obj);
        try {
          if (this.savedQuotePolicyInsuredArray.length > 0) {
            if (this.savedQuotePolicyInsuredArray[i].id) {
              this.travellerInformation[i].insuredId = this.savedQuotePolicyInsuredArray[i].id
              this.travellerInformation[i].firstName = this.savedQuotePolicyInsuredArray[i].firstName
              this.travellerInformation[i].lastName = this.savedQuotePolicyInsuredArray[i].lastName
              this.travellerInformation[i].departureCity = this.savedQuotePolicyInsuredArray[i].homeCountry
              this.travellerInformation[i].country = this.savedQuotePolicyInsuredArray[i].homeCountry
              this.travellerInformation[i].insitute = this.savedQuotePolicyInsuredArray[i].insitute
            }
            if (this.savedQuotePolicyInsuredArray[i].policyQuestionAnswers) {
              for (let k = 0; k < this.savedQuotePolicyInsuredArray[i].policyQuestionAnswers.length; k++) {
                this.travellerInformation[i].questionsansers[k].answer = this.savedQuotePolicyInsuredArray[i].policyQuestionAnswers[k].answer;
                if (this.savedQuotePolicyInsuredArray[i].policyQuestionAnswers[k].question != null) {
                  this.travellerInformation[i].questionsansers[k].question = this.savedQuotePolicyInsuredArray[i].policyQuestionAnswers[k].question.question;
                  this.travellerInformation[i].questionsansers[k].quetionId = this.savedQuotePolicyInsuredArray[i].policyQuestionAnswers[k].question.id;
                }
                this.travellerInformation[i].questionsansers[k].quetionAnswerId = this.savedQuotePolicyInsuredArray[i].policyQuestionAnswers[k].id;
              }
            }
          }
        }
        catch { }
      }
      // }
      // else{
      //    this.getQuoteData();
      // }
      console.log(this.travellerInfo)
      console.log(this.travellerInfoStep1)
      try {
        if (this.NonResidentCountry.displayName) {
          this.NonResidentCountry = this.NonResidentCountry.displayName
        } else {
          this.NonResidentCountry = this.NonResidentCountry
        }
      }
      catch {

      }
      const request =
      {
        "policyId": this.savedQuotesID,
        "agentId": this.agentId,
        "declaration": true,
        "deductableOptions": [
          {
            "amount": 0,
            "createdAt": "2022-04-27T05:08:15.125Z",
            "createdBy": "string",
            "id": 0,
            "lastModifiedBy": "string",
            "option": "string",
            "reduceAmount": 0,
            "updatedAt": "2022-04-27T05:08:15.125Z"
          }
        ],
        "language": this.selectedQuestionlanguages1,
        "noOfDays": this.calculatedDays,
        "optionalInformation": {
          "agentNote": "string",
          "beneficiary": "string",
          "comment": "string"
        },
        "paymentInformation": {
          "amount": 0,
          "cardNumber": "string",
          "cardType": "string",
          "cvv": "string",
          "expiryDate": "string"
        },
        "primaryAddress": {
          "address1": "string",
          "address2": "string",
          "city": "string",
          "postalCode": "string",
          "province": "string"
        },
        "isSameAddress": this.purchaserAddressSame,
        "questionsansers": [

        ],
        "residentOf": this.selectedQuestionprovince1,
        "returnDate": this.expiryDateSelected,
        "secondaryAddress": {
          "address1": "string",
          "address2": "string",
          "city": "string",
          "postalCode": "string",
          "province": "string"
        },
        "selectedPlan": this.selectedPlanSend,
        "startDate": this.startDateSelected,
        "travellerInformation": this.travellerInfoStep1,
        "travelllerDetails": this.travellerInformation,
        "visitorsToCanada": "yes",
        "purchaserInformation": {
          "country": this.NonResidentCountry,
          "emailAddress": "",
          "firstName": "",
          "language": "",
          "lastName": "",
          "phoneNumber1": "",
          "phoneNumber2": "",
          "postalCode": "",
          "province": "",
          "purchaserAddress": {
            "country": this.NonResidentCountry,
            "address1": "",
            "address2": "",
            "city": "",
            "postalCode": ""
          }
        }
      }

      console.log(this.travellerInfo)
      this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
        this.step2headerclick = true
        if (this.planNameToShow == "All") {
          this.planQuoteResponses = []
          this.planQuoteResponses = data.data.planQuoteResponses;

        }
        //       this.planNameToShow="International Student Smart Plan"
        // this.planNameToShow="International Student Smart-Plus Plan"
        else if (this.planNameToShow == "International Student Smart Plan") {
          this.planQuoteResponses = []
          this.planQuoteResponses.push(data.data.planQuoteResponses[0]);
        }
        else if (this.planNameToShow == "International Student Smart-Plus Plan") {
          this.planQuoteResponses = []
          this.planQuoteResponses.push(data.data.planQuoteResponses[1]);
        }
        // else{
        //   this.planQuoteResponses=[]
        //   this.planQuoteResponses = data.data.planQuoteResponses;
        // }
        if (this.showSaveQuotesVal == "true") {
          if (this.planQuoteResponses.length == 1) {
            for (let m = 0; m < data.data.planQuoteResponses.length; m++) {
              if (data.data.planQuoteResponses[m].planName == this.planQuoteResponses[0].planName) {
                this.planQuoteResponses = []
                this.planNameToShow = data.data.planQuoteResponses[m].planName
                this.planQuoteResponses.push(data.data.planQuoteResponses[m]);
              }
            }
          } else {
            this.planQuoteResponses = []
            this.planQuoteResponses = data.data.planQuoteResponses;
          }
          this.travellerInformation = []
          for (let i = 0; i < data.data.salesRequest.travelllerDetails.length; i++) {
            var obj = {}
            obj["age"] = data.data.salesRequest.travelllerDetails[i].age
            obj["arrivalDateOfCanada"] = data.data.salesRequest.travelllerDetails[i].arrivalDateOfCanada
            obj["dateOfBirth"] = data.data.salesRequest.travelllerDetails[i].dateOfBirth
            obj["waitPeroid"] = data.data.salesRequest.travelllerDetails[i].waitPeroid
            obj["notEligibleFlag"] = false
            obj["checkDeclaration"] = false
            obj["age"] = data.data.salesRequest.travelllerDetails[i].age
            obj["arrivalDateInCanada"] = data.data.salesRequest.travelllerDetails[i].arrivalDateOfCanada;
            obj["arrivalDateOfCanada"] = data.data.salesRequest.travelllerDetails[i].arrivalDateOfCanada;
            obj["homeCountry"] = data.data.salesRequest.travelllerDetails[i].departureCity;
            obj["dateOfBirth"] = data.data.salesRequest.travelllerDetails[i].dateOfBirth;
            obj["dayTimePhone"] = ""
            obj["deductableOptionId"] = ""
            obj["departureCity"] = data.data.salesRequest.travelllerDetails[i].departureCity;
            obj["eligable"] = "true"
            obj["emailAddress"] = ""
            obj["firstName"] = data.data.salesRequest.travelllerDetails[i].firstName;
            obj["insitute"] = data.data.salesRequest.travelllerDetails[i].insitute
            obj["language"] = this.selectedQuestionlanguages1
            obj["lastName"] = data.data.salesRequest.travelllerDetails[i].lastName;
            obj["premium"] = ""
            obj["insuredId"] = data.data.salesRequest.travelllerDetails[i].insuredId;

            obj["question"] =
              [
                { question: "" },
                { question: "" },
                { question: "" },
                { question: "" }
              ]
            obj["quetionId"] =
              [
                { quetionId: "" },
                { quetionId: "" },
                { quetionId: "" },
                { quetionId: "" }
              ]
            obj["ans"] =
              [
                { ans: "" },
                { ans: "" },
                { ans: "" },
                { ans: "" }
              ]
            obj["answer"] = [
              { answer: false },
              { answer: false },
              { answer: false },
              { answer: false }
            ]
            obj["quetionAnswerId"] = [
              { quetionAnswerId: "" },
              { quetionAnswerId: "" },
              { quetionAnswerId: "" },
              { quetionAnswerId: "" }
            ]
            this.travellerInformation.push(obj);
            for (let j = 0; j < data.data.salesRequest.travelllerDetails[i].questionsansers.length; j++) {
              if (data.data.salesRequest.travelllerDetails[i].questionsansers[j].question) {
                this.travellerInformation[i].question[j].question = data.data.salesRequest.travelllerDetails[i].questionsansers[j].question;
                this.travellerInformation[i].quetionId[j].quetionId = data.data.salesRequest.travelllerDetails[i].questionsansers[j].quetionId;
              }
              this.travellerInformation[i].ans[j].ans = data.data.salesRequest.travelllerDetails[i].questionsansers[j].answer;
              this.travellerInformation[i].answer[j].answer = data.data.salesRequest.travelllerDetails[i].questionsansers[j].answer;
              this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.salesRequest.travelllerDetails[i].questionsansers[j].quetionAnswerId;
            }
          }
        }
        else {
          if (this.planNameToShow == "All") {
            this.planQuoteResponses = []
            this.planQuoteResponses = data.data.planQuoteResponses;

          }
          //       this.planNameToShow="International Student Smart Plan"
          // this.planNameToShow="International Student Smart-Plus Plan"
          else if (this.planNameToShow == "International Student Smart Plan") {
            this.planQuoteResponses = []
            this.planQuoteResponses.push(data.data.planQuoteResponses[0]);
          }
          else if (this.planNameToShow == "International Student Smart-Plus Plan") {
            this.planQuoteResponses = []
            this.planQuoteResponses.push(data.data.planQuoteResponses[1]);
          }
          else {
            this.planQuoteResponses = []
            this.planQuoteResponses = data.data.planQuoteResponses;
          }
          this.travellerInformation = []
          for (let i = 0; i < data.data.salesRequest.travellerInformation.length; i++) {
            var obj = {}
            obj["age"] = data.data.salesRequest.travellerInformation[i].age
            obj["arrivalDateOfCanada"] = data.data.salesRequest.travellerInformation[i].arrivalDateOfCanada
            obj["dateOfBirth"] = data.data.salesRequest.travellerInformation[i].dateOfBirth
            obj["waitPeroid"] = data.data.salesRequest.travellerInformation[i].waitPeroid
            obj["notEligibleFlag"] = false
            obj["checkDeclaration"] =
              obj["insuredId"] = data.data.salesRequest.travelllerDetails[i].insuredId
            obj["question"] =
              [
                { question: "" },
                { question: "" },
                { question: "" },
                { question: "" }
              ]
            obj["quetionId"] =
              [
                { quetionId: "" },
                { quetionId: "" },
                { quetionId: "" },
                { quetionId: "" }
              ]
            obj["ans"] =
              [
                { ans: "" },
                { ans: "" },
                { ans: "" },
                { ans: "" }
              ]
            obj["answer"] = [
              { answer: false },
              { answer: false },
              { answer: false },
              { answer: false }
            ]
            obj["quetionAnswerId"] = [
              { quetionAnswerId: "" },
              { quetionAnswerId: "" },
              { quetionAnswerId: "" },
              { quetionAnswerId: "" }
            ]
            this.travellerInformation.push(obj);
          }
        }
        this.startDateShow = data.data.salesRequest.startDate;
        this.expiryDateShow = data.data.salesRequest.returnDate;
        this.resdentShowShow = data.data.salesRequest.residentOf;
        this.daysToshow = this.calculatedDays;


        this.qestionInfoArray = [];
        //this.qestionInfoArray = data.data.questions;
        let object = {};
        data.data.questions.forEach(element => {
          object = {};
          object['id'] = element.id;
          object['plans'] = element.plans;
          object['questionOptions'] = element.questionOptions;
          object['question'] = element.question;
          object['questionArray'] = element.question.split(' ');
          this.qestionInfoArray.push(object);
        })
        console.log("QuestionInfoArray!!!", this.qestionInfoArray);
        this.qestionInfoArrayShow = [];
        this.showQuestionnaireQue = true
        this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
        window.scrollTo(0, 0);
        if (this.showSendSaveQuoteEmail == false) {
          this.showChooseQuote = false;
          this.showIntStudPlan = true;
          this.showIntStudPlanStep1 = false;
          this.showIntStudPlanPlanOption = true;
          this.showQuestionnaire = false;
          this.showContactInfo = false;
          this.showPayment = false;
          this.showPaymentsDetails = false;
        }
      }, error => {

      }, () => { });
    }
  }
  saveQuotesPopup: boolean = false;
  openQuotePopUp() {
    var flag = true;
    this.saveQuotetravellerInfo = [];
    this.saveQuoteTravellerDetails = [];
    if (!this.expiryDate) { this.expiryDateFlag = true; flag = false } else { this.expiryDateFlag = false; this.expiryDateFlagValid = false }
    if (!this.startDate) { this.startDateFlag = true; flag = false } else { this.startDateFlag = false; this.startDateFlagValid = false }
    // if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false;flag=true}
    // if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false;flag=true}
    for (let k = 0; k < this.travellerInfo.length; k++) {
      if (this.travellerInfo[k].arrivalDateOfCanada == "" || this.travellerInfo[k].arrivalDateOfCanada == null) {
        this.arrivalDateCanadaFlag = true; flag = false
        this.travellerInfo[k].arrivalDateCanadaFlag = true
      }
      else {
        this.arrivalDateCanadaFlag = false;
        this.travellerInfo[k].arrivalDateCanadaFlag = false
      }
      // this.travellerInfo[k].dateOfBirth = this.datePipe.transform(this.travellerInfo[k].dateOfBirth, "yyyy-MM-dd");
      if (this.travellerInfo[k].dateOfBirth == "" || this.travellerInfo[k].dateOfBirth == null) {
        this.dobFlag = true; flag = false
        this.travellerInfo[k].dobFlag = true
      }
      else {
        this.dobFlag = false;
        this.travellerInfo[k].dobFlag = false
      }
    }
    if (flag == true) {
      this.saveQuotesPopup = true;
    }
    else {
      this.saveQuotesPopup = false;
    }
  }
  quoteNameErrorRemove() {
    this.quoteNameFlag = false;
  }
  quoteName: any;
  quoteNameFlag: boolean = false;
  quoteDescriptions: any;
  saveQuotetravellerInfo = [];
  saveQuoteTravellerDetails = [];
  saveQuoteStage1() {
    var flag = true;
    this.saveQuotetravellerInfo = [];
    this.saveQuoteTravellerDetails = [];
    if (!this.expiryDate) { this.expiryDateFlag = true; flag = false } else { this.expiryDateFlag = false; this.expiryDateFlagValid = false }
    if (!this.startDate) { this.startDateFlag = true; flag = false } else { this.startDateFlag = false; this.startDateFlagValid = false }
    // if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false;flag=true}
    // if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false;flag=true}
    this.expiryDateSelected = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
    this.startDateSelected = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    for (let k = 0; k < this.travellerInfo.length; k++) {
      if (this.travellerInfo[k].arrivalDateOfCanada == "" || this.travellerInfo[k].arrivalDateOfCanada == null) {
        this.arrivalDateCanadaFlag = true; flag = false
        this.travellerInfo[k].arrivalDateCanadaFlag = true
      }
      else {
        this.arrivalDateCanadaFlag = false;
        this.travellerInfo[k].arrivalDateCanadaFlag = false
      }
      // this.travellerInfo[k].dateOfBirth = this.datePipe.transform(this.travellerInfo[k].dateOfBirth, "yyyy-MM-dd");
      if (this.travellerInfo[k].dateOfBirth == "" || this.travellerInfo[k].dateOfBirth == null) {
        this.dobFlag = true; flag = false
        this.travellerInfo[k].dobFlag = true
      }
      else {
        this.dobFlag = false;
        this.travellerInfo[k].dobFlag = false
      }
    }
    if (!this.quoteName) { this.quoteNameFlag = true; flag = false } else { this.quoteNameFlag = false }
    console.log(this.travellerInfo)
    for (let i = 0; i < this.travellerInfo.length; i++) {
      var obj = {};
      obj["dateOfBirth"] = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd")
      obj["age"] = this.travellerInfo[i].age;
      obj["arrivalDateOfCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
      obj["waitPeroid"] = this.travellerInfo[i].waitPeroid;
      obj["eligable"] = true,
        this.saveQuotetravellerInfo.push(obj);
    }
    for (let i = 0; i < this.travellerInfo.length; i++) {
      var obj = {};
      obj["age"] = this.travellerInfo[i].age;
      obj["arrivalDateInCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
      obj["arrivalDateOfCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
      obj["country"] = ""
      obj["dateOfBirth"] = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd")
      obj["dayTimePhone"] = ""
      obj["deductableOptionId"] = 0
      obj["departureCity"] = ""
      obj["eligable"] = true
      obj["emailAddress"] = ""
      obj["firstName"] =
        obj["insitute"] = ""
      obj["insurancePremium"] = ""
      obj["insuredId"] = 0;
      obj["language"] = ""
      obj["lastName"] = ""
      obj["premium"] = 0
      obj["questionsansers"] = []
      obj["tripCost"] = ""
      obj["waitPeroid"] = this.travellerInfo[i].waitPeroid;
      this.saveQuoteTravellerDetails.push(obj);

    }

    for (let i = 0; i < this.travellerInformation.length; i++) {
      // if(this.travellerInformation.length>0){
      if (this.travellerInformation[i].insuredId) {
        this.saveQuoteTravellerDetails[i].insuredId = this.travellerInformation[i].insuredId
      } else {
        this.saveQuoteTravellerDetails[i].insuredId = 0
      }
      if (this.travellerInformation[i].firstName) {
        this.saveQuoteTravellerDetails[i].firstName = this.travellerInformation[i].firstName
      } else {
        this.saveQuoteTravellerDetails[i].firstName = ""
      }
      if (this.travellerInformation[i].lastName) {
        this.saveQuoteTravellerDetails[i].lastName = this.travellerInformation[i].lastName
      } else {
        this.saveQuoteTravellerDetails[i].lastName = ""
      }
      // }
    }
    try {
      if (this.travellerInformation.length > 0) {
        if (this.travellerInformation[0].firstName) {
          this.saveQuoteTravellerDetails = []
          for (let i = 0; i < this.travellerInformation.length; i++) {

            if (this.travellerInformation[i].notEligibleFlag == false) {
              var obj = {}
              obj["age"] = this.travellerInformation[i].age;
              obj["arrivalDateInCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
              obj["country"] = this.travellerInformation[i].homeCountry;
              obj["dateOfBirth"] = this.travellerInformation[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = this.travellerInformation[i].homeCountry;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = this.travellerInformation[i].firstName;
              obj["insitute"] = this.travellerInformation[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = this.travellerInformation[i].lastName;
              obj["premium"] = this.amount;
              obj["insuredId"] = this.travellerInformation[i].insuredId;

              obj["questionsansers"] =


                [
                  {
                    "answer": this.travellerInformation[i].ans[0].ans,
                    "question": this.travellerInformation[i].question[0].question,
                    "quetionId": this.travellerInformation[i].quetionId[0].quetionId,
                    "quetionAnswerId": this.travellerInformation[i]?.quetionAnswerId[0]?.quetionAnswerId,
                  },
                  {
                    "answer": this.travellerInformation[i].ans[1].ans,
                    "question": this.travellerInformation[i].question[1].question,
                    "quetionId": this.travellerInformation[i].quetionId[1].quetionId,
                    "quetionAnswerId": this.travellerInformation[i]?.quetionAnswerId[1].quetionAnswerId,
                  },
                  {
                    "answer": this.travellerInformation[i].ans[2].ans,
                    "question": this.travellerInformation[i].question[2].question,
                    "quetionId": this.travellerInformation[i].quetionId[2].quetionId,
                    "quetionAnswerId": this.travellerInformation[i]?.quetionAnswerId[2]?.quetionAnswerId,
                  },
                  {
                    "answer": this.travellerInformation[i].ans[3].ans,
                    "question": this.travellerInformation[i].question[3].question,
                    "quetionId": this.travellerInformation[i].quetionId[3].quetionId,
                    "quetionAnswerId": this.travellerInformation[i]?.quetionAnswerId[3]?.quetionAnswerId,
                  }
                ]
              obj["tripCost"] = ""
              obj["waitPeroid"] = this.travellerInformation[i].waitPeroid;
              this.saveQuoteTravellerDetails.push(obj)


            }
          }
        }
      }
    }
    catch {

    }






    if (flag == true) {
      try {
        if (this.NonResidentCountry.displayName) {
          this.NonResidentCountry = this.NonResidentCountry.displayName
        } else {
          this.NonResidentCountry = this.NonResidentCountry
        }
      }
      catch {

      }
      const request =
      {
        "policyId": this.savedQuotesID,
        "agentId": this.agentId,
        "declaration": true,
        "deductableOptions": [
          {
            "amount": 0,
            "createdAt": "2022-04-27T05:08:15.125Z",
            "createdBy": "",
            "id": 0,
            "lastModifiedBy": "",
            "option": "",
            "reduceAmount": 0,
            "updatedAt": "2022-04-27T05:08:15.125Z"
          }
        ],
        "language": this.selectedQuestionlanguages1,
        "noOfDays": this.calculatedDays,
        "optionalInformation": {
          "agentNote": this.comment,
          "beneficiary": this.beneficiary,
          "comment": this.comment
        },
        "paymentInformation": {
          "amount": this.amount,
          "cardNumber": this.cardNoToSend,
          "cardType": this.cardType,
          "cvv": "",
          "expiryDate": this.expDate1ToSend + this.expDateYearToSend
        },

        "primaryAddress": {
          "address1": this.address1,
          "address2": this.address2,
          "city": this.City,
          "postalCode": this.PostalCode,
          "province": this.Province
        },
        "quoteDescriptions": this.quoteDescriptions,
        "quoteName": this.quoteName,
        "isSameAddress": this.purchaserAddressSame,
        "questionsansers": this.questionAnsArray,
        "residentOf": this.selectedQuestionprovince1,
        "returnDate": this.expiryDateSelected,
        "secondaryAddress": {
          "address1": "",
          "address2": "",
          "city": "",
          "postalCode": "",
          "province": ""
        },
        "selectedPlan": this.selectedPlanSend,
        "startDate": this.startDateSelected,
        "travellerInformation": this.saveQuotetravellerInfo,
        "travelllerDetails": this.saveQuoteTravellerDetails,
        "visitorsToCanada": this.selectedQuestionAns1,
        "purchaserInformation": {
          "country": this.NonResidentCountry,
          "emailAddress": this.purchaseEmail,
          "firstName": this.purchaserFirstName,
          "language": this.selectedQuestionlanguages1,
          "lastName": this.purchaserLastName,
          "phoneNumber1": this.purchasePhone1,
          "phoneNumber2": this.purchasePhone2,
          "postalCode": this.purchasePostalCode,
          "province": this.purchaseProvince,
          "purchaserAddress": {
            "country": this.NonResidentCountry,
            "address1": this.purchaserAddress1,
            "address2": this.purchaserAddress2,
            "city": this.purchaseCity,
            "postalCode": this.purchasePostalCode,
            "province": this.purchaseProvince
          }
        }
      }
      if (this.showSendSaveQuoteEmail == false) {
        this.base.callPostService(this.config.saveQuote, request).subscribe((data: any) => {
          if (data.status == true) {
            this.quoteNameFlag = false;
            this.saveQuotesPopup = false;
            this.saveQuotesPopup1 = false;
            this.saveQuotesPopup2 = false;
            // this.quoteName=data.data.quoteName
            // this.quoteDescriptions=data.data.quoteDescription
            this.savedQuotesID = data.data.id;
            this.savedQuoteEmailPlanName = data.data.planName;
            this.quoteName = data.data.quoteName
            this.quoteDescriptions = data.data.quoteDescription
            this.travellerInformation = []
            for (let i = 0; i < data.data.policyInsureds.length; i++) {
              var obj = {}
              obj["age"] = data.data.policyInsureds[i].age
              obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada
              obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth
              obj["waitPeroid"] = data.data.policyInsureds[i].waitPeroid
              obj["notEligibleFlag"] = false
              obj["checkDeclaration"] = false
              obj["age"] = data.data.policyInsureds[i].age
              obj["arrivalDateInCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
              obj["homeCountry"] = data.data.policyInsureds[i].homeCountry;
              obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = data.data.policyInsureds[i].homeCountry;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = data.data.policyInsureds[i].firstName;
              obj["insitute"] = data.data.policyInsureds[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = data.data.policyInsureds[i].lastName;
              obj["premium"] = ""
              obj["insuredId"] = data.data.policyInsureds[i].id;

              obj["question"] =
                [
                  { question: "" },
                  { question: "" },
                  { question: "" },
                  { question: "" }
                ]
              obj["quetionId"] =
                [
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" }
                ]
              obj["ans"] =
                [
                  { ans: "" },
                  { ans: "" },
                  { ans: "" },
                  { ans: "" }
                ]
              obj["answer"] = [
                { answer: false },
                { answer: false },
                { answer: false },
                { answer: false }
              ]
              obj["quetionAnswerId"] = [
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" }
              ]
              this.travellerInformation.push(obj);
              for (let j = 0; j < data.data.policyInsureds[i].policyQuestionAnswers.length; j++) {
                if (data.data.policyInsureds[i].policyQuestionAnswers[j].question != null) {
                  this.travellerInformation[i].question[j].question = data.data.policyInsureds[i].policyQuestionAnswers[j].question.question;
                  this.travellerInformation[i].quetionId[j].quetionId = data.data.policyInsureds[i].policyQuestionAnswers[j].question.id;
                }
                this.travellerInformation[i].ans[j].ans = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].answer[j].answer = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.policyInsureds[i].policyQuestionAnswers[j].id;

              }
            }
            this.savedQuotePolicyInsuredArray = data.data.policyInsureds;
            Swal.fire('', "Quote information saved.", 'success');
          } else {
            Swal.fire('', data.message, 'error');
          }
        }, error => {

        }, () => { });
      } else {
        this.base.callPostService(this.config.savePolicyQuoteAndEmail, request).subscribe((data: any) => {
          if (data.status == true) {
            this.savedEmailTemplate = data.data.emailTemplate;
            this.savedEmailTemplateName = data.data.emailName;
            this.savedQuotesID = data.data.policy.id;
            this.savedQuoteEmailPlanName = data.data.policy.planName;
            this.quoteName = data.data.policy.quoteName
            this.quoteDescriptions = data.data.policy.quoteDescription
            this.travellerInformation = []
            for (let i = 0; i < data.data.policy.policyInsureds.length; i++) {
              var obj = {}
              obj["age"] = data.data.policy.policyInsureds[i].age
              obj["arrivalDateOfCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada
              obj["dateOfBirth"] = data.data.policy.policyInsureds[i].dateOfBirth
              obj["waitPeroid"] = data.data.policy.policyInsureds[i].waitPeroid
              obj["notEligibleFlag"] = false
              obj["checkDeclaration"] = false
              obj["age"] = data.data.policy.policyInsureds[i].age
              obj["arrivalDateInCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada;
              obj["homeCountry"] = data.data.policy.policyInsureds[i].homeCountry;
              obj["dateOfBirth"] = data.data.policy.policyInsureds[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = data.data.policy.policyInsureds[i].homeCountry;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = data.data.policy.policyInsureds[i].firstName;
              obj["insitute"] = data.data.policy.policyInsureds[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = data.data.policy.policyInsureds[i].lastName;
              obj["premium"] = ""
              obj["insuredId"] = data.data.policy.policyInsureds[i].id;

              obj["question"] =
                [
                  { question: "" },
                  { question: "" },
                  { question: "" },
                  { question: "" }
                ]
              obj["quetionId"] =
                [
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" }
                ]
              obj["ans"] =
                [
                  { ans: "" },
                  { ans: "" },
                  { ans: "" },
                  { ans: "" }
                ]
              obj["answer"] = [
                { answer: false },
                { answer: false },
                { answer: false },
                { answer: false }
              ]
              obj["quetionAnswerId"] = [
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" }
              ]
              this.travellerInformation.push(obj);
              for (let j = 0; j < data.data.policy.policyInsureds[i].policyQuestionAnswers.length; j++) {
                if (data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question != null) {
                  this.travellerInformation[i].question[j].question = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question.question;
                  this.travellerInformation[i].quetionId[j].quetionId = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question.id;
                }
                this.travellerInformation[i].ans[j].ans = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].answer[j].answer = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].id;

              }
            }
            this.savedQuotePolicyInsuredArray = data.data.policy.policyInsureds;
            this.sendEmailOfSavedQuotes();
            // Swal.fire('',"Quote information saved.",'success');
          } else {
            Swal.fire('', data.message, 'error');
          }
        }, error => {

        }, () => { });
      }
    }
  }

  selectedPlanName: any;
  selectedPlanPrice: any;
  selectedPlanSend: any;
  selectedPlanSendHtml: any = [];
  purchasePlan(item) {

    this.questionNumbers = 0
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showIntStudPlan = true;
    this.showIntStudPlanStep1 = false;
    this.showIntStudPlanPlanOption = false;
    this.showQuestionnaire = true;
    this.showQuestionnaireQue = true;
    this.showContactInfo = false;
    this.showPayment = false;
    this.showPaymentsDetails = false;
    this.selectedPlanName = item.planName.trim();
    this.selectedPlanPrice = item.totalAmount;
    this.selectedPlanSendHtml.push(item)
    this.selectedPlanSend = null
    var obj = {};

    obj["planId"] = item.planId
    obj["planName"] = item.planName

    this.selectedPlanSend = obj;
    this.selectPlanDetails = []
    this.selectPlanDetails.push(item);

  }
  nextQuestion() {
    this.showQuestionnaireQue = false;
    this.showDeclarationQuestionnaire = false;
  }
  onClickQuestionnaireProceed() {
    window.scrollTo(0, 0);
    this.showQuestionnaireQue = false;
    this.showDeclarationQuestionnaire = false;
    this.showChooseQuote = false;
    this.showIntStudPlan = true;
    this.showIntStudPlanStep1 = false;
    this.showIntStudPlanPlanOption = false;
    this.showQuestionnaire = false;
    this.showQuestionnaireQue = false;
    this.showContactInfo = true;
    this.showPayment = false;
    this.showPaymentsDetails = false;
  }
  removeFirstNameError(i) {
    // this.firstNameFlag=false
    this.travellerInformation[i].firstNameFlag = false;
  }
  removeLastNameError(i) {
    // this.lastNameFlag=false;
    this.travellerInformation[i].lastNameFlag = false;
  }
  removeInstituteNameError(i) {
    // this.InstituteFlag=false;
    this.travellerInformation[i].InstituteFlag = false;
  }
  removeCountryNameError(i) {
    // this.CountryFlag=false;
    this.travellerInformation[i].CountryFlag = false;
  }
  purchaserAddress2: any;
  firstNameFlag: boolean = false;
  lastNameFlag: boolean = false;
  InstituteFlag: boolean = false;
  CountryFlag: boolean = false;
  onClickContactInfoNext() {
    //    if(this.purchaserAddressSame==true) {
    //     if(this.PopupShowProvince==true){
    //     this.showOutSideProvincePopup=true;
    //     this.PopupShowProvince=false
    //   }

    //   this.purchaserAddress1=this.address1;
    //   this.purchaserAddress2=this.address2;
    //   this.purchaseCity=this.City;
    //   this.purchasePostalCode=this.PostalCode;
    //   this.purchaseProvince=this.Province;
    //   this.resdentShowShow=this.Province;
    //   this.disableProvince = true;
    // }
    // this.PopupShowProvince=false
    var flag = true;
    // if(!this.purchaserLastName){flag=true;this.purchaserLastNameFlag=true}else{flag=false;this.purchaserLastNameFlag=false}
    // if(!this.purchaserFirstName){flag=true;this.purchaserFirstNameFlag=true}else{flag=false;this.purchaserFirstNameFlag=false}
    // if(!this.purchaserAddress1){flag=false;this.purchaserAddress1Flag=true}else{flag=true;this.purchaserAddress1Flag=false}
    // // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
    // if(!this.purchaseProvince){flag=false;this.purchaseProvinceFlag=true}else{flag=true;this.purchaseProvinceFlag=false}
    // if(!this.purchaseCity){flag=false;this.purchaseCityFlag=true}else{flag=true;this.purchaseCityFlag=false}
    // if(!this.purchasePostalCode){flag=false;this.purchasePostalCodeFlag=true}else{flag=true;this.purchasePostalCodeFlag=false}
    // if(!this.purchasePhone1){flag=false;this.purchasePhone1Flag=true}else{flag=true;this.purchasePhone1Flag=false}
    // if(!this.form4.purchasePhone2.value){flag=false;this.purchasePhone2Flag=true}else{flag=true;this.purchasePhone2Flag=false}
    // if(!this.purchaseEmail){flag=false;this.purchaseEmailFlag=true}else{flag=true;this.purchaseEmailFlag=false}
    // if(!this.purchaseEmailConfirm){flag=false;this.purchaseConfirmEmailFlag=true}else{flag=true;this.purchaseConfirmEmailFlag=false}
    // if(!this.travellerInformation[0].firstName){flag=false;this.firstNameFlag=true}else{flag=true;this.firstNameFlag=false}
    // if(!this.travellerInformation[0].lastName){flag=false;this.lastNameFlag=true}else{flag=true;this.lastNameFlag=false}
    // if(!this.travellerInformation[0].insitute){flag=false;this.InstituteFlag=true}else{flag=true;this.InstituteFlag=false}
    // if(!this.travellerInformation[0].homeCountry){flag=false;this.CountryFlag=true}else{flag=true;this.CountryFlag=false}

    for (let i = 0; i < this.travellerInformation.length; i++) {
      try { this.travellerInformation[i].firstName = this.travellerInformation[i].firstName.trim() } catch { }
      try { this.travellerInformation[i].lastName = this.travellerInformation[i].lastName.trim() } catch { }
      try { this.travellerInformation[0].insitute = this.travellerInformation[0].insitute.trim() } catch { }
      try { this.travellerInformation[0].homeCountry = this.travellerInformation[0].homeCountry.trim() } catch { }

      if (this.travellerInformation[i].firstName == "" || this.travellerInformation[i].firstName == null) {
        this.firstNameFlag = true; flag = false
        this.travellerInformation[i].firstNameFlag = true
      }
      else {
        this.firstNameFlag = false;
        this.travellerInformation[i].firstNameFlag = false
      }
      if (this.travellerInformation[i].lastName == "" || this.travellerInformation[i].lastName == null) {
        this.lastNameFlag = true; flag = false
        this.travellerInformation[i].lastNameFlag = true
      }
      else {
        this.lastNameFlag = false;
        this.travellerInformation[i].lastNameFlag = false
      }
      if (this.travellerInformation[0].insitute == "" || this.travellerInformation[0].insitute == null) {
        this.InstituteFlag = true; flag = false
        this.travellerInformation[0].InstituteFlag = true
      }
      else {
        this.InstituteFlag = false;
        this.travellerInformation[0].InstituteFlag = false
      }
      if ((this.travellerInformation[0].homeCountry == "" || this.travellerInformation[0].homeCountry == null) && this.NonResidentSelected == false) {
        this.CountryFlag = true; flag = false
        this.travellerInformation[0].CountryFlag = true
      }
      else {
        this.CountryFlag = false;
        this.travellerInformation[0].CountryFlag = false
      }
    }

    if (flag == true && this.confirmEmailMatch == false) {

      var premiumAmount2 = this.selectedPlanPrice;
      while (premiumAmount2.charAt(0) === '$') {
        premiumAmount2 = premiumAmount2.substring(1);
      }

      premiumAmount2 = premiumAmount2.replace(/,/g, "");
      this.amount = premiumAmount2
      this.travellerDetailsToSend = []
      for (let i = 0; i < this.travellerInformation.length; i++) {
        if (this.travellerInformation[i].notEligibleFlag == false) {
          var obj = {}
          obj["age"] = this.travellerInformation[i].age;
          obj["arrivalDateInCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
          obj["arrivalDateOfCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
          obj["country"] = this.travellerInformation[i].homeCountry;
          obj["dateOfBirth"] = this.travellerInformation[i].dateOfBirth;
          obj["dayTimePhone"] = ""
          obj["deductableOptionId"] = ""
          obj["departureCity"] = this.travellerInformation[i].homeCountry;
          obj["eligable"] = "true"
          obj["emailAddress"] = ""
          obj["firstName"] = this.travellerInformation[i].firstName;
          obj["insitute"] = this.travellerInformation[i].insitute
          obj["language"] = this.selectedQuestionlanguages1
          obj["lastName"] = this.travellerInformation[i].lastName;
          obj["premium"] = premiumAmount2;
          obj["insuredId"] = this.travellerInformation[i].insuredId;
          obj["questionsansers"] =
            // this.questionAnsArray

            [
              {
                "answer": this.travellerInformation[i].ans[0].ans,
                "question": this.travellerInformation[i].question[0].question,
                "quetionId": this.travellerInformation[i].quetionId[0].quetionId,
                "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId
              },
              {
                "answer": this.travellerInformation[i].ans[1].ans,
                "question": this.travellerInformation[i].question[1].question,
                "quetionId": this.travellerInformation[i].quetionId[1].quetionId,
                "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId
              },
              {
                "answer": this.travellerInformation[i].ans[2].ans,
                "question": this.travellerInformation[i].question[2].question,
                "quetionId": this.travellerInformation[i].quetionId[2].quetionId,
                "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId
              },
              {
                "answer": this.travellerInformation[i].ans[3].ans,
                "question": this.travellerInformation[i].question[3].question,
                "quetionId": this.travellerInformation[i].quetionId[3].quetionId,
                "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId
              }
            ]
          obj["tripCost"] = ""
          obj["waitPeroid"] = this.travellerInformation[i].waitPeroid;
          this.travellerDetailsToSend.push(obj)
        }
      }
      try {
        if (this.NonResidentCountry.displayName) {
          this.NonResidentCountry = this.NonResidentCountry.displayName
        } else {
          this.NonResidentCountry = this.NonResidentCountry
        }
      }
      catch {

      }
      const request =
      {
        "policyId": this.savedQuotesID,
        "agentId": this.agentId,
        "declaration": true,
        "salesType": "B2B",
        "deductableOptions": [
          {
            "amount": 0,
            "createdAt": "2022-04-27T05:08:15.125Z",
            "createdBy": "string",
            "id": 0,
            "lastModifiedBy": "string",
            "option": "string",
            "reduceAmount": 0,
            "updatedAt": "2022-04-27T05:08:15.125Z"
          }
        ],
        "language": this.selectedQuestionlanguages1,
        "noOfDays": this.calculatedDays,
        "optionalInformation": {
          "agentNote": this.comment,
          "beneficiary": this.beneficiary,
          "comment": this.agentNote
        },
        "paymentInformation": {
          "amount": this.amount,
          "cardNumber": this.ssl_card_number,
          "cardType": this.ssl_card_type,
          "cvv": this.cvvToSend,
          "expiryDate": this.ssl_exp_date
        },
        "primaryAddress": {
          "address1": "",
          "address2": "",
          "city": "",
          "postalCode": "",
          "province": ""
        },
        "isSameAddress": this.purchaserAddressSame,
        "questionsansers": this.questionAnsArray,
        "residentOf": this.selectedQuestionprovince1,
        "returnDate": this.expiryDateSelected,
        "secondaryAddress": {
          "address1": "string",
          "address2": "string",
          "city": "string",
          "postalCode": "string",
          "province": "string"
        },
        "selectedPlan": this.selectedPlanSend,
        "startDate": this.startDateSelected,
        "travellerInformation": this.travellerInfoStep1,
        "travelllerDetails": this.travellerDetailsToSend,
        "visitorsToCanada": this.selectedQuestionAns1,
        "purchaserInformation": {
          "country": this.NonResidentCountry,
          "emailAddress": this.purchaseEmail,
          "firstName": this.purchaserFirstName,
          "language": this.selectedQuestionlanguages1,
          "lastName": this.purchaserLastName,
          "phoneNumber1": this.purchasePhone1,
          "phoneNumber2": this.purchasePhone2,
          "postalCode": this.purchasePostalCode,
          "province": this.purchaseProvince,
          "purchaserAddress": {
            "country": this.NonResidentCountry,
            "address1": this.purchaserAddress1,
            "address2": this.purchaserAddress2,
            "city": this.purchaseCity,
            "postalCode": this.purchasePostalCode
          }
        }
      }
      // this.restService.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
      this.base.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
        if (this.purchaserAddressSame == true) {
          this.NonResidentSelected = false;

          if (this.PopupShowProvince == true) {
            this.showOutSideProvincePopup = true;
            this.PopupShowProvince = false
          }

          this.purchaserAddress1 = this.address1;
          this.purchaserAddress2 = this.address2;
          this.purchaseCity = this.City;
          this.purchasePostalCode = this.PostalCode;
          this.purchaseProvince = this.Province;
          this.resdentShowShow = this.Province;
          this.disableProvince = true;
        }
        this.PopupShowProvince = false
        this.travelllerDetailsPersonArray = []
        this.travelllerDetailsPersonArray = data.data.travelllerDetails
        window.scrollTo(0, 0);
        if (this.showSaveQuotesVal == "true") {
          this.travellerInformation = []
          for (let i = 0; i < data.data.travelllerDetails.length; i++) {
            var obj = {}
            obj["age"] = data.data.travelllerDetails[i].age
            obj["arrivalDateOfCanada"] = data.data.travelllerDetails[i].arrivalDateOfCanada
            obj["dateOfBirth"] = data.data.travelllerDetails[i].dateOfBirth
            obj["waitPeroid"] = data.data.travelllerDetails[i].waitPeroid
            obj["notEligibleFlag"] = false
            obj["checkDeclaration"] = false
            obj["age"] = data.data.travelllerDetails[i].age
            obj["arrivalDateInCanada"] = data.data.travelllerDetails[i].arrivalDateOfCanada;
            obj["arrivalDateOfCanada"] = data.data.travelllerDetails[i].arrivalDateOfCanada;
            obj["homeCountry"] = data.data.travelllerDetails[i].departureCity;
            obj["dateOfBirth"] = data.data.travelllerDetails[i].dateOfBirth;
            obj["dayTimePhone"] = ""
            obj["deductableOptionId"] = ""
            obj["departureCity"] = data.data.travelllerDetails[i].departureCity;
            obj["eligable"] = "true"
            obj["emailAddress"] = ""
            obj["firstName"] = data.data.travelllerDetails[i].firstName;
            obj["insitute"] = data.data.travelllerDetails[i].insitute
            obj["language"] = this.selectedQuestionlanguages1
            obj["lastName"] = data.data.travelllerDetails[i].lastName;
            obj["premium"] = ""
            obj["insuredId"] = data.data.travelllerDetails[i].insuredId;

            obj["question"] =
              [
                { question: "" },
                { question: "" },
                { question: "" },
                { question: "" }
              ]
            obj["quetionId"] =
              [
                { quetionId: "" },
                { quetionId: "" },
                { quetionId: "" },
                { quetionId: "" }
              ]
            obj["ans"] =
              [
                { ans: "" },
                { ans: "" },
                { ans: "" },
                { ans: "" }
              ]
            obj["answer"] = [
              { answer: false },
              { answer: false },
              { answer: false },
              { answer: false }
            ]
            obj["quetionAnswerId"] = [
              { quetionAnswerId: "" },
              { quetionAnswerId: "" },
              { quetionAnswerId: "" },
              { quetionAnswerId: "" }
            ]
            this.travellerInformation.push(obj);
            for (let j = 0; j < data.data.travelllerDetails[i].questionsansers.length; j++) {
              this.travellerInformation[i].question[j].question = data.data.travelllerDetails[i].questionsansers[j].question;
              this.travellerInformation[i].quetionId[j].quetionId = data.data.travelllerDetails[i].questionsansers[j].quetionId;
              this.travellerInformation[i].ans[j].ans = data.data.travelllerDetails[i].questionsansers[j].answer;
              this.travellerInformation[i].answer[j].answer = data.data.travelllerDetails[i].questionsansers[j].answer;
              this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.travelllerDetails[i].questionsansers[j].quetionAnswerId;
            }
          }
        }
        this.step4headerclick = true
        if (this.intStudPlanChecked == true || this.intStudPlanChecked1 == true || this.intStudPlanChecked2 == true) {
          this.showQuestionnaireQue = false;
          this.showDeclarationQuestionnaire = false;
          this.showChooseQuote = false;
          this.showIntStudPlan = true;
          this.showIntStudPlanStep1 = false;
          this.showIntStudPlanPlanOption = false;
          this.showQuestionnaire = false;
          this.showQuestionnaireQue = false;
          this.showContactInfo = false;
          this.showPayment = true;
          this.showPaymentsDetails = false;
        }
        if (this.studAccidentIncChecked == true) {
          this.showQuestionnaireQue = false;
          this.showDeclarationQuestionnaire = false;
          this.showChooseQuote = false;
          this.showIntStudPlan = true;
          this.showIntStudPlanStep1 = false;
          this.showIntStudPlanPlanOption = false;
          this.showQuestionnaire = false;
          this.showQuestionnaireQue = false;
          this.showContactInfo = false;
          this.showPayment = true;
          this.showPaymentsDetails = false;
        }
        else {
          if (this.showSaveQuotesVal == "true") {
            this.showQuestionnaireQue = false;
            this.showDeclarationQuestionnaire = false;
            this.showChooseQuote = false;
            this.showIntStudPlan = true;
            this.showIntStudPlanStep1 = false;
            this.showIntStudPlanPlanOption = false;
            this.showQuestionnaire = false;
            this.showQuestionnaireQue = false;
            this.showContactInfo = false;
            this.showPayment = true;
            this.showPaymentsDetails = false;
          }
        }

        localStorage.removeItem('selectedQuestionprovince1');
        localStorage.removeItem('selectedQuestionlanguages1');

      }, error => {
        {
          if (error.status == 400) {
          }
        }
      }, () => { });
    }

  }

  saveQuotesPopup2: boolean = false;
  openQuotePopUp2() {
    this.saveQuotesPopup2 = true;
  }
  quoteNameErrorRemove2() {
    this.quoteNameFlag = false;
  }
  savedQuotePolicyInsuredArray: any = []
  onSaveQuote3() {
    var flag = true;
    this.expiryDateSelected = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
    this.startDateSelected = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    if (!this.quoteName) { this.quoteNameFlag = true; flag = false } else { this.quoteNameFlag = false; flag = true }
    this.saveQuotetravellerInfo = []
    for (let i = 0; i < this.travellerInfo.length; i++) {
      var obj = {};
      obj["dateOfBirth"] = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd")
      obj["age"] = this.travellerInfo[i].age;
      obj["arrivalDateOfCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
      obj["waitPeroid"] = this.travellerInfo[i].waitPeroid;
      obj["eligable"] = true,
        this.saveQuotetravellerInfo.push(obj);
    }
    var premiumAmount2 = this.selectedPlanPrice;
    while (premiumAmount2.charAt(0) === '$') {
      premiumAmount2 = premiumAmount2.substring(1);
    }

    premiumAmount2 = premiumAmount2.replace(/,/g, "");
    this.amount = premiumAmount2
    this.SavedQuotetravellerDetailsToSend = []
    for (let i = 0; i < this.travellerInformation.length; i++) {

      if (this.travellerInformation[i].notEligibleFlag == false) {
        var obj = {}
        obj["age"] = this.travellerInformation[i].age;
        obj["arrivalDateInCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
        obj["arrivalDateOfCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
        obj["country"] = this.travellerInformation[i].homeCountry;
        obj["dateOfBirth"] = this.travellerInformation[i].dateOfBirth;
        obj["dayTimePhone"] = ""
        obj["deductableOptionId"] = ""
        obj["departureCity"] = this.travellerInformation[i].homeCountry;
        obj["eligable"] = "true"
        obj["emailAddress"] = ""
        obj["firstName"] = this.travellerInformation[i].firstName;
        obj["insitute"] = this.travellerInformation[i].insitute
        obj["language"] = this.selectedQuestionlanguages1
        obj["lastName"] = this.travellerInformation[i].lastName;
        obj["premium"] = this.amount;
        obj["insuredId"] = this.travellerInformation[i].insuredId;

        obj["questionsansers"] =
          // this.questionAnsArray

          [
            {
              "answer": this.travellerInformation[i].ans[0].ans,
              "question": this.travellerInformation[i].question[0].question,
              "quetionId": this.travellerInformation[i].quetionId[0].quetionId,
              "quetionAnswerId": "",
            },
            {
              "answer": this.travellerInformation[i].ans[1].ans,
              "question": this.travellerInformation[i].question[1].question,
              "quetionId": this.travellerInformation[i].quetionId[1].quetionId,
              "quetionAnswerId": "",
            },
            {
              "answer": this.travellerInformation[i].ans[2].ans,
              "question": this.travellerInformation[i].question[2].question,
              "quetionId": this.travellerInformation[i].quetionId[2].quetionId,
              "quetionAnswerId": "",
            },
            {
              "answer": this.travellerInformation[i].ans[3].ans,
              "question": this.travellerInformation[i].question[3].question,
              "quetionId": this.travellerInformation[i].quetionId[3].quetionId,
              "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId,
            }
          ]
        obj["tripCost"] = ""
        obj["waitPeroid"] = this.travellerInformation[i].waitPeroid;
        this.SavedQuotetravellerDetailsToSend.push(obj)

        //  if(this.travellerInformation[i].quetionAnswerId.length>0){
        //  if(this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId){
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[0].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId
        // }else{
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[0].quetionAnswerId=""
        // }
        // if(this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId){
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[1].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId
        // }else{
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[1].quetionAnswerId=""
        // }
        // if(this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId){
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[2].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId
        // }else{
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[2].quetionAnswerId=""
        // }
        // if(this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId){
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[3].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId
        // }else{
        //   this.SavedQuotetravellerDetailsToSend[i].questionsansers[3].quetionAnswerId=""
        // }
        // }
      }
    }
    if (this.selectedPlanSend.length < 1) {
      this.selectedPlanSend = null
    }

    if (flag == true) {
      try {
        if (this.NonResidentCountry.displayName) {
          this.NonResidentCountry = this.NonResidentCountry.displayName
        } else {
          this.NonResidentCountry = this.NonResidentCountry
        }
      }
      catch {

      }
      const request =
      {
        "policyId": this.savedQuotesID,
        "agentId": this.agentId,
        "declaration": true,
        "deductableOptions": [
          {
            "amount": 0,
            "createdAt": "2022-04-27T05:08:15.125Z",
            "createdBy": "",
            "id": 0,
            "lastModifiedBy": "",
            "option": "",
            "reduceAmount": 0,
            "updatedAt": "2022-04-27T05:08:15.125Z"
          }
        ],
        "language": this.selectedQuestionlanguages1,
        "noOfDays": this.calculatedDays,
        "optionalInformation": {
          "agentNote": this.comment,
          "beneficiary": this.beneficiary,
          "comment": this.comment
        },
        "paymentInformation": {
          "amount": this.amount,
          "cardNumber": this.cardNoToSend,
          "cardType": this.cardType,
          "cvv": "",
          "expiryDate": this.expDate1ToSend + this.expDateYearToSend
        },

        "primaryAddress": {
          "address1": this.address1,
          "address2": this.address2,
          "city": this.City,
          "postalCode": this.PostalCode,
          "province": this.Province
        },
        "quoteDescriptions": this.quoteDescriptions,
        "quoteName": this.quoteName,
        "isSameAddress": this.purchaserAddressSame,
        "questionsansers": this.questionAnsArray,
        "residentOf": this.selectedQuestionprovince1,
        "returnDate": this.expiryDateSelected,
        "secondaryAddress": {
          "address1": "",
          "address2": "",
          "city": "",
          "postalCode": "",
          "province": ""
        },
        "selectedPlan": this.selectedPlanSend,
        "startDate": this.startDateSelected,
        "travellerInformation": this.saveQuotetravellerInfo,
        "travelllerDetails": this.SavedQuotetravellerDetailsToSend,
        "visitorsToCanada": this.selectedQuestionAns1,
        "purchaserInformation": {
          "country": this.NonResidentCountry,
          "emailAddress": this.purchaseEmail,
          "firstName": this.purchaserFirstName,
          "language": this.selectedQuestionlanguages1,
          "lastName": this.purchaserLastName,
          "phoneNumber1": this.purchasePhone1,
          "phoneNumber2": this.purchasePhone2,
          "postalCode": this.purchasePostalCode,
          "province": this.purchaseProvince,
          "purchaserAddress": {
            "country": this.NonResidentCountry,
            "address1": this.purchaserAddress1,
            "address2": this.purchaserAddress2,
            "city": this.purchaseCity,
            "postalCode": this.purchasePostalCode,
            "province": this.purchaseProvince
          }
        }
      }
      if (this.showSendSaveQuoteEmail == false) {
        this.base.callPostService(this.config.saveQuote, request).subscribe((data: any) => {
          if (data.status == true) {
            this.quoteNameFlag = false;
            this.saveQuotesPopup = false;
            this.saveQuotesPopup1 = false;
            this.saveQuotesPopup2 = false;
            // this.quoteName="";
            // this.quoteDescriptions=""
            this.savedQuotesID = data.data.id;
            this.savedQuoteEmailPlanName = data.data.planName;
            this.quoteName = data.data.quoteName
            this.quoteDescriptions = data.data.quoteDescription
            this.travellerInformation = []
            for (let i = 0; i < data.data.policyInsureds.length; i++) {
              var obj = {}
              obj["age"] = data.data.policyInsureds[i].age
              obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada
              obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth
              obj["waitPeroid"] = data.data.policyInsureds[i].waitPeroid
              obj["notEligibleFlag"] = false
              obj["checkDeclaration"] = false
              obj["age"] = data.data.policyInsureds[i].age
              obj["arrivalDateInCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
              obj["homeCountry"] = data.data.policyInsureds[i].homeCountry;
              obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = data.data.policyInsureds[i].homeCountry;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = data.data.policyInsureds[i].firstName;
              obj["insitute"] = data.data.policyInsureds[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = data.data.policyInsureds[i].lastName;
              obj["premium"] = ""
              obj["insuredId"] = data.data.policyInsureds[i].id;

              obj["question"] =
                [
                  { question: "" },
                  { question: "" },
                  { question: "" },
                  { question: "" }
                ]
              obj["quetionId"] =
                [
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" }
                ]
              obj["ans"] =
                [
                  { ans: "" },
                  { ans: "" },
                  { ans: "" },
                  { ans: "" }
                ]
              obj["answer"] = [
                { answer: false },
                { answer: false },
                { answer: false },
                { answer: false }
              ]
              obj["quetionAnswerId"] = [
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" }
              ]
              this.travellerInformation.push(obj);
              for (let j = 0; j < data.data.policyInsureds[i].policyQuestionAnswers.length; j++) {
                if (data.data.policyInsureds[i].policyQuestionAnswers[j].question != null) {
                  this.travellerInformation[i].question[j].question = data.data.policyInsureds[i].policyQuestionAnswers[j].question.question;
                  this.travellerInformation[i].quetionId[j].quetionId = data.data.policyInsureds[i].policyQuestionAnswers[j].question.id;
                }
                this.travellerInformation[i].ans[j].ans = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].answer[j].answer = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.policyInsureds[i].policyQuestionAnswers[j].id;

              }
            }
            this.savedQuotePolicyInsuredArray = data.data.policyInsureds;
            if (this.showPaymentLinkPop == true) {
              this.sendPaymentLink();
            } else {
              Swal.fire('', "Quote information saved.", 'success');
            }
          } else {
            Swal.fire('', data.message, 'error');
          }
        }, error => {
          {
            if (error.status == 400) {
            }
          }
        }, () => { });
      } else {
        this.base.callPostService(this.config.savePolicyQuoteAndEmail, request).subscribe((data: any) => {
          if (data.status == true) {
            this.savedEmailTemplate = data.data.emailTemplate;
            this.savedEmailTemplateName = data.data.emailName;
            this.savedQuotesID = data.data.policy.id;
            this.savedQuoteEmailPlanName = data.data.policy.planName;
            this.travellerInformation = []
            for (let i = 0; i < data.data.policy.policyInsureds.length; i++) {
              var obj = {}
              obj["age"] = data.data.policy.policyInsureds[i].age
              obj["arrivalDateOfCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada
              obj["dateOfBirth"] = data.data.policy.policyInsureds[i].dateOfBirth
              obj["waitPeroid"] = data.data.policy.policyInsureds[i].waitPeroid
              obj["notEligibleFlag"] = false
              obj["checkDeclaration"] = false
              obj["age"] = data.data.policy.policyInsureds[i].age
              obj["arrivalDateInCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada;
              obj["homeCountry"] = data.data.policy.policyInsureds[i].homeCountry;
              obj["dateOfBirth"] = data.data.policy.policyInsureds[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = data.data.policy.policyInsureds[i].homeCountry;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = data.data.policy.policyInsureds[i].firstName;
              obj["insitute"] = data.data.policy.policyInsureds[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = data.data.policy.policyInsureds[i].lastName;
              obj["premium"] = ""
              obj["insuredId"] = data.data.policy.policyInsureds[i].id;

              obj["question"] =
                [
                  { question: "" },
                  { question: "" },
                  { question: "" },
                  { question: "" }
                ]
              obj["quetionId"] =
                [
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" }
                ]
              obj["ans"] =
                [
                  { ans: "" },
                  { ans: "" },
                  { ans: "" },
                  { ans: "" }
                ]
              obj["answer"] = [
                { answer: false },
                { answer: false },
                { answer: false },
                { answer: false }
              ]
              obj["quetionAnswerId"] = [
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" }
              ]
              this.travellerInformation.push(obj);
              for (let j = 0; j < data.data.policy.policyInsureds[i].policyQuestionAnswers.length; j++) {
                if (data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question != null) {
                  this.travellerInformation[i].question[j].question = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question.question;
                  this.travellerInformation[i].quetionId[j].quetionId = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question.id;
                }
                this.travellerInformation[i].ans[j].ans = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].answer[j].answer = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].id;

              }
            }
            this.sendEmailOfSavedQuotes();
            // Swal.fire('',"Quote information saved.",'success');
          } else {
            Swal.fire('', data.message, 'error');
          }
        }, error => {

        }, () => { });
      }
    }

  }

  onClickPaymentNext() {
    window.scrollTo(0, 0);
    this.showQuestionnaireQue = false;
    this.showDeclarationQuestionnaire = false;
    this.showChooseQuote = false;
    this.showIntStudPlan = true;
    this.showIntStudPlanStep1 = false;
    this.showIntStudPlanPlanOption = false;
    this.showQuestionnaire = false;
    this.showQuestionnaireQue = false;
    this.showContactInfo = false;
    this.showPayment = false;
    this.showPaymentsDetails = true;
  }
  onClickFinalizePayment() {
    this.finalizePaymentPopup = true
  }
  sendfinalizePaymentEmail() {
    this.finalizePaymentPopup = false;
    Swal.fire('', "Successfully Sent", 'success')
    window.scrollTo(0, 0);
    this.showChooseQuote = true;
    this.showQuestionnaireQue = false;
    this.showDeclarationQuestionnaire = false;
    this.showIntStudPlan = false;
    this.showIntStudPlanStep1 = false;
    this.showIntStudPlanPlanOption = false;
    this.showQuestionnaire = false;
    this.showQuestionnaireQue = false;
    this.showContactInfo = false;
    this.showPayment = false;
    this.showPaymentsDetails = false;
    this.showPaymentsDetailsStudAccidentInsure = false;
    this.showStudAccidentInsure = false;
  }
  gotBackToIntStudPlan() {

    var flag = true
    if (this.step3headerclick == true) {
      for (let i = 0; i < this.travellerInformation.length; i++) {
        try { this.travellerInformation[i].firstName = this.travellerInformation[i].firstName.trim() } catch { }
        try { this.travellerInformation[i].lastName = this.travellerInformation[i].lastName.trim() } catch { }
        try { this.travellerInformation[0].insitute = this.travellerInformation[0].insitute.trim() } catch { }
        try { this.travellerInformation[0].homeCountry = this.travellerInformation[0].homeCountry.trim() } catch { }
        if (this.travellerInformation[i].firstName == "" || this.travellerInformation[i].firstName == null) {
          this.firstNameFlag = true; flag = false
          this.travellerInformation[i].firstNameFlag = true
        }
        else {
          this.firstNameFlag = false;
          this.travellerInformation[i].firstNameFlag = false
        }
        if (this.travellerInformation[i].lastName == "" || this.travellerInformation[i].lastName == null) {
          this.lastNameFlag = true; flag = false
          this.travellerInformation[i].lastNameFlag = true
        }
        else {
          this.lastNameFlag = false;
          this.travellerInformation[i].lastNameFlag = false
        }
        if (this.travellerInformation[0].insitute == "" || this.travellerInformation[0].insitute == null) {
          this.InstituteFlag = true; flag = false
          this.travellerInformation[0].InstituteFlag = true
        }
        else {
          this.InstituteFlag = false;
          this.travellerInformation[0].InstituteFlag = false
        }
        if ((this.travellerInformation[0].homeCountry == "" || this.travellerInformation[0].homeCountry == null) && this.NonResidentSelected == false) {
          this.CountryFlag = true; flag = false
          this.travellerInformation[0].CountryFlag = true
        }
        else {
          this.CountryFlag = false;
          this.travellerInformation[0].CountryFlag = false
        }
      }
    }
    if (flag == true) {
      window.scrollTo(0, 0);
      this.showQuestionnaireQue = false;
      this.showDeclarationQuestionnaire = false;
      this.showChooseQuote = false;
      this.showIntStudPlan = true;
      this.showIntStudPlanStep1 = true;
      this.showIntStudPlanPlanOption = false;
      this.showQuestionnaire = false;
      this.showQuestionnaireQue = false;
      this.showContactInfo = false;
      this.showPayment = false;
      this.showPaymentsDetails = false;
    }
  }
  gotBackToIntStudPlanOption() {

    window.scrollTo(0, 0);
    this.showQuestionnaireQue = false;
    this.showDeclarationQuestionnaire = false;
    this.showChooseQuote = false;
    this.showIntStudPlan = true;
    this.showIntStudPlanStep1 = false;
    this.showIntStudPlanPlanOption = true;
    this.showQuestionnaire = false;
    this.showQuestionnaireQue = false;
    this.showContactInfo = false;
    this.showPayment = false;
    this.showPaymentsDetails = false;
  }
  gotBackToQuestionnaire() {

    // window.scrollTo(0,0);
    // this.showQuestionnaireQue=false;
    // this.showDeclarationQuestionnaire=false;
    // this.showChooseQuote=false;
    // this.showIntStudPlan=true;
    // this.showIntStudPlanStep1=false;
    // this.showIntStudPlanPlanOption=false;
    // this.showQuestionnaire=true;
    // this.showQuestionnaireQue=true;
    // this.showContactInfo=false;
    // this.showPayment=false;
    // this.showPaymentsDetails=false;
    var flag = true
    console.log(this.expiryDate)
    if (this.errorFlagNoDays == true || this.errorNegative == true || this.exceedNoOfDays == true || this.exceedNoOfDays1 == true || this.ageErrorCross == true || this.startDateFlagValid == true || this.ArrivalDateFlagValid == true) { flag = false }
    if (!this.expiryDate) { this.expiryDateFlag = true; flag = false } else { this.expiryDateFlag = false; this.expiryDateFlagValid = false }
    if (!this.startDate) { this.startDateFlag = true; flag = false } else { this.startDateFlag = false; this.startDateFlagValid = false }
    for (let k = 0; k < this.travellerInfo.length; k++) {
      if (this.travellerInfo[k].arrivalDateOfCanada == "" || this.travellerInfo[k].arrivalDateOfCanada == null) {
        this.arrivalDateCanadaFlag = true; flag = false
        this.travellerInfo[k].arrivalDateCanadaFlag = true
      }
      else {
        this.arrivalDateCanadaFlag = false;
        this.travellerInfo[k].arrivalDateCanadaFlag = false
      }
      if (this.travellerInfo[k].dateOfBirth == "" || this.travellerInfo[k].dateOfBirth == null || this.travellerInfo[k].ageErrorCross == true) {
        this.dobFlag = true; flag = false
        this.travellerInfo[k].dobFlag = true
      }
      else {
        this.dobFlag = false;
        this.travellerInfo[k].dobFlag = false
      }
    }
    if (this.step3headerclick == true) {
      for (let i = 0; i < this.travellerInformation.length; i++) {
        try { this.travellerInformation[i].firstName = this.travellerInformation[i].firstName.trim() } catch { }
        try { this.travellerInformation[i].lastName = this.travellerInformation[i].lastName.trim() } catch { }
        try { this.travellerInformation[0].insitute = this.travellerInformation[0].insitute.trim() } catch { }
        try { this.travellerInformation[0].homeCountry = this.travellerInformation[0].homeCountry.trim() } catch { }
        if (this.travellerInformation[i].firstName == "" || this.travellerInformation[i].firstName == null) {
          this.firstNameFlag = true; flag = false
          this.travellerInformation[i].firstNameFlag = true
        }
        else {
          this.firstNameFlag = false;
          this.travellerInformation[i].firstNameFlag = false
        }
        if (this.travellerInformation[i].lastName == "" || this.travellerInformation[i].lastName == null) {
          this.lastNameFlag = true; flag = false
          this.travellerInformation[i].lastNameFlag = true
        }
        else {
          this.lastNameFlag = false;
          this.travellerInformation[i].lastNameFlag = false
        }
        if (this.travellerInformation[0].insitute == "" || this.travellerInformation[0].insitute == null) {
          this.InstituteFlag = true; flag = false
          this.travellerInformation[0].InstituteFlag = true
        }
        else {
          this.InstituteFlag = false;
          this.travellerInformation[0].InstituteFlag = false
        }
        if ((this.travellerInformation[0].homeCountry == "" || this.travellerInformation[0].homeCountry == null) && this.NonResidentSelected == false) {
          this.CountryFlag = true; flag = false
          this.travellerInformation[0].CountryFlag = true
        }
        else {
          this.CountryFlag = false;
          this.travellerInformation[0].CountryFlag = false
        }
      }
    }

    if (flag == true) {
      window.scrollTo(0, 0);
      this.showChooseQuote = false;
      this.showIntStudPlan = true;
      this.showIntStudPlanStep1 = false;
      this.showIntStudPlanPlanOption = true;
      this.showQuestionnaire = false;
      this.showContactInfo = false;
      this.showPayment = false;
      this.showPaymentsDetails = false;
      if (this.showSaveQuotesVal == "true") {
        this.declarationErrorFlag = true
      }
    }
  }
  gotBackToContactInfo() {

    var flag = true
    if (this.errorFlagNoDays == true || this.errorNegative == true || this.exceedNoOfDays == true || this.exceedNoOfDays1 == true || this.ageErrorCross == true || this.startDateFlagValid == true || this.ArrivalDateFlagValid == true) { flag = false }
    if (!this.expiryDate) { this.expiryDateFlag = true; flag = false } else { this.expiryDateFlag = false; this.expiryDateFlagValid = false }
    if (!this.startDate) { this.startDateFlag = true; flag = false } else { this.startDateFlag = false; this.startDateFlagValid = false }
    for (let k = 0; k < this.travellerInfo.length; k++) {
      if (this.travellerInfo[k].arrivalDateOfCanada == "" || this.travellerInfo[k].arrivalDateOfCanada == null) {
        this.arrivalDateCanadaFlag = true; flag = false
        this.travellerInfo[k].arrivalDateCanadaFlag = true
      }
      else {
        this.arrivalDateCanadaFlag = false;
        this.travellerInfo[k].arrivalDateCanadaFlag = false
      }
      if (this.travellerInfo[k].dateOfBirth == "" || this.travellerInfo[k].dateOfBirth == null || this.travellerInfo[k].ageErrorCross == true) {
        this.dobFlag = true; flag = false
        this.travellerInfo[k].dobFlag = true
      }
      else {
        this.dobFlag = false;
        this.travellerInfo[k].dobFlag = false
      }
    }
    for (let i = 0; i < this.travellerInformation.length; i++) {
      try { this.travellerInformation[i].firstName = this.travellerInformation[i].firstName.trim() } catch { }
      try { this.travellerInformation[i].lastName = this.travellerInformation[i].lastName.trim() } catch { }
      try { this.travellerInformation[0].insitute = this.travellerInformation[0].insitute.trim() } catch { }
      try { this.travellerInformation[0].homeCountry = this.travellerInformation[0].homeCountry.trim() } catch { }
      if (this.travellerInformation[i].firstName == "" || this.travellerInformation[i].firstName == null) {
        this.firstNameFlag = true; flag = false
        this.travellerInformation[i].firstNameFlag = true
      }
      else {
        this.firstNameFlag = false;
        this.travellerInformation[i].firstNameFlag = false
      }
      if (this.travellerInformation[i].lastName == "" || this.travellerInformation[i].lastName == null) {
        this.lastNameFlag = true; flag = false
        this.travellerInformation[i].lastNameFlag = true
      }
      else {
        this.lastNameFlag = false;
        this.travellerInformation[i].lastNameFlag = false
      }
      if (this.travellerInformation[0].insitute == "" || this.travellerInformation[0].insitute == null) {
        this.InstituteFlag = true; flag = false
        this.travellerInformation[0].InstituteFlag = true
      }
      else {
        this.InstituteFlag = false;
        this.travellerInformation[0].InstituteFlag = false
      }
      if ((this.travellerInformation[0].homeCountry == "" || this.travellerInformation[0].homeCountry == null) && this.NonResidentSelected == false) {
        this.CountryFlag = true; flag = false
        this.travellerInformation[0].CountryFlag = true
      }
      else {
        this.CountryFlag = false;
        this.travellerInformation[0].CountryFlag = false
      }
    }

    if (flag == true) {
      window.scrollTo(0, 0);
      this.showQuestionnaireQue = false;
      this.showDeclarationQuestionnaire = false;
      this.showChooseQuote = false;
      this.showIntStudPlan = true;
      this.showIntStudPlanStep1 = false;
      this.showIntStudPlanPlanOption = false;
      this.showQuestionnaire = false;
      this.showQuestionnaireQue = false;
      this.showContactInfo = true;
      this.showPayment = false;
      this.showPaymentsDetails = false;
    }
  }
  gobackToChooseQuote() {

    window.scrollTo(0, 0);
    this.showChooseQuote = true;
    this.showQuestionnaireQue = false;
    this.showDeclarationQuestionnaire = false;
    this.showIntStudPlan = false;
    this.showIntStudPlanStep1 = false;
    this.showIntStudPlanPlanOption = false;
    this.showQuestionnaire = false;
    this.showQuestionnaireQue = false;
    this.showContactInfo = false;
    this.showPayment = false;
    this.showPaymentsDetails = false;
    this.showSendSaveQuoteEmail = false;
  }
  gotBackToPayment() {

    this.showQuestionnaireQue = false;
    this.showDeclarationQuestionnaire = false;
    this.showChooseQuote = false;
    this.showIntStudPlan = true;
    this.showIntStudPlanStep1 = false;
    this.showIntStudPlanPlanOption = false;
    this.showQuestionnaire = false;
    this.showQuestionnaireQue = false;
    this.showContactInfo = false;
    this.showPayment = true;
    this.showPaymentsDetails = false;
  }
  onClickPayInFull() {
    this.checkPayInFull = true;
    this.checkPayInMonthly = false
    this.showPayInMonthlyPopup = false;
  }
  onClickPayMonthaly() {
    this.checkPayInMonthly = true;
    this.checkPayInFull = false;
  }
  showPayInMonthlyPopup: boolean = false;
  onClickMonthlyPayment() {
    this.showPayInMonthlyPopup = true;
  }
  showStudAccidentInsure: boolean = false;
  showStudAccidentInsureStep1: boolean = false;
  showStudAccidentInsurePlanOption: boolean = false;
  showContactInfoStudAccidentInsure: boolean = false;
  showPaymentStudAccidentInsure: boolean = false;
  showPaymentsDetailsStudAccidentInsure: boolean = false;
  onClickStudAccidentInsureStep1() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = true;
    this.showContactInfoStudAccidentInsure = false;
  }
  onClickPurchaseStudAccidentInsure() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = false;
    this.showContactInfoStudAccidentInsure = true;
  }
  onClickContactInfoNextStudAccidentInsure() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = false;
    this.showContactInfoStudAccidentInsure = false;
    this.showPaymentStudAccidentInsure = true;
    this.showPaymentsDetailsStudAccidentInsure = false;
  }
  onClickPaymentNextStudAccidentInsure() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = false;
    this.showContactInfoStudAccidentInsure = false;
    this.showPaymentStudAccidentInsure = false;
    this.showPaymentsDetailsStudAccidentInsure = true;
  }
  gobackToChooseQuoteFromSAI() {
    window.scrollTo(0, 0);
    this.showChooseQuote = true;
    this.showStudAccidentInsure = false;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = false;
    this.showContactInfoStudAccidentInsure = false;
    this.showPaymentStudAccidentInsure = false;
    this.showPaymentsDetailsStudAccidentInsure = false;
  }
  gobackToSAIStep1() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = true;
    this.showStudAccidentInsurePlanOption = false;
    this.showContactInfoStudAccidentInsure = false;
    this.showPaymentStudAccidentInsure = false;
    this.showPaymentsDetailsStudAccidentInsure = false;
  }
  showPaymentpage() {
    var flag = true
    if (this.errorFlagNoDays == true || this.errorNegative == true || this.exceedNoOfDays == true || this.exceedNoOfDays1 == true || this.ageErrorCross == true || this.startDateFlagValid == true || this.ArrivalDateFlagValid == true) { flag = false }
    if (!this.expiryDate) { this.expiryDateFlag = true; flag = false } else { this.expiryDateFlag = false; this.expiryDateFlagValid = false }
    if (!this.startDate) { this.startDateFlag = true; flag = false } else { this.startDateFlag = false; this.startDateFlagValid = false }
    for (let k = 0; k < this.travellerInfo.length; k++) {
      if (this.travellerInfo[k].arrivalDateOfCanada == "" || this.travellerInfo[k].arrivalDateOfCanada == null) {
        this.arrivalDateCanadaFlag = true; flag = false
        this.travellerInfo[k].arrivalDateCanadaFlag = true
      }
      else {
        this.arrivalDateCanadaFlag = false;
        this.travellerInfo[k].arrivalDateCanadaFlag = false
      }
      if (this.travellerInfo[k].dateOfBirth == "" || this.travellerInfo[k].dateOfBirth == null || this.travellerInfo[k].ageErrorCross == true) {
        this.dobFlag = true; flag = false
        this.travellerInfo[k].dobFlag = true
      }
      else {
        this.dobFlag = false;
        this.travellerInfo[k].dobFlag = false
      }
    }
    for (let i = 0; i < this.travellerInformation.length; i++) {
      try { this.travellerInformation[i].firstName = this.travellerInformation[i].firstName.trim() } catch { }
      try { this.travellerInformation[i].lastName = this.travellerInformation[i].lastName.trim() } catch { }
      try { this.travellerInformation[0].insitute = this.travellerInformation[0].insitute.trim() } catch { }
      try { this.travellerInformation[0].homeCountry = this.travellerInformation[0].homeCountry.trim() } catch { }
      if (this.travellerInformation[i].firstName == "" || this.travellerInformation[i].firstName == null) {
        this.firstNameFlag = true; flag = false
        this.travellerInformation[i].firstNameFlag = true
      }
      else {
        this.firstNameFlag = false;
        this.travellerInformation[i].firstNameFlag = false
      }
      if (this.travellerInformation[i].lastName == "" || this.travellerInformation[i].lastName == null) {
        this.lastNameFlag = true; flag = false
        this.travellerInformation[i].lastNameFlag = true
      }
      else {
        this.lastNameFlag = false;
        this.travellerInformation[i].lastNameFlag = false
      }
      if (this.travellerInformation[0].insitute == "" || this.travellerInformation[0].insitute == null) {
        this.InstituteFlag = true; flag = false
        this.travellerInformation[0].InstituteFlag = true
      }
      else {
        this.InstituteFlag = false;
        this.travellerInformation[0].InstituteFlag = false
      }
      if ((this.travellerInformation[0].homeCountry == "" || this.travellerInformation[0].homeCountry == null) && this.NonResidentSelected == false) {
        this.CountryFlag = true; flag = false
        this.travellerInformation[0].CountryFlag = true
      }
      else {
        this.CountryFlag = false;
        this.travellerInformation[0].CountryFlag = false
      }
    }

    if (flag == true) {
      this.showQuestionnaireQue = false;
      this.showDeclarationQuestionnaire = false;
      this.showChooseQuote = false;
      this.showIntStudPlan = true;
      this.showIntStudPlanStep1 = false;
      this.showIntStudPlanPlanOption = false;
      this.showQuestionnaire = false;
      this.showQuestionnaireQue = false;
      this.showContactInfo = false;
      this.showPayment = true;
      this.showPaymentsDetails = false;
    }
  }
  gobackToSAIPlanOption() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = true;
    this.showContactInfoStudAccidentInsure = false;
    this.showPaymentStudAccidentInsure = false;
    this.showPaymentsDetailsStudAccidentInsure = false;
  }
  gotBackToContactInfoSAI() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = false;
    this.showContactInfoStudAccidentInsure = true;
    this.showPaymentStudAccidentInsure = false;
    this.showPaymentsDetailsStudAccidentInsure = false;
  }
  gotBackToPaymentSAI() {
    window.scrollTo(0, 0);
    this.showChooseQuote = false;
    this.showStudAccidentInsure = true;
    this.showStudAccidentInsureStep1 = false;
    this.showStudAccidentInsurePlanOption = false;
    this.showContactInfoStudAccidentInsure = false;
    this.showPaymentStudAccidentInsure = true;
    this.showPaymentsDetailsStudAccidentInsure = false;
  }

  //-------------------------------------------ISP-------------------------------------------------------
  popUpResidentFlag: boolean = false;
  selectedQuestionprovince1: any;
  NonResidentCountry: any;
  selectedQuestionlanguages1: any;
  minDate = new Date();

  minDate1 = new Date();
  minDateArrival = new Date();
  saveQuoteDate = new Date();
  shownew: boolean = false
  popUpResidentFlag1: boolean = false
  validateResident(data) {
    if (data == "Non-Resident of Canada") {
      this.shownew = true
      this.NonResidentSelected = true
    }
    else {
      this.shownew = false
      this.NonResidentSelected = false
    }
    if (data != null) {
      this.popUpResidentFlag = true;
    }
  }
  validateResident1(data) {

    if (data != null) {
      this.popUpResidentFlag1 = true;
      this.purchaserNonResidentCountry = this.NonResidentCountry
      this.purchaserNonResidentCountryName = this.NonResidentCountry.displayName
    }
    else {
      this.purchaserNonResidentCountry = null
    }
  }

  popUpLanguageFlag: boolean = false;
  validateLanguage(data) {
    if (data != null) {
      this.popUpLanguageFlag = true;
    }
  }

  provincesArray: any[] = [];
  provincesArray1: any[] = [];
  getAllProvinces() {
    this.user.getProvincesBToB().subscribe((data: any) => {
      this.provincesArray = data.data;
    }, error => {
      {
      }
    }, () => { });
  }
  getAllProvinces1() {

    this.user.getProvinceByAgentId(this.agentId).subscribe((data: any) => {
      if (data.success !== false) {
        this.provincesArray1 = data.data;
        this.provincesArray1 = this.provincesArray1.sort((a, b) => (a.provinceName < b.provinceName) ? -1 : 1);
      }
      sessionStorage.removeItem('hideQuotePurchase');
      if (data.status == false || data.success == false) {
        sessionStorage.setItem('hideQuotePurchase', 'true');
        this.hideQuotePurchase = sessionStorage.getItem('hideQuotePurchase')
        this.router.navigateByUrl('/dashboard/sales-home');
      }

    }, error => {
      {
      }
    }, () => { });
  }

  languagesArray: any = [];
  getAllLanguages() {
    this.user.getLanguageBToB().subscribe((data: any) => {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i] == "English") {
          this.languagesArray.push(data.data[i]);
        }
      }
    }, error => {
      {
      }
    }, () => { });
  }

  startDateFlag: boolean = false;
  startDate: any;
  startDateTemp: any;
  callStartDateFunction(event) {

    if (this.startDate !== null) {
      for (let i = 0; i < this.travellerInfo.length; i++) {
        this.travellerInfo[i].ArrivalDateFlagValid1 = false
      }

      if (this.startDate._d) {
        this.startDate = this.startDate._d;
      }
      console.log("startDate!!", this.startDate)
      if (this.startDate) {
        this.errorFlagNoDays = false;
        this.startDateFlag = false;
        this.startDateFlagValid = false
        var chkDate1 = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
        this.chkDate = new Date();
        this.chkDate = this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
        var maxDate = this.datePipe.transform(this.maxDatestart, "yyyy-MM-dd");
        console.log(this.chkDate)
        console.log(chkDate1)
        if (chkDate1 > maxDate) {
          this.startDateFlagValid = true

        }

        else if (chkDate1 < this.chkDate) {
          this.startDateFlagValid = true

        }
        else {
          this.startDateFlagValid = false
        }
        // this.minDate=this.startDate;
        this.minDateArrival = this.startDate;
        for (let i = 0; i < this.travellerInfo.length; i++) {
          this.travellerInfo[i].arrivalDateOfCanada = null;
          this.travellerInfo[i].waitPeroid = null;
        }
        if (this.expiryDate) {
          const dateTwo = new Date(new Date(this.startDate).setDate(new Date(this.startDate).getDate() + this.calculatedDays));
          this.expiryDate = dateTwo;
          this.errorFlagNoDays = false;
          this.minDateArrival = new Date(this.startDate)
        }
        if (this.calculatedDays) {
          this.callCalculatedDaysFunction()
        }
      }
      for (let i = 0; i < this.travellerInfo.length; i++) {
        if (!this.startDate) {
          this.travellerInfo[i].arrivalDateOfCanada = null;
          this.travellerInfo[i].waitPeroid = null;
        }
      }
    }
    else {
      this.startDateFlagValid = true

    }
  }

  expiryDateFlag: boolean = false;
  expiryDate: any;
  calculatedDays: any;
  callExpiryDateFunction(event) {

    // this.startDateFlag=false;
    if (this.expiryDate !== null) {
      if (this.expiryDate._d) {
        this.expiryDate = this.expiryDate._d;
      }
      console.log("ExpiryDate", this.expiryDate)
      // if(this.calculatedDays<0){
      //   this.errorNegative=true;
      // }else{
      this.errorNegative = false;
      if (this.expiryDate) {
        var Time = new Date(this.expiryDate).getTime() - new Date(this.startDate).getTime();
        var Days = Time / (1000 * 3600 * 24); //Diference in Days
        let a = Math.round(Days)
        this.calculatedDays = a + 1;
        this.expiryDateFlag = false;
        this.expiryDateFlagValid = false
        if (this.calculatedDays < 0) {
          this.errorNegative = true;
        }
        if (this.calculatedDays > 365) {
          this.exceedNoOfDays = true;
        } else {
          this.exceedNoOfDays = false;
        }
        if (this.calculatedDays < 14 && this.calculatedDays > -1) {
          this.exceedNoOfDays1 = true
        } else {
          this.exceedNoOfDays1 = false;
        }
      }
    }
    else {
      if (this.calculatedDays) {
        this.callCalculatedDaysFunction()
      }
      else {
        this.expiryDateFlagValid = true
      }
    }
  }
  travellerInfo: any[] = [];
  addFirstValueTraveller() {
    var obj = {};
    obj["dateOfBirth"] = "";
    obj["age"] = "";
    obj["arrivalDateOfCanada"] = "";
    obj["waitPeroid"] = "";
    this.travellerInfo.push(obj);
    this.numberOFInsured = 1;
  }

  dobFlag: boolean = false;
  ageErrorCross: boolean = false;
  callDateOfBirth(event) {
    //   for(let i=0;i<this.travellerInfo.length;i++){
    //     var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime());
    //     var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    //     this.travellerInfo[i].age=ageCalculate;
    //     if(this.travellerInfo[i].age > 69){
    //       this.ageErrorCross = true;
    //     }else{
    //       this.ageErrorCross = false;
    //     }
    //     this.dobFlag=false;
    //   }
    //   for(let i=0;i<this.travellerInfo.length;i++){
    //     var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime()+1);
    //     var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    //     this.travellerInfo[i].age=ageCalculate;
    //     this.dobFlag=false;
    //     let startDate: string = this.travellerInfo[i].dateOfBirth;
    // let date1: Date = new Date();
    // let date2: Date = new Date(startDate);
    // let timeInMilisec: number = date1.getTime() - date2.getTime();
    // let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
    // console.log(daysBetweenDates)
    //     if(this.travellerInfo[i].age > 69 || daysBetweenDates <31){
    //       // this.firstFormGroup.controls.itemRows.controls[index].ageErrorCross= true;
    //        this.ageErrorCross = true;
    //     }else{
    //       // this.firstFormGroup.controls.itemRows.controls[index].ageErrorCross= false;

    //        this.ageErrorCross = false;
    //     }
    //     }

    this.ageErrorCross = false;
    for (let i = 0; i < this.travellerInfo.length; i++) {
      if (this.travellerInfo[i].dateOfBirth != null) {
        if (this.travellerInfo[i].dateOfBirth._d) {
          this.travellerInfo[i].dateOfBirth = this.travellerInfo[i].dateOfBirth._d;
        }
        console.log("DOB!!", this.travellerInfo[i].dateOfBirth);
        // this.travellerInfo[i].dateOfBirth = this.travellerInfo[i].dateOfBirth._d;
        // console.log("DoB",this.travellerInfo[i].dateOfBirth);
        this.travellerInfo[i].dateOfBirth = new Date(this.travellerInfo[i].dateOfBirth)
        var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime() + 1);
        var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
        // if(ageCalculate!==nu)
        // {
        this.travellerInfo[i].age = ageCalculate;
        if (Number.isNaN(this.travellerInfo[i].age)) {
          this.travellerInfo[i].age = "";
        }
        // }
        // this.travellerInfo[i].dobFlag=false;
        let startDate: string = this.travellerInfo[i].dateOfBirth;
        let date1: Date = new Date();
        let date2: Date = new Date(startDate);
        let timeInMilisec: number = date1.getTime() + 1 - date2.getTime() + 1;
        let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
        console.log(daysBetweenDates)
        if (this.travellerInfo[i].age > 69 || daysBetweenDates < 31) {
          this.travellerInfo[i].ageErrorCross = true
          this.travellerInfo[i].dobFlag = true;
          this.ageErrorCross = true;
        } else {
          this.travellerInfo[i].ageErrorCross = false
          this.travellerInfo[i].dobFlag = false;

        }
      }
      else {
        this.travellerInfo[i].dobFlag = true;
      }
    }
  }

  innerPop: boolean = false;
  selectedQuestionAns1: any;
  currentIndex: any = 0;
  arrivalDateCanadaFlag: boolean = false;
  callArriveCanadaDate(event, index) {

    if (this.startDate) {
      this.travellerInfo[index].ArrivalDateFlagValid1 = false
      for (let i = 0; i < this.travellerInfo.length; i++) {
        if (this.travellerInfo[index].arrivalDateOfCanada != null) {
          if (this.travellerInfo[index].arrivalDateOfCanada._d) {
            this.travellerInfo[index].arrivalDateOfCanada = this.travellerInfo[index].arrivalDateOfCanada._d;
          }

          const date = this.startDate;
          const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const datePipe = new DatePipe('en-US');
          //   if(timezone=="Asia/Calcutta"){
          //     this.datePipe12 = new DatePipe('en-in');
          //  }
          //  else{
          //    this.datePipe12 = new DatePipe('en-US');
          //  }
          console.log(date);
          this.formattedDate = datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss', timezone);
          const date2 = new Date(this.formattedDate);
          const formattedDate4 = date2.toString().substring(0, 24);

          console.log(this.formattedDate);
          console.log(formattedDate4);
          // this.startDate=formattedDate;

          // var e = new Date(this.startDate);
          // this.startDate.setTime( this.startDate.getTime() + this.startDate.getTimezoneOffset()*60*1000 );
          // this.startDate = e;

          this.startDateTemp = new Date(formattedDate4);



          console.log(this.startDateTemp);
          console.log("Arrival Date in canada!!", this.travellerInfo[index].arrivalDateOfCanada);
          // this.travellerInfo[index].arrivalDateOfCanada = this.travellerInfo[index].arrivalDateOfCanada._d;
          if (this.travellerInfo[index].arrivalDateOfCanada) {
            var Time = this.startDateTemp.getTime() + 1 - this.travellerInfo[index].arrivalDateOfCanada.getTime() + 1;
            var Days = Time / (1000 * 3600 * 24); //Diference in Days
            // let a3 = Math.round(Days)
            //  Days=a3;
            // if(Days>=1 && Days <=30){

            var chkDate1 = this.datePipe.transform(this.travellerInfo[index].arrivalDateOfCanada, "yyyy-MM-dd");
            this.chkDate = new Date();
            this.chkDate = this.datePipe.transform(this.startDateTemp, "yyyy-MM-dd");
            console.log(this.chkDate)
            console.log(chkDate1)
            if (chkDate1 > this.chkDate) {

              this.travellerInfo[index].ArrivalDateFlagValid = true
              this.ArrivalDateFlagValid = true
            }
            else {
              this.ArrivalDateFlagValid = false
              this.travellerInfo[index].ArrivalDateFlagValid = false
            }


            if (Days >= 1) {
              this.showarrivalDateInCanadaPopup = true;
              // item.waitPeroid
              // this.travellerInfo[index].waitPeroid="48 Hours - Sickness";
              this.currentIndex = index
            } else {
              // this.showarrivalDateInCanadaPopup=true;
              // item.waitPeroid
              this.travellerInfo[index].waitPeroid = "None";
              this.currentIndex = index
            }
            this.travellerInfo[index].arrivalDateCanadaFlag = false;
          }
          else {
            this.travellerInfo[index].waitPeroid = null
          }
        }
        else {
          this.travellerInfo[index].ArrivalDateFlagValid = true
          this.ArrivalDateFlagValid = true
        }
      }

    }
    else {

      this.travellerInfo[index].ArrivalDateFlagValid = true
      this.travellerInfo[index].ArrivalDateFlagValid1 = true
      this.ArrivalDateFlagValid = true
      // window.alert("Need valid expiry/start date to calculate the wait period of your policy.")
      for (let i = 0; i < this.travellerInfo.length; i++) {
        this.travellerInfo[i].arrivalDateOfCanada = null;
        this.travellerInfo[index].waitPeroid = null
      }
    }


  }
  errorNegative: boolean = false
  exceedNoOfDays: boolean = false
  exceedNoOfDays1: boolean = false
  errorFlagNoDays: boolean = false
  callCalculatedDaysFunction() {
    // if(this.calculatedDays<0){
    //   this.errorNegative=true;
    // }else{
    //   this.errorNegative=false;
    // if(this.startDate){
    // const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + parseInt(this.calculatedDays)));
    // this.expiryDate=dateTwo;
    // }else{
    //   window.alert("Need valid start date before adding no of days.")  
    // }
    // }
    if (this.calculatedDays < 14 && this.calculatedDays > -1) {
      this.exceedNoOfDays1 = true
    } else {
      this.exceedNoOfDays1 = false;
    }
    if (this.calculatedDays > 365) {
      this.exceedNoOfDays = true;

    } else {
      this.exceedNoOfDays = false
      if (this.calculatedDays < 0) {
        this.errorNegative = true;
      } else {
        this.errorNegative = false;
        if (this.startDate) {
          if (this.calculatedDays != 0) {
            const dateTwo = new Date(new Date(this.startDate).setDate(new Date(this.startDate).getDate() + parseInt(this.calculatedDays) - 1));
            this.expiryDate = dateTwo;
            this.expiryDateFlag = false
            this.expiryDateFlagValid = false
          }
          else {
            const dateTwo = new Date(new Date(this.startDate).setDate(new Date(this.startDate).getDate() + parseInt(this.calculatedDays)));
            this.expiryDate = dateTwo;
            this.expiryDateFlag = false
            this.expiryDateFlagValid = false
          }
        } else {
          this.errorFlagNoDays = true;
          // window.alert("Need valid start date before adding no of days.")  
        }
      }
    }
  }

  onClickQuestion1(data) {

    if (data == "Yes") {
      // this.innerPop=true;
      this.showOkButton = true
      this.travellerInfo[this.currentIndex].waitPeroid = "None";
    } else {
      this.showOkButton = true
      // for(let i=0;i<this.travellerInfo.length;i++){
      if (this.travellerInfo[this.currentIndex].arrivalDateOfCanada._d) {
        this.travellerInfo[this.currentIndex].arrivalDateOfCanada = this.travellerInfo[this.currentIndex].arrivalDateOfCanada._d;
      }
      const date = this.startDate;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const datePipe = new DatePipe('en-US');

      const formattedDate = datePipe.transform(date, 'yyyy-MM-dd hh:mm:ss ZZZZ', timezone);
      console.log(formattedDate);
      // this.startDate=formattedDate;

      // var e = new Date(this.startDate);
      // this.startDate.setTime( this.startDate.getTime() + this.startDate.getTimezoneOffset()*60*1000 );
      // this.startDate = e;

      this.startDateTemp = new Date(formattedDate);
      var Time = this.startDateTemp.getTime() + 1 - this.travellerInfo[this.currentIndex].arrivalDateOfCanada.getTime() + 1;
      var Days = Time / (1000 * 3600 * 24); //Diference in Days 
      this.travellerInfo[this.currentIndex].waitPeroid = "48 Hours - Sickness";
      // if(Days>=1 && Days <=30  && this.currentIndex == i){
      //   this.showarrivalDateInCanadaPopup=true;
      //   this.travellerInfo[i].waitPeroid="48 hours for a sickness. 24 hours for an Injury";
      // }else if(Days>=30  && this.currentIndex == i){
      //   this.showarrivalDateInCanadaPopup=true;
      //   this.travellerInfo[i].waitPeroid="7 days for a Sickness, 24 hours for an injury";
      // }
      // }
      // this.innerPop=false;
    }
  }

  onClickQuestion2(data) {
    if (data == "Yes") {
      for (let i = 0; i < this.travellerInfo.length; i++) {
        var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime();
        var Days = Time / (1000 * 3600 * 24); //Diference in Days 
        if (Days >= 1 && Days <= 30 && this.currentIndex == i) {
          this.showarrivalDateInCanadaPopup = true;
          this.travellerInfo[i].waitPeroid = "None";
        } else if (Days >= 30 && this.currentIndex == i) {
          this.showarrivalDateInCanadaPopup = true;
          this.travellerInfo[i].waitPeroid = "None";
        }

      }
    } else {
      for (let i = 0; i < this.travellerInfo.length; i++) {
        var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime();
        var Days = Time / (1000 * 3600 * 24); //Diference in Days 
        if (Days >= 1 && Days <= 30 && this.currentIndex == i) {
          this.showarrivalDateInCanadaPopup = true;
          this.travellerInfo[i].waitPeroid = "48 Hours - Sickness";
        } else if (Days >= 30 && this.currentIndex == i) {
          this.showarrivalDateInCanadaPopup = true;
          this.travellerInfo[i].waitPeroid = "None";
        }

      }
    }
  }

  selectedQuestionAns2: any;
  modalCloseQuestion() {
    this.showOkButton = false
    this.showarrivalDateInCanadaPopup = false;
    this.selectedQuestionAns1 = undefined;
    this.selectedQuestionAns2 = undefined;
    this.innerPop = false;
  }

  planQuoteResponses = [];
  startDateShow = ""
  expiryDateShow: any;
  resdentShowShow: any;
  daysToshow: any;
  travellerInformation = [];
  qestionInfoArray = [];
  chkDate: any
  chkDate2: any
  startDateFlagValid: boolean = false
  expiryDateFlagValid: boolean = false
  // postCallStep1(){

  //   var flag=true;
  //   if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false;this.expiryDateFlagValid=false}
  //   if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false;this.startDateFlagValid=false}
  //   if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false}
  //   if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false}
  //   if(!this.ageErrorCross){flag=false}else{}

  //   var chkDate1 = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
  //   this.chkDate = new Date();
  //  this.chkDate=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
  //  console.log(this.chkDate)
  //  console.log(chkDate1)
  //  if(chkDate1<this.chkDate){
  //    this.startDateFlagValid=true
  //    flag=false
  //  }
  //  else{
  //    this.startDateFlagValid=false
  //  }

  //   var chkDate2 = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
  //   this.chkDate2 = new Date();
  //  this.chkDate2=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
  //  console.log(this.chkDate2)
  //  console.log(chkDate2)
  //  if(chkDate2<this.chkDate2){
  //    this.expiryDateFlagValid=true
  //    flag=false
  //  }
  //  else{
  //    this.expiryDateFlagValid=false
  //  }


  //   //  for(let i=0;i<this.travellerInfo.length;i++){
  //   //   this.travellerInfo[i].arrivalDateOfCanada = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
  //   //   this.travellerInfo[i].dateOfBirth = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd");
  //   //  }

  //     if (flag == true) {
  //       try{
  //         if(this.NonResidentCountry.displayName){
  //           this.NonResidentCountry=this.NonResidentCountry.displayName
  //         }else{
  //           this.NonResidentCountry=this.NonResidentCountry
  //         }
  //       }
  //       catch{

  //       }
  //       this.expiryDateSelected = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
  //       this.startDateSelected = this.datePipe.transform(this.startDate, "yyyy-MM-dd");

  //       const request = 
  //       {
  //         "policyId": this.savedQuotesID,
  //     "agentId": this.agentId,
  //     "declaration": true,
  //     "deductableOptions": [
  //       {
  //         "amount": 0,
  //         "createdAt": "2022-04-27T05:08:15.125Z",
  //         "createdBy": "string",
  //         "id": 0,
  //         "lastModifiedBy": "string",
  //         "option": "string",
  //         "reduceAmount": 0,
  //         "updatedAt": "2022-04-27T05:08:15.125Z"
  //       }
  //     ],
  //     "language": this.selectedQuestionlanguages1,
  //     "noOfDays": this.calculatedDays,
  //     "optionalInformation": {
  //       "agentNote": "string",
  //       "beneficiary": "string",
  //       "comment": "string"
  //     },
  //     "paymentInformation": {
  //       "amount": 0,
  //       "cardNumber": "string",
  //       "cardType": "string",
  //       "cvv": "string",
  //       "expiryDate": "string"
  //     },
  //     "primaryAddress": {
  //       "address1": "string",
  //       "address2": "string",
  //       "city": "string",
  //       "postalCode": "string",
  //       "province":"string"
  //     },
  //     "isSameAddress": this.purchaserAddressSame,
  //     "questionsansers": [

  //     ],
  //     "residentOf": this.selectedQuestionprovince1,
  //     "returnDate": this.expiryDateSelected,
  //     "secondaryAddress": {
  //       "address1": "string",
  //       "address2": "string",
  //       "city": "string",
  //       "postalCode": "string",
  //       "province":"string"
  //     },
  //     "selectedPlan": {},
  //     "startDate": this.startDateSelected,
  //     "travellerInformation": this.travellerInfoStep1,
  //     "travelllerDetails": [
  //       {
  //         "arrivalDateInCanada": "",
  //         "country": "",
  //         "dateOfBirth": "",
  //         "dayTimePhone": "",
  //         "departureCity": "",
  //         "emailAddress": "",
  //         "firstName": "",
  //         "insitute": "",
  //         "language": "",
  //         "lastName": ""
  //       }
  //     ],
  //     "visitorsToCanada": "yes",
  //     "purchaserInformation":{
  //       "country": this.NonResidentCountry,
  //       "emailAddress": "",
  //       "firstName": "",
  //       "language": "",
  //       "lastName": "",
  //       "phoneNumber1": "",
  //       "phoneNumber2": "",
  //       "postalCode": "",
  //       "province": "",
  //       "purchaserAddress": {
  //         "country": this.NonResidentCountry,
  //         "address1": "",
  //         "address2": "",
  //         "city": "",
  //         "postalCode": ""
  //     }}
  //        }
  //       this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
  //       this.onClickToShowPlanInfo();
  //       this.planQuoteResponses=[]
  //       this.planQuoteResponses = data.data.planQuoteResponses;
  //       this.startDateShow = data.data.salesRequest.startDate;
  //       this.expiryDateShow=data.data.salesRequest.returnDate;
  //       this.resdentShowShow=data.data.salesRequest.residentOf;
  //       this.daysToshow = this.calculatedDays;
  //       this.travellerInformation = data.data.salesRequest.travellerInformation;
  //       this.qestionInfoArray = []
  //       this.qestionInfoArray = data.data.questions;
  //       this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
  //          }, error => {

  //       }, () => { });
  //   }}

  checkYesNo: boolean = true;
  checkYesNoPrev: boolean = false;
  checkToggleButtonYesbtn = "";
  checkToggleButtonNobtn = "";
  questionToshowNoteligible: any;
  applicantIndex: any;
  ageShowNotEligible: any;
  notEligibleFlag: boolean = false;
  YesbuttonClick(question, age, index, i, data, index1) {

    this.showNextbtn = true
    data.answer[i].answer = true
    this.queIndex = i
    // this.qestionInfoArrayShow[i].checkToggleButtonYesbtn="Active"
    // this.qestionInfoArrayShow[i].checkToggleButtonNobtn="Active1"
    // this.questionToshowNoteligible=question;
    // this.ageShowNotEligible=age;
    // this.applicantIndex=index;
    this.notEligible = true
    data.notEligibleFlag = true
    this.checkYesNo = false
    // this.checkToggleButtonYesbtn="Active";
    data.checkToggleButtonYesbtn = "Active";
    data.checkToggleButtonNobtn = "";
    // this.checkToggleButtonNobtn="";
    var obj = {}
    obj["question"] = question;
    obj["age"] = age;
    obj["questionIndex"] = index;
    obj["Insured"] = index;
    obj["answer"] = "Yes";
    obj["ans"] = "Yes";
    obj["questionNumber"] = this.questionNumbers;
    this.notEligibleQuestions.push(obj)
    data.ans[i].ans = "Yes";
    data.question[i].question = question;
  }
  YesbuttonClick1(question, age, index, data, queIndex, id1, k) {

    this.showNextbtn = true
    // this.queIndex=queIndex
    // data.answer[queIndex].answer=false
    data.answer[queIndex].answer = true
    data.notEligibleFlag = false
    data.notEligibleFlag1 = false
    // this.notEligible=false;
    this.notEligibleQuestions = this.notEligibleQuestions.filter(val => val.Insured !== k + 1);
    if (this.notEligibleQuestions.length == 0) {
      this.notEligible = false
    }
    this.checkYesNo = false
    var obj = {}
    obj["answer"] = "Yes";
    obj["question"] = question;
    obj["quetionId"] = id1;
    obj["Insured"] = index;
    obj["ans"] = "Yes";
    this.questionAnsArray.push(obj);

    data.question[queIndex].question = question;
    data.quetionId[queIndex].quetionId = id1;
    data.ans[queIndex].ans = "Yes";
    console.log(this.travellerInformation)
  }
  NobuttonClick2(question, id, data, item, index, age, j, k) {

    this.queIndex = index
    this.showNextbtn = true
    data.notEligibleFlag1 = true
    data.notEligibleFlag = true

    //  this.queIndex=index
    //  this.queIndex1=index
    this.questionToshowNoteligible = question;
    this.ageShowNotEligible = age;
    this.notEligibleQuestions = [];

    data.answer[index].answer = false
    console.log(data)
    console.log(index)
    var obj = {}
    obj["question"] = question;
    obj["age"] = age;
    obj["questionIndex"] = j;
    obj["Insured"] = j;
    obj["answer"] = "No";
    obj["ans"] = "No";
    obj["questionNumber"] = this.questionNumbers;
    this.notEligibleQuestions.push(obj)
    data.ans[index].ans = "No";
    this.notEligible = true;
    this.applicantIndex = index;
    this.checkYesNo = false

  }

  prevQuestionNotEligible() {

    this.qestionInfoArrayShow = [];
    this.showErrorForQuestion = false;
    this.notEligible = false;
    this.showQuestionnaireQue = true;
    this.notEligibleFlag = false;
    this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
  }

  questionAnsArray: any[] = [];
  notEligible: boolean = false;
  yesNoIndex: any;
  NobuttonClick(question, id, i, data, index) {

    // this.queIndex=i
    this.showNextbtn = true
    // this.qestionInfoArrayShow[i].checkToggleButtonNobtn="Active"
    // this.qestionInfoArrayShow[i].checkToggleButtonYesbtn="Active1"
    // this.checkToggleButtonYesbtn="";
    data.answer[i].answer = true
    data.checkToggleButtonYesbtn = "";
    // this.checkToggleButtonNobtn="Active";
    data.checkToggleButtonNobtn = "Active";
    // this.notEligibleFlag=false;
    data.notEligibleFlag = false
    this.notEligibleQuestions = this.notEligibleQuestions.filter(val => val.Insured !== index + 1);
    if (this.notEligibleQuestions.length == 0) {
      this.notEligible = false
    }
    this.checkYesNo = false
    var obj = {}
    obj["answer"] = "No";
    obj["question"] = question;
    obj["quetionId"] = id;
    obj["Insured"] = index + 1;
    obj["ans"] = "No";
    data.question[i].question = question;
    data.quetionId[i].quetionId = id;
    data.ans[i].ans = "No";
    this.questionAnsArray.push(obj);
    data.ans[i].ans = "No";
  }
  closeEligiblePop() {
    this.notEligibleQuestions = [];
    this.showErrorForQuestion = false;
    this.showQuestionnaireQue = true;

    this.qestionInfoArrayShow = [];
    this.showErrorForQuestion = false;
    this.notEligible = false;
    this.questionNumbers++
    // this.queIndex1=this.questionNumbers++
    // this.qestionInfoArrayShow.push(this.qestionInfoArray[this.queIndex1+1]);
    // this.queIndex1++
    this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
    this.lastQuestion = this.qestionInfoArray.length / 2
    if (this.lastQuestion == this.questionNumbers) {
      this.showDeclarationQuestionnaire = true;
      this.showQuestionnaireQue = false;
    } else {
      this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
      this.checkYesNo = true;
    }
    if (this.qestionInfoArray.length < 100) {
      this.matProgressValue = this.matProgressValue * 2
    }


  }
  lastQuestion: any;
  showErrorForQuestion: boolean = false;
  unselectButton: boolean = false;
  // updateQuestion()
  // {

  //   this.unselectButton=true;
  //   window.scrollTo(0,0);
  //   this.checkToggleButtonNobtn="";
  //   this.checkToggleButtonYesbtn="";
  //   if(this.notEligibleFlag==true){
  //     this.showErrorForQuestion=true
  //     this.qestionInfoArrayShow=[];
  //     this.notEligible=true;
  //     this.showQuestionnaireQue=false;
  //   }else{
  //     this.questionNumbers++;
  //     this.showErrorForQuestion=false;
  //     this.notEligible=false;
  //     this.qestionInfoArrayShow=[]
  //     this.lastQuestion=this.qestionInfoArray.length/2;
  //     if(this.lastQuestion == this.questionNumbers){
  //     this.declaration=true;
  //     this.showDeclarationQuestionnaire=true;
  //     this.showQuestionnaireQue=false;
  //     }else{
  //       this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
  //       this.checkYesNo=true;
  //     }
  //     if(this.qestionInfoArray.length<100){
  //       this.matProgressValue=this.matProgressValue*2
  //     }
  //   }

  // //  this.display3=false;
  // //   this.display4=true;
  // }
  gotoDeclaration: boolean = false;
  showNextbtn: boolean = true;
  updateQuestion() {

    this.notEligibleQuestions

    console.log(this.travellerInformation);
    console.log(this.questionNumbers);

    for (let m = 0; m < this.travellerInformation.length; m++) {
      if (this.travellerInformation[m].notEligibleFlag == false) {
        if (this.travellerInformation[m].ans[this.questionNumbers].ans == '') {
          this.showNextbtn = false
        }
      }
    }
    console.log(this.showNextbtn)
    if (this.showNextbtn == true) {
      window.scrollTo(0, 0);
      if (this.notEligibleQuestions.length > 0) {
        if (this.questionNumbers == this.notEligibleQuestions[0].questionNumber) {
          this.checknotEligibleQuestions = []
          this.checknotEligibleQuestions = this.travellerInformation.filter(val => val.notEligibleFlag == false);
          if (this.checknotEligibleQuestions.length == 0) {
            this.notEligible = true
          }
        }
      }
      if (this.notEligible == true) {
        this.showQuestionnaireQue = false
        this.showErrorForQuestion = true;
        // this.display3=false;
        this.showNextquesbtn = false
        for (let m = 0; m < this.travellerInformation.length; m++) {
          if (this.travellerInformation[m].notEligibleFlag == false) {
            this.showNextquesbtn = true
          }
        }
        this.qestionInfoArrayShow = [];
      }
      // }
      else {
        this.questionNumbers++;
        this.showErrorForQuestion = false;
        this.notEligible = false;
        this.qestionInfoArrayShow = []
        this.lastQuestion = this.qestionInfoArray.length / 2
        if (this.lastQuestion == this.questionNumbers) {
          for (let i = 0; i < this.travellerInformation.length; i++) {
            if (this.travellerInformation[i].notEligibleFlag != true) {
              this.gotoDeclaration = true
            }

          }
          if (this.gotoDeclaration == true) {
            this.showQuestionnaireQue = false
            this.showDeclarationQuestionnaire = true;
          }

        } else {
          this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
          this.checkYesNo = true;
        }
        if (this.qestionInfoArray.length < 100) {
          this.matProgressValue = this.matProgressValue * 2
        }
      }
    }

    else {
      this.showNextbtn = false
    }

    //  this.display3=false;
    //   this.display4=true;
  }

  prevQuestion() {

    window.scrollTo(0, 0);
    // this.checkToggleButtonNobtn="";
    // this.checkToggleButtonYesbtn="";
    // if(this.questionNumbers !=0){
    //   this.questionNumbers--
    //   this.qestionInfoArrayShow=[];
    //   this.notEligible=false;
    //   this.declaration=false;
    //   this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
    //   this.checkYesNo=true;
    // }

    if (this.questionNumbers != 0) {
      this.questionNumbers--
      this.qestionInfoArrayShow = [];
      this.notEligible = false;
      this.showDeclarationQuestionnaire = false;
      this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
      this.checkYesNo = true;
    } else {
      this.showDeclarationQuestionnaire = false;
      this.showIntStudPlanPlanOption = true
      this.showQuestionnaireQue = false
      this.showQuestionnaire = false
      // this.display=true;
    }
  }
  prevQuestion8() {
    // this.declaration=false;
    // this.display9=true;
    this.showDeclarationQuestionnaire = false
    this.qestionInfoArrayShow = [];
    this.showErrorForQuestion = false;
    this.notEligible = false;
    this.qestionInfoArrayShow.push(this.qestionInfoArray[this.questionNumbers]);
    this.prevQuestion();
    this.showQuestionnaireQue = true
  }

  declarationErrorFlag: boolean = true;
  onClickDeclaration(event, data, j) {
    // var flagCheck = event.target.checked;
    // if(flagCheck==true){
    // this.declarationErrorFlag=false;
    // }else{
    //   this.declarationErrorFlag=true;

    // }


    var flag = true
    if (event.target.checked) {
      data.checkDeclaration = true;
      this.declarationErrorFlag = false;
      for (let i = 0; i < this.travellerInformation.length; i++) {
        if (this.travellerInformation[i].checkDeclaration == false && this.travellerInformation[i].notEligibleFlag == false) {
          flag = false;
          this.declarationErrorFlag = true
        }
      }
      if (flag == true) {
        this.travellerInformation[j].checkDeclaration == true
        // this.form2.secondCtrl.setValue('true')
        this.declarationErrorFlag = false

      } else {
        // this.form2.secondCtrl.setValue('')
        this.travellerInformation[j].checkDeclaration == false
        this.declarationErrorFlag = true
      }
    } else {
      // data.checkDeclaration=false;
      this.travellerInformation[j].checkDeclaration = false;
      this.declarationErrorFlag = true


    }
  }






  quoteRequest: any[] = [];
  step2SaveApiCall() {
    this.questionNumbers = 0
    console.log(this.travellerInformation)

    var flag = true;
    if (this.declarationErrorFlag == true) { flag = false; this.declarationErrorFlag = true } else { flag = true; this.declarationErrorFlag = false }

    if (flag) {
      this.insuredPersonArray = []
      for (let i = 0; i < this.travellerInfo.length; i++) {
        this.insuredPerson();
      }
      // if(this.travellerInfo.length==2){
      //   this.insuredPerson();
      // }
      // if(this.travellerInfo.length==3){
      //   this.insuredPerson();
      //   this.insuredPerson();
      // }
      // if(this.travellerInfo.length==4){
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      // }
      // if(this.travellerInfo.length==5){
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      // }
      // if(this.travellerInfo.length==6){
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      // }
      // if(this.travellerInfo.length==7){
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      // }
      // if(this.travellerInfo.length==8){
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      // }
      // if(this.travellerInfo.length==9){
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      //   this.insuredPerson();
      // }
      if (flag == true) {
        for (let i = 0; i < this.travellerInformation.length; i++) {
          if (this.travellerInformation[i].notEligibleFlag == true) {
            this.travellerInformation.splice(i, 1);
          }
        }
        var premiumAmount2 = this.selectedPlanPrice;
        while (premiumAmount2.charAt(0) === '$') {
          premiumAmount2 = premiumAmount2.substring(1);
        }

        premiumAmount2 = premiumAmount2.replace(/,/g, "");
        this.amount = premiumAmount2
        this.travellerDetailsToSend = []
        for (let i = 0; i < this.travellerInformation.length; i++) {
          if (this.travellerInformation[i].notEligibleFlag == false) {
            var obj = {}
            obj["age"] = this.travellerInformation[i].age;
            obj["arrivalDateInCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
            obj["arrivalDateOfCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
            obj["country"] = this.travellerInformation[i].homeCountry;
            obj["dateOfBirth"] = this.travellerInformation[i].dateOfBirth;
            obj["dayTimePhone"] = ""
            obj["deductableOptionId"] = ""
            obj["departureCity"] = this.travellerInformation[i].homeCountry;
            obj["eligable"] = "true"
            obj["emailAddress"] = ""
            obj["firstName"] = this.travellerInformation[i].firstName;
            obj["insitute"] = this.travellerInformation[i].insitute
            obj["language"] = this.selectedQuestionlanguages1
            obj["lastName"] = this.travellerInformation[i].lastName;
            obj["premium"] = premiumAmount2;
            obj["insuredId"] = this.travellerInformation[i].insuredId;
            obj["questionsansers"] =
              // this.questionAnsArray

              [
                {
                  "answer": this.travellerInformation[i].ans[0].ans,
                  "question": this.travellerInformation[i].question[0].question,
                  "quetionId": this.travellerInformation[i].quetionId[0].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId
                },
                {
                  "answer": this.travellerInformation[i].ans[1].ans,
                  "question": this.travellerInformation[i].question[1].question,
                  "quetionId": this.travellerInformation[i].quetionId[1].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId
                },
                {
                  "answer": this.travellerInformation[i].ans[2].ans,
                  "question": this.travellerInformation[i].question[2].question,
                  "quetionId": this.travellerInformation[i].quetionId[2].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId
                },
                {
                  "answer": this.travellerInformation[i].ans[3].ans,
                  "question": this.travellerInformation[i].question[3].question,
                  "quetionId": this.travellerInformation[i].quetionId[3].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId
                }
              ]
            obj["tripCost"] = ""
            obj["waitPeroid"] = this.travellerInformation[i].waitPeroid;
            this.travellerDetailsToSend.push(obj)
          }
        }
        try {
          if (this.NonResidentCountry.displayName) {
            this.NonResidentCountry = this.NonResidentCountry.displayName
          } else {
            this.NonResidentCountry = this.NonResidentCountry
          }
        }
        catch {

        }
        const request =
        {
          "policyId": this.savedQuotesID,
          "agentId": this.agentId,
          "declaration": true,
          "deductableOptions": [
            {
              "amount": 0,
              "createdAt": "2022-04-27T05:08:15.125Z",
              "createdBy": "string",
              "id": 0,
              "lastModifiedBy": "string",
              "option": "string",
              "reduceAmount": 0,
              "updatedAt": "2022-04-27T05:08:15.125Z"
            }
          ],
          "language": this.selectedQuestionlanguages1,
          "noOfDays": this.calculatedDays,
          "optionalInformation": {
            "agentNote": "string",
            "beneficiary": "string",
            "comment": "string"
          },
          "paymentInformation": {
            "amount": this.amount,
            "cardNumber": "string",
            "cardType": "string",
            "cvv": "string",
            "expiryDate": "string"
          },
          "primaryAddress": {
            "address1": "string",
            "address2": "string",
            "city": "string",
            "postalCode": "string",
            "province": "string"
          },
          "isSameAddress": this.purchaserAddressSame,
          "questionsansers": this.questionAnsArray,
          "residentOf": this.selectedQuestionprovince1,
          "returnDate": this.expiryDateSelected,
          "secondaryAddress": {
            "address1": "string",
            "address2": "string",
            "city": "string",
            "postalCode": "string",
            "province": "string"
          },
          "selectedPlan": this.selectedPlanSend,
          "startDate": this.startDateSelected,
          "travellerInformation": this.travellerInformation,
          "travelllerDetails": this.travellerDetailsToSend,
          "visitorsToCanada": this.selectedQuestionAns1,
          "purchaserInformation": {
            "country": this.NonResidentCountry,
            "emailAddress": "",
            "firstName": "",
            "language": "",
            "lastName": "",
            "phoneNumber1": "",
            "phoneNumber2": "",
            "postalCode": "",
            "province": "",
            "purchaserAddress": {
              "country": this.NonResidentCountry,
              "address1": "",
              "address2": "",
              "city": "",
              "postalCode": ""
            }
          }
        }
        this.base.callPostService(this.config.postApistep2, request).subscribe((data: any) => {
          // this.selectedPlanPrice=data.data.paymentInformation.amount;
          this.step3headerclick = true
          if (this.showSaveQuotesVal !== "true") {

            this.purchaseProvince = data.data.residentOf;
            // this.Province=data.data.residentOf;
          }
          if (data.data.residentOf == "Non-Resident of Canada") {
            this.NonResidentSelected = true
            this.shownew = true
          } else {
            this.shownew = false
            this.NonResidentSelected = false;
          }
          if (this.showSaveQuotesVal == "true") {
            this.travellerInformation = []
            for (let i = 0; i < data.data.travelllerDetails.length; i++) {
              var obj = {}
              obj["age"] = data.data.travelllerDetails[i].age
              obj["arrivalDateOfCanada"] = data.data.travelllerDetails[i].arrivalDateOfCanada
              obj["dateOfBirth"] = data.data.travelllerDetails[i].dateOfBirth
              obj["waitPeroid"] = data.data.travelllerDetails[i].waitPeroid
              obj["notEligibleFlag"] = false
              obj["checkDeclaration"] = false
              obj["age"] = data.data.travelllerDetails[i].age
              obj["arrivalDateInCanada"] = data.data.travelllerDetails[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = data.data.travelllerDetails[i].arrivalDateOfCanada;
              obj["homeCountry"] = data.data.travelllerDetails[i].departureCity;
              obj["dateOfBirth"] = data.data.travelllerDetails[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = data.data.travelllerDetails[i].departureCity;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = data.data.travelllerDetails[i].firstName;
              obj["insitute"] = data.data.travelllerDetails[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = data.data.travelllerDetails[i].lastName;
              obj["premium"] = ""
              obj["insuredId"] = data.data.travelllerDetails[i].insuredId;

              obj["question"] =
                [
                  { question: "" },
                  { question: "" },
                  { question: "" },
                  { question: "" }
                ]
              obj["quetionId"] =
                [
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" }
                ]
              obj["ans"] =
                [
                  { ans: "" },
                  { ans: "" },
                  { ans: "" },
                  { ans: "" }
                ]
              obj["answer"] = [
                { answer: false },
                { answer: false },
                { answer: false },
                { answer: false }
              ]
              obj["quetionAnswerId"] = [
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" }
              ]
              this.travellerInformation.push(obj);
              for (let j = 0; j < data.data.travelllerDetails[i].questionsansers.length; j++) {
                this.travellerInformation[i].question[j].question = data.data.travelllerDetails[i].questionsansers[j].question;
                this.travellerInformation[i].quetionId[j].quetionId = data.data.travelllerDetails[i].questionsansers[j].quetionId;
                this.travellerInformation[i].ans[j].ans = data.data.travelllerDetails[i].questionsansers[j].answer;
                this.travellerInformation[i].answer[j].answer = data.data.travelllerDetails[i].questionsansers[j].answer;
                this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.travelllerDetails[i].questionsansers[j].quetionAnswerId;
              }
            }
          }
          this.selectedPlanPrice = data.data.selectedPlan.totalAmount;
          this.onClickQuestionnaireProceed();
        }, error => {

        }, () => { });
      }
    }
  }
  openSaveQuotepopUp1() {
    this.saveQuotesPopup1 = true;
  }
  saveQuotesPopup1: boolean = false;
  step2SaveQuote() {
    var flag = true;
    this.expiryDateSelected = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
    this.startDateSelected = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    if (!this.quoteName) { this.quoteNameFlag = true; flag = false } else { this.quoteNameFlag = false; flag = true }
    this.saveQuotetravellerInfo = []
    for (let i = 0; i < this.travellerInfo.length; i++) {
      var obj = {};
      obj["dateOfBirth"] = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd")
      obj["age"] = this.travellerInfo[i].age;
      obj["arrivalDateOfCanada"] = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd")
      obj["waitPeroid"] = this.travellerInfo[i].waitPeroid;
      obj["eligable"] = true,
        this.saveQuotetravellerInfo.push(obj);
    }
    this.SavedQuotetravellerDetailsToSend = []
    for (let i = 0; i < this.travellerInformation.length; i++) {
      if (this.travellerInformation[i].notEligibleFlag == false) {
        var obj = {}
        obj["age"] = this.travellerInformation[i].age;
        obj["arrivalDateInCanada"] = this.datePipe.transform(this.travellerInformation[i].arrivalDateOfCanada, "yyyy-MM-dd")
        obj["arrivalDateOfCanada"] = this.datePipe.transform(this.travellerInformation[i].arrivalDateOfCanada, "yyyy-MM-dd")
        obj["country"] = this.travellerInformation[i].homeCountry;
        obj["dateOfBirth"] = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd")
        obj["dayTimePhone"] = ""
        obj["deductableOptionId"] = 0
        obj["insurancePremium"] = ""
        obj["departureCity"] = this.travellerInformation[i].homeCountry;
        obj["eligable"] = true
        obj["emailAddress"] = ""
        obj["firstName"] = this.travellerInformation[i].firstName;
        obj["insitute"] = this.travellerInformation[i].insitute
        obj["language"] = this.selectedQuestionlanguages1
        obj["lastName"] = this.travellerInformation[i].lastName;
        obj["premium"] = this.amount;
        obj["insuredId"] = this.travellerInformation[i].insuredId;
        obj["questionsansers"] =
          // this.questionAnsArray
          [
            {
              "answer": this.travellerInformation[i].ans[0].ans,
              "question": this.travellerInformation[i].question[0].question,
              "quetionId": this.travellerInformation[i].quetionId[0].quetionId,
              "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId
            },
            {
              "answer": this.travellerInformation[i].ans[1].ans,
              "question": this.travellerInformation[i].question[1].question,
              "quetionId": this.travellerInformation[i].quetionId[1].quetionId,
              "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId
            },
            {
              "answer": this.travellerInformation[i].ans[2].ans,
              "question": this.travellerInformation[i].question[2].question,
              "quetionId": this.travellerInformation[i].quetionId[2].quetionId,
              "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId
            },
            {
              "answer": this.travellerInformation[i].ans[3].ans,
              "question": this.travellerInformation[i].question[3].question,
              "quetionId": this.travellerInformation[i].quetionId[3].quetionId,
              "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId
            }
          ]
        obj["tripCost"] = ""
        obj["waitPeroid"] = this.travellerInformation[i].waitPeroid;

        this.SavedQuotetravellerDetailsToSend.push(obj)
        //  if(this.travellerInformation[i].quetionAnswerId.length>0){
        //   if(this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId){
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[0].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId
        //  }else{
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[0].quetionAnswerId=""
        //  }
        //  if(this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId){
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[1].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId
        //  }else{
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[1].quetionAnswerId=""
        //  }
        //  if(this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId){
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[2].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId
        //  }else{
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[2].quetionAnswerId=""
        //  }
        //  if(this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId){
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[3].quetionAnswerId=this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId
        //  }else{
        //    this.SavedQuotetravellerDetailsToSend[i].questionsansers[3].quetionAnswerId=""
        //  }
        //  }
      }
    }
    if (flag == true) {
      // if(this.selectedPlanSend.length!=0){
      //   this.selectPlanDetails=[]
      //   this.selectPlanDetails.push(this.selectedPlanSend);
      // }
      if (this.selectedPlanSend == null) {
        this.selectedPlanSend = null
      }
      if (this.selectedPlanPrice) {
        var premiumAmount2 = this.selectedPlanPrice;
        while (premiumAmount2.charAt(0) === '$') {
          premiumAmount2 = premiumAmount2.substring(1);
        }
        premiumAmount2 = premiumAmount2.replace(/,/g, "");
        this.amount = premiumAmount2
      }
      try {
        if (this.NonResidentCountry.displayName) {
          this.NonResidentCountry = this.NonResidentCountry.displayName
        } else {
          this.NonResidentCountry = this.NonResidentCountry
        }
      }
      catch {

      }
      const request =
      {
        "policyId": this.savedQuotesID,
        "agentId": this.agentId,
        "declaration": true,
        "deductableOptions": [
          {
            "amount": 0,
            "createdAt": "2022-04-27T05:08:15.125Z",
            "createdBy": "",
            "id": 0,
            "lastModifiedBy": "",
            "option": "",
            "reduceAmount": 0,
            "updatedAt": "2022-04-27T05:08:15.125Z"
          }
        ],
        "language": this.selectedQuestionlanguages1,
        "noOfDays": this.calculatedDays,
        "optionalInformation": {
          "agentNote": this.comment,
          "beneficiary": this.beneficiary,
          "comment": this.comment
        },
        "paymentInformation": {
          "amount": this.amount,
          "cardNumber": this.cardNoToSend,
          "cardType": this.cardType,
          "cvv": "",
          "expiryDate": this.expDate1ToSend + this.expDateYearToSend
        },

        "primaryAddress": {
          "address1": this.address1,
          "address2": this.address2,
          "city": this.City,
          "postalCode": this.PostalCode,
          "province": this.Province
        },
        "quoteDescriptions": this.quoteDescriptions,
        "quoteName": this.quoteName,
        "isSameAddress": this.purchaserAddressSame,
        "questionsansers": this.questionAnsArray,
        "residentOf": this.selectedQuestionprovince1,
        "returnDate": this.expiryDateSelected,
        "secondaryAddress": {
          "address1": "",
          "address2": "",
          "city": "",
          "postalCode": "",
          "province": ""
        },
        "selectedPlan": this.selectedPlanSend,
        "startDate": this.startDateSelected,
        "travellerInformation": this.saveQuotetravellerInfo,
        "travelllerDetails": this.SavedQuotetravellerDetailsToSend,
        "visitorsToCanada": this.selectedQuestionAns1,
        "purchaserInformation": {
          "country": this.NonResidentCountry,
          "emailAddress": this.purchaseEmail,
          "firstName": this.purchaserFirstName,
          "language": this.selectedQuestionlanguages1,
          "lastName": this.purchaserLastName,
          "phoneNumber1": this.purchasePhone1,
          "phoneNumber2": this.purchasePhone2,
          "postalCode": this.purchasePostalCode,
          "province": this.purchaseProvince,
          "purchaserAddress": {
            "country": this.NonResidentCountry,
            "address1": this.purchaserAddress1,
            "address2": this.purchaserAddress2,
            "city": this.purchaseCity,
            "postalCode": this.purchasePostalCode,
            "province": this.purchaseProvince
          }
        }
      }
      if (this.showSendSaveQuoteEmail == false) {
        this.base.callPostService(this.config.saveQuote, request).subscribe((data: any) => {
          if (data.status == true) {
            this.quoteNameFlag = false;
            this.saveQuotesPopup = false;
            this.saveQuotesPopup1 = false;
            this.saveQuotesPopup2 = false;
            // this.quoteName="";
            // this.quoteDescriptions=""
            this.savedQuotesID = data.data.id;
            this.savedQuoteEmailPlanName = data.data.planName;
            this.quoteName = data.data.quoteName
            this.quoteDescriptions = data.data.quoteDescription
            this.travellerInformation = []
            for (let i = 0; i < data.data.policyInsureds.length; i++) {
              var obj = {}
              obj["age"] = data.data.policyInsureds[i].age
              obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada
              obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth
              obj["waitPeroid"] = data.data.policyInsureds[i].waitPeroid
              obj["notEligibleFlag"] = false
              obj["checkDeclaration"] = false
              obj["age"] = data.data.policyInsureds[i].age
              obj["arrivalDateInCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
              obj["homeCountry"] = data.data.policyInsureds[i].homeCountry;
              obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = data.data.policyInsureds[i].homeCountry;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = data.data.policyInsureds[i].firstName;
              obj["insitute"] = data.data.policyInsureds[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = data.data.policyInsureds[i].lastName;
              obj["premium"] = ""
              obj["insuredId"] = data.data.policyInsureds[i].id;

              obj["question"] =
                [
                  { question: "" },
                  { question: "" },
                  { question: "" },
                  { question: "" }
                ]
              obj["quetionId"] =
                [
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" }
                ]
              obj["ans"] =
                [
                  { ans: "" },
                  { ans: "" },
                  { ans: "" },
                  { ans: "" }
                ]
              obj["answer"] = [
                { answer: false },
                { answer: false },
                { answer: false },
                { answer: false }
              ]
              obj["quetionAnswerId"] = [
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" }
              ]
              this.travellerInformation.push(obj);
              for (let j = 0; j < data.data.policyInsureds[i].policyQuestionAnswers.length; j++) {
                if (data.data.policyInsureds[i].policyQuestionAnswers[j].question != null) {
                  this.travellerInformation[i].question[j].question = data.data.policyInsureds[i].policyQuestionAnswers[j].question.question;
                  this.travellerInformation[i].quetionId[j].quetionId = data.data.policyInsureds[i].policyQuestionAnswers[j].question.id;
                }
                this.travellerInformation[i].ans[j].ans = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].answer[j].answer = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.policyInsureds[i].policyQuestionAnswers[j].id;

              }
            }
            this.savedQuotePolicyInsuredArray = data.data.policyInsureds;
            Swal.fire('', "Quote information saved.", 'success');
          } else {
            Swal.fire('', data.message, 'error');
          }

        }, error => {

        }, () => { });
      }
      else {
        this.base.callPostService(this.config.savePolicyQuoteAndEmail, request).subscribe((data: any) => {
          if (data.status == true) {
            this.savedEmailTemplate = data.data.emailTemplate;
            this.savedEmailTemplateName = data.data.emailName;
            this.savedQuotesID = data.data.policy.id;
            this.savedQuoteEmailPlanName = data.data.policy.planName;
            this.savedQuotePolicyInsuredArray = data.data.policy.policyInsureds;
            this.travellerInformation = []
            for (let i = 0; i < data.data.policy.policyInsureds.length; i++) {
              var obj = {}
              obj["age"] = data.data.policy.policyInsureds[i].age
              obj["arrivalDateOfCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada
              obj["dateOfBirth"] = data.data.policy.policyInsureds[i].dateOfBirth
              obj["waitPeroid"] = data.data.policy.policyInsureds[i].waitPeroid
              obj["notEligibleFlag"] = false
              obj["checkDeclaration"] = false
              obj["age"] = data.data.policy.policyInsureds[i].age
              obj["arrivalDateInCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada;
              obj["arrivalDateOfCanada"] = data.data.policy.policyInsureds[i].arrivalDateOfCanada;
              obj["homeCountry"] = data.data.policy.policyInsureds[i].homeCountry;
              obj["dateOfBirth"] = data.data.policy.policyInsureds[i].dateOfBirth;
              obj["dayTimePhone"] = ""
              obj["deductableOptionId"] = ""
              obj["departureCity"] = data.data.policy.policyInsureds[i].homeCountry;
              obj["eligable"] = "true"
              obj["emailAddress"] = ""
              obj["firstName"] = data.data.policy.policyInsureds[i].firstName;
              obj["insitute"] = data.data.policy.policyInsureds[i].insitute
              obj["language"] = this.selectedQuestionlanguages1
              obj["lastName"] = data.data.policy.policyInsureds[i].lastName;
              obj["premium"] = ""
              obj["insuredId"] = data.data.policy.policyInsureds[i].id;

              obj["question"] =
                [
                  { question: "" },
                  { question: "" },
                  { question: "" },
                  { question: "" }
                ]
              obj["quetionId"] =
                [
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" },
                  { quetionId: "" }
                ]
              obj["ans"] =
                [
                  { ans: "" },
                  { ans: "" },
                  { ans: "" },
                  { ans: "" }
                ]
              obj["answer"] = [
                { answer: false },
                { answer: false },
                { answer: false },
                { answer: false }
              ]
              obj["quetionAnswerId"] = [
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" },
                { quetionAnswerId: "" }
              ]
              this.travellerInformation.push(obj);
              for (let j = 0; j < data.data.policy.policyInsureds[i].policyQuestionAnswers.length; j++) {
                if (data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question != null) {
                  this.travellerInformation[i].question[j].question = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question.question;
                  this.travellerInformation[i].quetionId[j].quetionId = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].question.id;
                }
                this.travellerInformation[i].ans[j].ans = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].answer[j].answer = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].answer;
                this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.policy.policyInsureds[i].policyQuestionAnswers[j].id;

              }
            }
            this.sendEmailOfSavedQuotes();
            // Swal.fire('',"Quote information saved.",'success');
          } else {
            Swal.fire('', data.message, 'error');
          }
        }, error => {

        }, () => { });
      }
    }
  }

  insuredPersonArray = [];
  insuredPerson() {
    var obj = {};
    obj["firstName"] = ""
    obj["lastName"] = ""
    obj["insitute"] = ""
    obj["homeCountry"] = ""
    this.insuredPersonArray.push(obj);
  }

  countryListing: any = [];
  countryListing1: any = [];
  getcountryListing() {
    this.user.getCountryDropdown().subscribe((data: any) => {
      this.countryListing = data.data;
    }, error => {
      {
        //handle Exception from Server 404,401
      }
    }, () => { });
  }
  getcountryListing1() {
    this.user.getCountryWithCode().subscribe((data: any) => {
      this.countryListing1 = data.data;
    }, error => {
      {
        //handle Exception from Server 404,401
      }
    }, () => { });
  }

  purchaserAddress1Flag: boolean = false;
  showAddressResults1: boolean = false;
  showAddressResults: boolean = false;
  purchaserAddress1: any = "";
  purchaserLastName: any = "";
  purchaserFirstName: any = "";
  purchasePostalCode: any = "";
  purchaseProvince: any = null;
  purchaseCity: any;
  getAddress = [];
  getAddress1 = [];
  callAddressApiCall() {
    this.showcheckbox = false
    this.purchaserAddressSame = false


    // this.purchaserAddress1Flag=false;
    this.showAddressResults = true;
    // this.purchaseProvince=false;
    // this.purchasePostalCode=false;
    // this.purchaseCity=false;
    this.user.getAddressCanada(this.address1).subscribe((data: any) => {
      this.getAddress =data.suggestions;
    }, error => {
      {
        //handle Exception from Server 404,401
      }
    }, () => { });
  }
  callAddressApiCall1() {

    this.purchaserAddress1Flag = false;
    this.showAddressResults1 = true;
    // this.purchaseProvince=false;
    // this.purchasePostalCode=false;
    // this.purchaseCity=false;
    if (this.purchaserNonResidentCountry == undefined) {
      var cName = "CAN"
    }
    else {
      cName = this.purchaserNonResidentCountry.iso3Code
    }
    this.user.getAddressCanada(this.purchaserAddress1).subscribe((data: any) => {
      this.getAddress1 = data.suggestions;
    }, error => {
      {
        //handle Exception from Server 404,401
      }
    }, () => { });
  }
  callAddressApiCall1N() {

    this.purchaserAddress1Flag = false;
    this.showAddressResults1 = true;
    // this.purchaseProvince=false;
    // this.purchasePostalCode=false;
    // this.purchaseCity=false;
    if (this.purchaserNonResidentCountry == undefined) {
      var cName = "CAN"
    }
    else {
      cName = this.purchaserNonResidentCountry.iso3Code
    }
    this.user.getAddressCanada1N(this.purchaserAddress1, this.purchaserAddress1c).subscribe((data: any) => {
      this.getAddress1 = data.suggestions;
    }, error => {
      {
        //handle Exception from Server 404,401
      }
    }, () => { });
  }
  callAddressApiCallN() {
    this.showAddressResults = true;
    // this.primaryProvince=false;
    // this.primaryPostalCode=false;
    // this.primaryCity=false;
    this.user.getAddressCanadaN(this.address1, this.primaryAddress1c).subscribe((data: any) => {
      this.getAddress = data.suggestions;
    }, error => {
      {
        //handle Exception from Server 404,401
      }
    }, () => { });
  }
  getSelectedAddress: any[] = [];
  getSelectedAddress1: any[] = [];
  showOutSideProvincePopup: boolean = false;
  ProvinceCode: any;
  onClickSearchResult(item) {

    // if (item.Type == "Address") {
      // this.address1 = item.Text;
      this.showAddressResults = false;
      this.showcheckbox = true

      this.user.getAddressCanadaSelected(item.action.id).subscribe((data: any) => {
        this.getSelectedAddress = data.features;
        this.address1 = this.getSelectedAddress[0]?.properties?.address_line1;
        this.address2 = this.getSelectedAddress[0]?.properties?.address_line2;
        this.City = this.getSelectedAddress[0]?.properties?.place;
        this.PostalCode = this.getSelectedAddress[0]?.properties?.postcode;
        this.Province = this.getSelectedAddress[0]?.properties?.region;
        this.ProvinceCode = this.getSelectedAddress[0]?.properties?.region_code;
        for (let i = 0; this.provincesArray1.length > i; i++) {
          if (this.provincesArray1[i].provinceName == this.Province || this.provincesArray1[i].provinceCode == this.ProvinceCode) {
            // this.showOutSideProvincePopup=false;
            this.PopupShowProvince = false
            return;
          } else {
            // this.showOutSideProvincePopup=true;
            this.PopupShowProvince = true
          }
        }
        //     this.purchaseCityFlag=false;
        // this.purchaseProvinceFlag=false;
        // this.purchasePostalCodeFlag=false;
        // this.purchaseCityFlag=false;
        // this.purchasePostalCodeFlag=false;
        // this.purchaseProvinceFlag=false;
      }, error => {
        {
        }
      }, () => { })
    // }
    // else {
    //   this.address1 = item.Text;
    //   this.primaryAddress1c = item.Id
    //   this.callAddressApiCallN()
    // }
  }
  purchaseProvinceCode: any;
  onClickSearchResult1(item) {

    // if (item.Type == "Address") {
      this.purchaserAddressSame = false
      this.purchaserAddress1 = item.Text;
      this.showAddressResults1 = false;

      this.user.getAddressCanadaSelected(item.action.id).subscribe((data: any) => {

        this.getSelectedAddress1 = data.features;
        this.purchaserAddress1 = this.getSelectedAddress1[0]?.properties?.address_line1;
        this.purchaserAddress2 = this.getSelectedAddress1[0]?.properties?.address_line2;
        this.purchaseCity = this.getSelectedAddress1[0]?.properties?.place;
        this.purchasePostalCode = this.getSelectedAddress1[0]?.properties?.postcode;
        if (this.purchaseProvince !== "Non-Resident of Canada") {
          this.purchaseProvince = this.getSelectedAddress1[0]?.properties?.region;
          if (this.getSelectedAddress1[0]?.properties?.region == "Québec") {
            this.getSelectedAddress1[0].properties.region = "Quebec"
            this.purchaseProvince = this.getSelectedAddress1[0]?.properties?.region;
          } else {
            this.purchaseProvince = this.getSelectedAddress1[0]?.properties?.region;
          }
        }
        else {
          this.purchaseProvince == "Non-Resident of Canada";
        }
        this.purchaseProvinceCode = this.getSelectedAddress1[0].ProvinceCode;
        this.resdentShowShow = this.getSelectedAddress1[0]?.properties?.region;
        this.purchaseCityFlag = false;
        this.purchaseProvinceFlag = false;
        this.purchasePostalCodeFlag = false;
        for (let i = 0; this.provincesArray1.length > i; i++) {
          if (this.provincesArray1[i].provinceName == this.purchaseProvince || this.provincesArray1[i].provinceCode == this.purchaseProvinceCode) {
            this.showOutSideProvincePopup = false;
            return;
          } else {
            this.showOutSideProvincePopup = true;
          }
        }
        // this.purchaseCityFlag=false;
        // this.purchasePostalCodeFlag=false;
        // this.purchaseProvinceFlag=false;
      }, error => {
        {
        }
      }, () => { })
    // }
    // else {
    //   this.purchaserAddress1 = item.Text;
    //   this.purchaserAddress1c = item.Id;
    //   this.callAddressApiCall1N();
    // }
  }
  purchaseEmailFlag: boolean = false;
  purchaseConfirmEmailFlag: boolean = false;
  purchasePhone1Flag: boolean = false;
  purchasePhone2Flag: boolean = false;
  purchasePostalCodeFlag: boolean = false;
  purchaseCityFlag: boolean = false;
  purchaserFirstNameFlag: boolean = false;
  purchaserLastNameFlag: boolean = false;
  onEmailClick() {
    this.purchaseEmailFlag = false;
  }
  onPhoneClick1() {
    if (this.NonResidentSelected == false) {
      if (!this.purchasePhone1) {

        this.notValidPhoneNo = false;
        this.purchasePhone1Flag = true
      }
      else {
        if (this.purchasePhone1.length > 9) {
          this.user.checkphoneNumber(this.purchasePhone1).pipe()
            .subscribe(
              data => {
                console.log(data);
                if (data.success == true) {
                  this.notValidPhoneNo = false;
                  this.purchasePhone1Flag = false
                }
                else {
                  this.notValidPhoneNo = true;
                  this.purchasePhone1Flag = false
                }
              }, error => {


              }, () => { });
        }
        else {
          this.notValidPhoneNo = false;
          this.purchasePhone1Flag = true
        }
      }
    }
  }
  onPhoneClick2() {
    if (this.purchasePhone2.length > 0) {
      if (!this.purchasePhone2) {

        this.notValidPhoneNo2 = false;
        this.purchasePhone2Flag = true
      }
      else {
        this.user.checkphoneNumber(this.purchasePhone2).pipe()
          .subscribe(
            data => {
              console.log(data);
              if (data.success == true) {
                this.notValidPhoneNo2 = false;
                this.purchasePhone2Flag = false
              }
              else {
                this.notValidPhoneNo2 = true;
                this.purchasePhone2Flag = false
              }
            }, error => {


            }, () => { });
      }
    }
    else {
      this.notValidPhoneNo2 = false;
      this.purchasePhone2Flag = false
    }
  }
  onPostalCodeClick() {
    this.purchasePostalCodeFlag = false;
  }
  onCityClick() {
    this.purchaseCityFlag = false;
  }
  onpurchaseFirstnameClick() {
    this.purchaserFirstNameFlag = false;
  }
  onpurchaseLastnameClick() {
    this.purchaserLastNameFlag = false;
  }

  purchaseEmail: any = "";
  emailNotValid: string = "";
  emailCheck() {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (!re.test(this.purchaseEmail.toLowerCase())) {
      this.emailNotValid = "Please enter valid Email";
    } else {
      this.emailNotValid = "";
    }
  }

  notValidPhoneNo: boolean = false;
  notValidPhoneNo2: boolean = false;
  purchasePhone1: any = "";
  // checkPatternWork(){  
  // var re = /^[0-9-+() ]*$/;
  // if (!re.test(this.purchasePhone1.toLowerCase())) {
  // this.notValidPhoneNo="Please enter valid Work Phone";
  // }else{
  //   this.notValidPhoneNo=""
  // }
  // }

  confirmEmailMatch: boolean = false;
  purchaseEmailConfirm: any = "";
  purchasePhone2: any;
  checkConfirmEmail() {

    if (this.purchaseEmail && this.purchaseEmailConfirm) {
      if (this.purchaseEmail == this.purchaseEmailConfirm) {
        this.confirmEmailMatch = false;
        this.purchaseConfirmEmailFlag = false;
      } else {
        this.confirmEmailMatch = true;
        this.purchaseConfirmEmailFlag = false;
      }
    }

  }
  onConfirmEmailClick(){
    this.purchaseConfirmEmailFlag=false;  
    }

  purchaseProvinceFlag: boolean = false;
  NonResidentSelected: boolean = false;
  purchaserNonResidentCountry: any;
  comment: any;
  beneficiary: any;
  agentNote: any;
  onProvinceClick() {

    this.purchaseProvinceFlag = false;
    this.resdentShowShow = this.Province
    if (this.Province == "Non-Resident of Canada") {
      this.NonResidentSelected = true
    } else {
      this.NonResidentSelected = false;
    }
    // for(let i = 0; this.provincesArray1.length > i; i++) {
    //   if(this.provincesArray1[i].provinceName==this.Province || this.provincesArray1[i].provinceCode==this.ProvinceCode){
    //     this.showOutSideProvincePopup=false;
    //     return;
    //   }else{
    //     this.showOutSideProvincePopup=true;
    //   }
    // }
  }
  onProvinceClick1() {

    this.purchaseProvinceFlag = false;
    this.resdentShowShow = this.purchaseProvince
    if (this.purchaseProvince == "Non-Resident of Canada") {
      this.NonResidentSelected = true
      this.purchaserAddressSame = false;
      this.purchaserAddress1 = "";
      this.purchaserAddress2 = "";
      this.purchaseCity = "";
      this.purchasePostalCode = "";
    } else {
      this.NonResidentSelected = false;
    }
    for (let i = 0; this.provincesArray1.length > i; i++) {
      if (this.provincesArray1[i].provinceName == this.purchaseProvince || this.provincesArray1[i].provinceCode == this.ProvinceCode) {
        this.showOutSideProvincePopup = false;
        return;
      } else {
        this.showOutSideProvincePopup = true;
      }
    }
  }
  viewPolicyDetailsPopup: boolean = false;
  viewPolicyDetailsPopup1: boolean = false;
  agentcbtn: boolean = true;
  hidecircle: boolean = true;
  tabs = [
    { active: 'active', tabcontent: 'tabcontent' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },

  ];
  openTabs(index) {
    this.reset();
    if (index == 3) {
      this.onSelectedBoxFile(index)
    }
    this.tabs[index].active = 'active';
    this.tabs[index].tabcontent = 'tabcontent';

    if (index == 0) {
      this.hidecircle = true;

    }
    else {
      this.hidecircle = false;

    }
    if (index == 2 || index == 3) {
      this.agentcbtn = false;
    }
    else {
      this.agentcbtn = true;

    }
  }
  reset() {
    for (let i = 0; this.tabs.length > i; i++) {
      this.tabs[i].active = '';
      this.tabs[i].tabcontent = 'hide';
    }
  }

  cardType: any;
  cardNoValid: boolean = false;
  cardError: boolean = false;
  cvvValid: boolean = false;
  expirydateValid: boolean = false;
  expDate1ToSend: any;
  expiryyrValid: boolean = false;
  purchaserNonResidentCountryflag: boolean = false;
  expDateYearToSend: any;
  cvvToSend: any;
  cardNoToSend: string = ''
  cardNoClick() {
    this.cardNoValid = false;
  }
  cvvClick() {
    this.cvvValid = false;
  }
  expiryDateClick() {
    this.expirydateValid = false;
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }

    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);

    console.log(month)
    console.log(last2Num)
    console.log(this.expDate1ToSend)
    console.log(this.expDateYearToSend)
    if (this.expDate1ToSend < month && this.expDateYearToSend <= last2Num) {
      // localStorage.removeItem('responseID');
      // this.blockUI.stop()
      this.expirydateValid = true;
      // Swal.fire('',"Expiry Date Invalid.",'error')
    }
    else {
      this.expiryyrValid = false;
      this.expirydateValid = false;
    }
  }
  expiryYearClick() {
    this.expiryyrValid = false;
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }

    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);

    console.log(month)
    console.log(last2Num)
    console.log(this.expDate1ToSend)
    console.log(this.expDateYearToSend)
    if (this.expDate1ToSend < month && this.expDateYearToSend <= last2Num) {
      // localStorage.removeItem('responseID');
      // this.blockUI.stop()
      this.expiryyrValid = true;
      // Swal.fire('',"Expiry Date Invalid.",'error')
    }
    else {
      this.expiryyrValid = false;
      this.expirydateValid = false;
    }
  }


  ValidateCreditCardNumber() {
    var ccNum = this.cardNoToSend;

    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
    var isValid = false;

    if (visaRegEx.test(ccNum)) {
      isValid = true;
      this.cardType = "VISA"
    } else if (mastercardRegEx.test(ccNum)) {
      isValid = true;
      this.cardType = "MasterCard"
    } else if (amexpRegEx.test(ccNum)) {
      isValid = true;
      this.cardType = "Amex"
    } else if (discovRegEx.test(ccNum)) {
      isValid = true;
      this.cardType = "Discover"
    } else {
      isValid = false;
    }
    if (isValid == true) {
      this.cardError = false;
    } else {
      this.cardError = true;
    }
  }
  paymentToken: any;
  buttonClicked = false;
  paymentCall() {
    
    if (!this.buttonClicked) {

      this.buttonClicked = false;

      var flag = true;
      if (this.NonResidentSelected == false) {
        if (!this.purchaserLastName) { flag = false; this.purchaserLastNameFlag = true } else { this.purchaserLastNameFlag = false }
        if (!this.purchaserFirstName) { flag = false; this.purchaserFirstNameFlag = true } else { this.purchaserFirstNameFlag = false }
        if (!this.purchaserAddress1) { flag = false; this.purchaserAddress1Flag = true } else { this.purchaserAddress1Flag = false }
        if (!this.purchaseProvince) { flag = false; this.purchaseProvinceFlag = true } else { this.purchaseProvinceFlag = false }
        if (!this.purchaseCity) { flag = false; this.purchaseCityFlag = true } else { this.purchaseCityFlag = false }
        if (!this.purchasePostalCode) { flag = false; this.purchasePostalCodeFlag = true } else { this.purchasePostalCodeFlag = false }
        if (!this.purchasePhone1) { flag = false; this.purchasePhone1Flag = true } else { this.purchasePhone1Flag = false }
        if (!this.purchaseEmail) { flag = false; this.purchaseEmailFlag = true } else { this.purchaseEmailFlag = false }
        if (!this.purchaseEmailConfirm) { flag = false; this.purchaseConfirmEmailFlag = true } else { this.purchaseConfirmEmailFlag = false }
      }
      else {
        if (!this.purchaserLastName) { flag = false; this.purchaserLastNameFlag = true } else { this.purchaserLastNameFlag = false }
        if (!this.purchaserFirstName) { flag = false; this.purchaserFirstNameFlag = true } else { this.purchaserFirstNameFlag = false }
        // if (!this.purchasePhone1) { flag = false; this.purchasePhone1Flag = true } else { this.purchasePhone1Flag = false }
        if (!this.purchaseEmail) { flag = false; this.purchaseEmailFlag = true } else { this.purchaseEmailFlag = false }
        if (!this.purchaseEmailConfirm) { flag = false; this.purchaseConfirmEmailFlag = true } else { this.purchaseConfirmEmailFlag = false }
      }
//         this.recaptchaV3Service.execute('submit_form').subscribe((token: string) => {
//       const formData = {
       
//         recaptchaToken: token,
//       };
//       //  console.log('Form data to submit:', formData);
// this.user.getV3RecaptchaVerification(formData.recaptchaToken).subscribe((data:any) =>{
//      debugger
    // if(data.success==true) {
      if (flag == true && this.confirmEmailMatch == false) {


        const d = new Date();
        let month = getMonth(d);
        function getMonth(date) {
          var month = date.getMonth() + 1;
          return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }

        const last2 = new Date().getFullYear().toString().slice(-2);
        console.log(last2); // 👉️ has type of string
        const last2Num = Number(last2);

        console.log(month)
        console.log(last2Num)
        console.log(this.expDate1ToSend)
        console.log(this.expDateYearToSend)
        if (this.expDate1ToSend < month && this.expDateYearToSend <= last2Num) {
          localStorage.removeItem('responseID');
          this.loading = false;
          Swal.fire('', "Expiry Date Invalid.", 'error')
        }
        else {

          // window.open("https://api.demo.convergepay.com/hosted-payments/?ssl_txn_auth_token="+this.paymentToken,'_self');
          //  this.form4.expDateToSend.setValue(this.form4.expDateToSend.value+this.form4.expDateYearToSend.value)
          this.expDate1ToSend2 = this.expDate1ToSend + this.expDateYearToSend
        }


        this.finalStageTransactionCall();
        //   var s = this.selectedPlanPrice;
        //   while(s.charAt(0) === '$')
        //   {
        //    s = s.substring(1);
        //   }
        //   s=s.replace (/,/g, "");
        // // s=1
        //   console.log(s)
        //     const request = 
        //         //Test Cred
        //           // {   
        //           //    "transactiontype": "ccsale",
        //           //    "lastName": this.purchaserLastName,
        //           //    "firstName": this.purchaserFirstName,
        //           //    "amount": s,
        //           //    "ssl_merchant_id": "0023039",
        //           //    "ssl_user_id": "apiuser",
        //           //    "ssl_pin": "BEC8HDPDZNJU4XBGMJOVA0Q82RF6Q05FQ4SHDJX48MXRIWFDOCD483YE5SE8DUSQ"

        //           //  }
        //            //Prod Cred
        //           {

        //             "transactiontype": "ccsale",
        //             "lastName": this.purchaserLastName,
        //             "firstName": this.purchaserFirstName,
        //             "amount": s,
        //             // "ssl_merchant_id": "2326992",
        //             // "ssl_user_id": "8040326582web",
        //              "ssl_pin": "X8YW7FCTDCY9DHBGNG4NNJIHHGWDLK7ZGANOFZV75LR3LODN05DM905FOVATZKTU"
        //           }
        //           this.base.callPostService(this.config.getTokenApiForPayment, request).subscribe((data: any) => {
        //           this.paymentToken = data.data;
        //           // this.getPaymentTokens();
        //           // this.totalAmount.setValue(this.selectedPlanPrice)
        //           localStorage.removeItem('selectedQuestionprovince1');
        //           localStorage.removeItem('selectedQuestionlanguages1');

        //            }, error => {

        //           if (this.base.handleError(error)) {
        //             if (error.status == 400) {
        //             }
        //           }
        //         }, () => { });
      }
    //    }
     
    //  else{
    // // this.error="reCaptcha Verification Failed";
    //  }
    // },error=>{{
    // }},()=>{});
      
    // });
    }
  }
    expDate1ToSend2: any;
    getPaymentTokens(){
      this.loading = true;
      // this.onPaymentGetwayCall()
      // console.log(this.thirdFormGroup.itemRows1.value.firstName)
      // console.log(this.form1.itemRows1.value.firstName)
      // console.log(this.thirdFormGroup.itemRows1.value.lastName)
      // console.log(this.thirdFormGroup.itemRows1.value.insitute)
      // console.log(this.form1.itemRows1.value.homeCountry)

      window.scrollTo(0, 0);
      var flag = true;

      // if(!this.form1.itemRows1.value[0].firstName){flag=false;this.firstNameFlag=true}else{this.firstNameFlag=false}
      // if(!this.form1.itemRows1.value[0].lastName){flag=false;this.lastNameFlag=true}else{this.lastNameFlag=false}
      // if(!this.form1.itemRows1.value[0].insitute){flag=false;this.InstituteFlag=true}else{this.InstituteFlag=false}
      // if(!this.form1.itemRows1.value[0].homeCountry){flag=false;this.CountryFlag=true}else{this.CountryFlag=false}
      // if(!this.form1.city.value){flag=false;this.cityFlag1=true}else{flag=true;this.cityFlag1=false}
      // if(!this.form1.provinceSelected.value){flag=false;this.provinceFlag1=true}else{flag=true;this.provinceFlag1=false}
      // if(!this.form1.postalCode.value){flag=false;this.postalCodeFlag1=true}else{flag=true;this.postalCodeFlag1=false}

      // if(flag){


      const d = new Date();
      let month = getMonth(d);
      function getMonth(date) {
        var month = date.getMonth() + 1;
        return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
      }

      const last2 = new Date().getFullYear().toString().slice(-2);
      console.log(last2); // 👉️ has type of string
      const last2Num = Number(last2);

      console.log(month)
      console.log(last2Num)
      console.log(this.expDate1ToSend)
      console.log(this.expDateYearToSend)
      if (this.expDate1ToSend < month && this.expDateYearToSend <= last2Num) {
        localStorage.removeItem('responseID');
        this.loading = false;
        Swal.fire('', "Expiry Date Invalid.", 'error')
      }
      else {
        // window.open("https://api.demo.convergepay.com/hosted-payments/?ssl_txn_auth_token="+this.paymentToken,'_self');
        //  this.form4.expDateToSend.setValue(this.form4.expDateToSend.value+this.form4.expDateYearToSend.value)
        this.expDate1ToSend2 = this.expDate1ToSend + this.expDateYearToSend
        // console.log(this.selectedPlanPrice)
        var s = this.selectedPlanPrice;
        while (s.charAt(0) === '$') {
          s = s.substring(1);
        }
        console.log(s)
        s = s.replace(/,/g, "");
        console.log(s)
        //s=1
        const request =
        // Prod Cred
        // {  

        //   "cardExpiryDate":this.expDate1ToSend2,
        //   "cardNumber": this.cardNoToSend,
        //    "transactiontype": "ccgettoken",
        //    "lastName": this.purchaserLastName,
        //    "firstName": this.purchaserFirstName,
        //    "purchaserAdressPostalCode": this.purchasePostalCode,
        //    "purchaserAdressStreet": this.purchaserAddress1,
        //    "amount": s,
        //    "ssl_merchant_id": "2326992",
        //    "ssl_user_id": "8040326582web",
        //    "ssl_pin": "SH2NNXHTEV3W5GAAZVO305QFCP3GW6A15W514YOK9AP1R9BGY0DOF6H4753K4SVJ"
        //  }
        //  test cred


        {
          "cardExpiryDate": this.expDate1ToSend2,
          "cardNumber": this.cardNoToSend,
          "transactiontype": "ccgettoken",
          "lastName": this.purchaserLastName,
          "firstName": this.purchaserFirstName,
          "purchaserAdressPostalCode": this.purchasePostalCode,
          "purchaserAdressStreet": this.purchaserAddress1,
          "amount": s,
          //  "ssl_merchant_id": "0023039",
          //  "ssl_user_id": "apiuser",
          //  "ssl_pin": "BEC8HDPDZNJU4XBGMJOVA0Q82RF6Q05FQ4SHDJX48MXRIWFDOCD483YE5SE8DUSQ"
        }
        // this.restService.callPostService(this.config.getTokenApiForPayment, request).subscribe((data: any) => {
        this.base.callPostService(this.config.generateTokenApiForPayment, request).subscribe((data: any) => {
          if (data.status == true) {
            this.paymentTokenNew = data.data.ssl_token;
            this.ssl_avs_address = data.data?.ssl_avs_address;
            this.ssl_avs_zip = data.data?.ssl_avs_zip;
            localStorage.removeItem('selectedQuestionprovince1');
            localStorage.removeItem('selectedQuestionlanguages1');
            this.onPaymentGetwayCall();
          }
          else {
            // Swal.fire('',data.message);
            Swal.fire('', data.message, 'error')
          }

          // this.step3PostApi()
          //   this.showAddressResults1=false;
          //   this.form4.totalAmount.setValue(this.selectedPlanPrice)
          //  this.form4.expDateYearToSend.setValue(23)

        }, error => {

          if (this.base.handleError(error)) {
            if (error.status == 400) {
            }
          }
        }, () => { });
      }
      // this.onClickAddress2();
    }
    onPaymentGetwayCall(){

      var flag = true
      try { this.purchaserLastName = this.purchaserLastName.trim() } catch { }
      try { this.purchaserFirstName = this.purchaserFirstName.trim() } catch { }
      try { this.purchaseEmail = this.purchaseEmail.trim() } catch { }
      try { this.purchaseEmailConfirm = this.purchaseEmailConfirm.trim() } catch { }
      if (this.purchaseProvince == "Non-Resident of Canada") {
        if (!this.purchaserLastName) { flag = false; this.purchaserLastNameFlag = true } else { this.purchaserLastNameFlag = false }
        if (!this.purchaserFirstName) { flag = false; this.purchaserFirstNameFlag = true } else { this.purchaserFirstNameFlag = false }
        //   if(!this.purchaserAddress1){flag=false;this.purchaserAddress1Flag=true}else{this.purchaserAddress1Flag=false}
        //   // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
        //   if(!this.purchaseProvince){flag=false;this.purchaseProvinceFlag=true}else{this.purchaseProvinceFlag=false}
        //   if(!this.purchaseCity){flag=false;this.purchaseCityFlag=true}else{this.purchaseCityFlag=false}
        //   if(!this.purchasePostalCode){flag=false;this.purchasePostalCodeFlag=true}else{this.purchasePostalCodeFlag=false}
        //  if(!this.purchasePhone1){flag=false;this.purchasePhone1Flag=true}else{this.purchasePhone1Flag=false}
        if (!this.purchaseEmail) { flag = false; this.purchaseEmailFlag = true } else { this.purchaseEmailFlag = false }
        if (!this.purchaseEmailConfirm) { flag = false; this.purchaseConfirmEmailFlag = true } else { this.purchaseConfirmEmailFlag = false }
        if (!this.cardNoToSend) { flag = false; this.cardNoValid = true } else { this.cardNoValid = false }
        // if(!this.cvvToSend){flag=false;this.cvvValid=true}else{this.cvvValid=false}
        if (!this.expDate1ToSend) { flag = false; this.expirydateValid = true } else { this.expirydateValid = false }
        if (!this.expDateYearToSend) { flag = false; this.expiryyrValid = true } else { this.expiryyrValid = false }
        // if(!this.purchaserNonResidentCountry){flag=false;this.purchaserNonResidentCountryflag=true}else{this.purchaserNonResidentCountryflag=false}
      }
      else {


        if (!this.purchaserLastName) { flag = false; this.purchaserLastNameFlag = true } else { this.purchaserLastNameFlag = false }
        if (!this.purchaserFirstName) { flag = false; this.purchaserFirstNameFlag = true } else { this.purchaserFirstNameFlag = false }
        if (!this.purchaserAddress1) { flag = false; this.purchaserAddress1Flag = true } else { this.purchaserAddress1Flag = false }
        // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
        if (!this.purchaseProvince) { flag = false; this.purchaseProvinceFlag = true } else { this.purchaseProvinceFlag = false }
        if (!this.purchaseCity) { flag = false; this.purchaseCityFlag = true } else { this.purchaseCityFlag = false }
        if (!this.purchasePostalCode) { flag = false; this.purchasePostalCodeFlag = true } else { this.purchasePostalCodeFlag = false }
        if (!this.purchasePhone1) { flag = false; this.purchasePhone1Flag = true } else { this.purchasePhone1Flag = false }
        if (!this.purchaseEmail) { flag = false; this.purchaseEmailFlag = true } else { this.purchaseEmailFlag = false }
        if (!this.purchaseEmailConfirm) { flag = false; this.purchaseConfirmEmailFlag = true } else { this.purchaseConfirmEmailFlag = false }
        if (!this.cardNoToSend) { flag = false; this.cardNoValid = true } else { this.cardNoValid = false }
        // if(!this.cvvToSend){flag=false;this.cvvValid=true}else{this.cvvValid=false}
        if (!this.expDate1ToSend) { flag = false; this.expirydateValid = true } else { this.expirydateValid = false }
        if (!this.expDateYearToSend) { flag = false; this.expiryyrValid = true } else { this.expiryyrValid = false }
      }
      if (flag == true) {
        this.expDate1ToSend2 = this.expDate1ToSend + this.expDateYearToSend
        this.blockUI.start('Your request is being processed. Please do not refresh your screen. Thank you for your patience.')
        localStorage.removeItem('policyId');
        const d = new Date();
        let month = getMonth(d);
        function getMonth(date) {
          var month = date.getMonth() + 1;
          return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
        }

        const last2 = new Date().getFullYear().toString().slice(-2);
        console.log(last2); // 👉️ has type of string
        const last2Num = Number(last2);

        console.log(month)
        console.log(last2Num)
        console.log(this.expDate1ToSend)
        console.log(this.expDateYearToSend)
        if (this.expDate1ToSend < month && this.expDateYearToSend <= last2Num) {
          localStorage.removeItem('responseID');
          this.blockUI.stop()
          Swal.fire('', "Expiry Date Invalid.", 'error')
        }
        else {
          // pay(this.paymentToken,this.paymentTokenNew,this.expDate1ToSend2,this.purchaserFirstName,this.purchaserLastName,this.ssl_avs_address,this.ssl_avs_zip);
          // setTimeout(() =>
          // {
          this.finalStageTransactionCall();
          // },
          // 8000);
        }
      }
      else {

      }

    }
    transactionID: any;
    amount: any;
    ssl_merchant_initiated_unscheduled: any;
    ssl_issuer_response: any;
    ssl_partner_app_id: any;
    ssl_card_number: any;
    ssl_transaction_type: any;
    ssl_transaction_reference_number: any;
    ssl_result: any;
    ssl_approval_code: any;
    ssl_txn_time: any;
    ssl_transaction_currency: any;
    ssl_account_balance: any;
    ssl_ps2000_data: any;
    ssl_exp_date: any;
    ssl_result_message: any;
    ssl_card_short_description: any;
    ssl_token_response: any;
    ssl_card_type: any;
    ssl_cvv2_response: any;
    ssl_add_token_response: any;
    ssl_avs_response: any;
    ssl_first_name: any;
    ssl_last_name: any;
    ssl_oar_data: any;
    ssl_get_token: any;
    ssl_salestax: any;
    ssl_token: any;
    ssl_avs_address: any;
    ssl_avs_zip: any;
    policyNumber: any;
    policyId: any;
    responseID: any;
    loading: boolean = false;
    finalStageTransactionCall(){

      var flag = true;

      //   this.responseID=localStorage.getItem('responseID');
      //   console.log(this.responseID)
      //   if(this.responseID!=null && this.responseID!=undefined && this.responseID!="undefined" )
      //   {
      //     this.loading=false
      //     this.blockUI.stop()
      //     this.loading=false
      // Swal.fire('',this.responseID,'error')
      // this.responseID=null;
      // localStorage.removeItem('responseID');
      // localStorage.removeItem('ssl_first_name');
      // localStorage.removeItem('transactionID');
      // localStorage.removeItem('ssl_last_name');
      // localStorage.removeItem('amount');
      // localStorage.removeItem('ssl_merchant_initiated_unscheduled');
      // localStorage.removeItem('ssl_issuer_response');
      // localStorage.removeItem('ssl_partner_app_id');
      // localStorage.removeItem('ssl_card_number');
      // localStorage.removeItem('ssl_transaction_type');
      // localStorage.removeItem('ssl_transaction_reference_number');
      // localStorage.removeItem('ssl_result');
      // localStorage.removeItem('ssl_approval_code');
      // localStorage.removeItem('ssl_txn_time');
      // localStorage.removeItem('ssl_amount');
      // localStorage.removeItem('ssl_transaction_currency');
      // localStorage.removeItem('ssl_account_balance');
      // localStorage.removeItem('ssl_ps2000_data');
      // localStorage.removeItem('ssl_exp_date');
      // localStorage.removeItem('ssl_result_message');
      // localStorage.removeItem('ssl_card_short_description');
      // localStorage.removeItem('ssl_get_token');
      // localStorage.removeItem('ssl_token_response');
      // localStorage.removeItem('ssl_card_type');
      // localStorage.removeItem('ssl_cvv2_response');
      // localStorage.removeItem('ssl_add_token_response');
      // localStorage.removeItem('ssl_avs_response');
      // localStorage.removeItem('ssl_first_name');
      // localStorage.removeItem('ssl_last_name');
      // localStorage.removeItem('ssl_oar_data');
      // localStorage.removeItem('ssl_get_token');
      // localStorage.removeItem('ssl_salestax');
      // localStorage.removeItem('ssl_token');
      // localStorage.removeItem('ssl_avs_address');
      // localStorage.removeItem('ssl_avs_zip');
      //   }
      //   else{
      // this.ssl_result_message=localStorage.getItem('ssl_result_message');
      // console.log(this.ssl_result_message)
      // if(this.ssl_result_message=="INVALID ISSUER" || this.ssl_result_message=="INVALID CARD"){
      //   if(this.ssl_result_message !=="APPROVAL"){
      //   this.loading=false
      //   this.blockUI.stop()
      //   if(this.ssl_result_message=="EXPIRED CARD") {
      //     Swal.fire('',"Invalid expiry date",'error')
      //   }
      //   else{
      //     if(this.ssl_result_message=="undefined"){
      //       Swal.fire('',"Please Check Payment Details",'error')
      //     }
      //   Swal.fire('',this.ssl_result_message,'error')
      //     }
      //   localStorage.removeItem('responseID');
      //   localStorage.removeItem('ssl_first_name');
      //   localStorage.removeItem('transactionID');
      //   localStorage.removeItem('ssl_last_name');
      //   localStorage.removeItem('amount');
      //   localStorage.removeItem('ssl_merchant_initiated_unscheduled');
      //   localStorage.removeItem('ssl_issuer_response');
      //   localStorage.removeItem('ssl_partner_app_id');
      //   localStorage.removeItem('ssl_card_number');
      //   localStorage.removeItem('ssl_transaction_type');
      //   localStorage.removeItem('ssl_transaction_reference_number');
      //   localStorage.removeItem('ssl_result');
      //   localStorage.removeItem('ssl_approval_code');
      //   localStorage.removeItem('ssl_txn_time');
      //   localStorage.removeItem('ssl_amount');
      //   localStorage.removeItem('ssl_transaction_currency');
      //   localStorage.removeItem('ssl_account_balance');
      //   localStorage.removeItem('ssl_ps2000_data');
      //   localStorage.removeItem('ssl_exp_date');
      //   localStorage.removeItem('ssl_result_message');
      //   localStorage.removeItem('ssl_card_short_description');
      //   localStorage.removeItem('ssl_get_token');
      //   localStorage.removeItem('ssl_token_response');
      //   localStorage.removeItem('ssl_card_type');
      //   localStorage.removeItem('ssl_cvv2_response');
      //   localStorage.removeItem('ssl_add_token_response');
      //   localStorage.removeItem('ssl_avs_response');
      //   localStorage.removeItem('ssl_first_name');
      //   localStorage.removeItem('ssl_last_name');
      //   localStorage.removeItem('ssl_oar_data');
      //   localStorage.removeItem('ssl_get_token');
      //   localStorage.removeItem('ssl_salestax');
      //   localStorage.removeItem('ssl_token');
      //   localStorage.removeItem('ssl_avs_address');
      //   localStorage.removeItem('ssl_avs_zip');
      // }
      //   else{

      // this.transactionID=localStorage.getItem('transactionID');
      // this.amount=localStorage.getItem('amount');
      // this.ssl_merchant_initiated_unscheduled=localStorage.getItem('ssl_merchant_initiated_unscheduled');
      // this.ssl_issuer_response=localStorage.getItem('ssl_issuer_response');
      // this.ssl_partner_app_id=localStorage.getItem('ssl_partner_app_id');
      // this.ssl_card_number=localStorage.getItem('ssl_card_number');
      // this.ssl_transaction_type=localStorage.getItem('ssl_transaction_type');
      // this.ssl_transaction_reference_number=localStorage.getItem('ssl_transaction_reference_number');
      // this.ssl_result=localStorage.getItem('ssl_result');
      // this.ssl_approval_code=localStorage.getItem('ssl_approval_code');
      // this.ssl_txn_time=this.datePipe.transform(localStorage.getItem('ssl_txn_time'), "dd/MM/yyyy HH:mm:ss a");
      // this.amount=localStorage.getItem('ssl_amount');
      // this.ssl_transaction_currency=localStorage.getItem('ssl_transaction_currency');
      // this.ssl_account_balance=localStorage.getItem('ssl_account_balance');
      // this.ssl_ps2000_data=localStorage.getItem('ssl_ps2000_data');
      // this.ssl_exp_date=localStorage.getItem('ssl_exp_date');
      // this.ssl_result_message=localStorage.getItem('ssl_result_message');
      // this.ssl_card_short_description=localStorage.getItem('ssl_card_short_description');
      // this.ssl_token_response=localStorage.getItem('ssl_token_response');
      // this.ssl_card_type=localStorage.getItem('ssl_card_type');
      // this.ssl_add_token_response=localStorage.getItem('ssl_add_token_response');
      // this.ssl_avs_response=localStorage.getItem('ssl_avs_response');
      // this.ssl_first_name=localStorage.getItem('ssl_first_name');
      // this.ssl_last_name=localStorage.getItem('ssl_last_name');
      // this.ssl_oar_data=localStorage.getItem('ssl_oar_data');
      // this.ssl_get_token=localStorage.getItem('ssl_get_token');
      // this.ssl_salestax=localStorage.getItem('ssl_salestax');
      // this.ssl_token=localStorage.getItem('ssl_token');
      // this.ssl_avs_address=localStorage.getItem('ssl_avs_address');
      // this.ssl_avs_zip=localStorage.getItem('ssl_avs_zip');

      // if(this.transactionID != null){flag=true}else{flag=false}
      if (flag == true) {
        var premiumAmount2 = this.selectedPlanPrice;
        while (premiumAmount2.charAt(0) === '$') {
          premiumAmount2 = premiumAmount2.substring(1);
        }

        premiumAmount2 = premiumAmount2.replace(/,/g, "");

        this.amount = premiumAmount2

        for (let i = 0; i < this.travellerInfo.length; i++) {
          if (this.travellerInfo[i].policy) {
            if (this.travellerInfo[i].policy.plans !== null) {
              this.travellerInfo[i].policy.plans.description = null
              this.travellerInfo[i].policy.plans.planDescription = null
            }
          }
        }

        this.travellerDetailsToSend = []
        for (let i = 0; i < this.travellerInformation.length; i++) {
          if (this.travellerInformation[i].notEligibleFlag == false) {
            var obj = {}
            obj["age"] = this.travellerInformation[i].age;
            obj["arrivalDateInCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
            obj["arrivalDateOfCanada"] = this.travellerInformation[i].arrivalDateOfCanada;
            obj["country"] = this.travellerInformation[i].homeCountry;
            obj["dateOfBirth"] = this.travellerInformation[i].dateOfBirth;
            obj["dayTimePhone"] = ""
            obj["deductableOptionId"] = ""
            obj["departureCity"] = this.travellerInformation[i].homeCountry;
            obj["eligable"] = "true"
            obj["emailAddress"] = ""
            obj["firstName"] = this.travellerInformation[i].firstName;
            obj["insitute"] = this.travellerInformation[i].insitute
            obj["language"] = this.selectedQuestionlanguages1
            obj["lastName"] = this.travellerInformation[i].lastName;
            obj["premium"] = premiumAmount2;
            obj["insuredId"] = this.travellerInformation[i].insuredId;
            obj["questionsansers"] =
              // this.questionAnsArray

              [
                {
                  "answer": this.travellerInformation[i].ans[0].ans,
                  "question": this.travellerInformation[i].question[0].question,
                  "quetionId": this.travellerInformation[i].quetionId[0].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[0].quetionAnswerId
                },
                {
                  "answer": this.travellerInformation[i].ans[1].ans,
                  "question": this.travellerInformation[i].question[1].question,
                  "quetionId": this.travellerInformation[i].quetionId[1].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[1].quetionAnswerId
                },
                {
                  "answer": this.travellerInformation[i].ans[2].ans,
                  "question": this.travellerInformation[i].question[2].question,
                  "quetionId": this.travellerInformation[i].quetionId[2].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[2].quetionAnswerId
                },
                {
                  "answer": this.travellerInformation[i].ans[3].ans,
                  "question": this.travellerInformation[i].question[3].question,
                  "quetionId": this.travellerInformation[i].quetionId[3].quetionId,
                  "quetionAnswerId": this.travellerInformation[i].quetionAnswerId[3].quetionAnswerId
                }
              ]
            obj["tripCost"] = ""
            obj["waitPeroid"] = this.travellerInformation[i].waitPeroid;
            this.travellerDetailsToSend.push(obj)
          }
        }


        if (this.purchaserAddress1 !== this.address1 || this.purchaseProvince !== this.Province) {
          this.purchaserAddressSame = false
        }
        // this.amount=1
        this.ssl_transaction_currency = "CAD";
        const request =
        {
          "policyId": this.savedQuotesID,
          "agentId": this.agentId,
          "declaration": true,
          "salesType": "B2B",
          "policyPremium": this.amount,
          "deductableOptions": [
            {
              "amount": 0,
              "createdAt": "2022-04-27T05:08:15.125Z",
              "createdBy": "string",
              "id": 0,
              "lastModifiedBy": "string",
              "option": "string",
              "reduceAmount": 0,
              "updatedAt": "2022-04-27T05:08:15.125Z"
            }
          ],
          "language": this.selectedQuestionlanguages1,
          "noOfDays": this.calculatedDays,
          "optionalInformation": {
            "agentNote": this.agentNote,
            "beneficiary": this.beneficiary,
            "comment": this.comment
          },
          "paymentInformation": {
            "amount": this.amount,
            "cardNumber": this.cardNoToSend,
            "cardType": this.cardType,
            "cvv": this.cvvToSend,
            "expiryDate": this.expDate1ToSend2
          },
          "primaryAddress": {

            "province": this.Province,
            "address1": this.address1,
            "address2": this.address2,
            "city": this.City,
            "postalCode": this.PostalCode
          },
          "isSameAddress": this.purchaserAddressSame,
          "questionsansers": this.questionAnsArray,
          "residentOf": this.selectedQuestionprovince1,
          "returnDate": this.expiryDateSelected,
          "secondaryAddress": {
            "address1": "string",
            "address2": "string",
            "city": "string",
            "postalCode": "string",
            "province": "string"
          },
          "transactionResponse": null,
          "selectedPlan": this.selectedPlanSend,
          "startDate": this.startDateSelected,
          "travellerInformation": this.travellerInfo,
          "travelllerDetails": this.travellerDetailsToSend,
          "visitorsToCanada": this.selectedQuestionAns1,
          "purchaserInformation": {
            "country": this.purchaserNonResidentCountryName,
            "emailAddress": this.purchaseEmail,
            "firstName": this.purchaserFirstName,
            "language": this.selectedQuestionlanguages1,
            "lastName": this.purchaserLastName,
            "phoneNumber1": this.purchasePhone1,
            "phoneNumber2": "",
            "postalCode": this.purchasePostalCode,
            "province": this.purchaseProvince,
            "purchaserAddress": {
              "country": this.purchaserNonResidentCountryName,
              "address1": this.purchaserAddress1,
              "address2": this.purchaserAddress2,
              "city": this.purchaseCity,
              "postalCode": this.purchasePostalCode,
              "province": this.purchaseProvince
            }

          },
          "creditCardInfo": {
            "ccNum": this.cardNoToSend,
            "expDate": this.expDate1ToSend2
          }
        }
        this.loading = false;
        this.blockUI.stop();
        this.blockUI.start('Your request is being processed. Please do not refresh your screen. Thank you for your patience.');
        console.log(request)
        this.base.callPostService(this.config.postBuyPolicy, request).subscribe((data: any) => {
          if (data.status == true) {
            this.loading = false;
            this.blockUI.stop();
            this.blockUI.start('Your request is being processed. Please do not refresh your screen. Thank you for your patience.');
            this.policyNumber = data.data.policyNumber;
            this.policyId = data.data.id;
            localStorage.setItem('policyNumber', this.policyNumber);
            localStorage.setItem('policyId', this.policyId);
            localStorage.setItem('purchaserEmail', data.data.purchaserEmailAddress);
            window.location.href = 'https://thzretail.com/TL-Broker-Self-Help-Portal/#/dashboard/payment';
            //  window.location.href = 'https://mytl.travelance.ca/#/dashboard/payment';
            // window.location.href = 'http://localhost:4200/#/dashboard/payment';
          }
          else {
            this.loading = false;
            this.blockUI.stop();
            Swal.fire('', data.message, 'error')

          }
        }, error => {

          if (error.status == 500) {
            this.loading = false
            Swal.fire('', "There was an error in processing your payment. Please contact Travelance Support. If your card has been charged, it would be refunded.", 'error')
          }
          if (error.status == 400) {
            this.loading = false
            Swal.fire('', "There was an error in processing your payment. Please contact Travelance Support. If your card has been charged, it would be refunded.", 'error')
          }

        }, () => { });
      }
      // }
      // }
    }
    skipQuestion(){
      var obj = {}
      for (let i = 0; i < this.qestionInfoArrayShow.length; i++) {
        obj["answer"] = "No";
        obj["question"] = this.qestionInfoArrayShow[i].question;
        obj["quetionId"] = this.qestionInfoArrayShow[i].id;
        this.questionAnsArray.push(obj);
      }
      this.notEligible = false;
      this.showQuestionnaireQue = false;
      this.showDeclarationQuestionnaire = true;
    }
    PopupPlanName: any;
    PopuptotalAmount: any;
    planNameClick(planName, totalAmount){
      this.PopupPlanName = planName
      this.PopuptotalAmount = totalAmount
    }
    disableProvince: boolean = false;
    onClickAddressSameCheckbox(event){

      if (this.address1 !== undefined) {
        var testFlag = event.target.checked;

        if (testFlag) {

          this.purchaserAddressSame = true;
          this.purchaserAddress1 = this.address1;
          this.purchaserAddress2 = this.address2;
          this.purchaseCity = this.City;
          this.purchasePostalCode = this.PostalCode;
          this.purchaseProvince = this.Province;
          this.resdentShowShow = this.Province;
          this.disableProvince = true;
          for (let i = 0; this.provincesArray1.length > i; i++) {
            if (this.provincesArray1[i].provinceName == this.Province || this.provincesArray1[i].provinceCode == this.ProvinceCode) {
              // this.showOutSideProvincePopup=false;
              this.PopupShowProvince = false
              return;
            } else {
              // this.showOutSideProvincePopup=true;
              this.PopupShowProvince = true
            }
          }

        } else {
          this.purchaserAddressSame = false;
          this.purchaserAddress1 = "";
          this.purchaserAddress2 = "";
          this.purchaseCity = "";
          this.purchasePostalCode = "";
          this.purchaseProvince = null;
          this.disableProvince = false;
        }
      }
      else {
        this.purchaserAddressSame = false;
      }

    }
    creditCardDetailsID: any;
    isPaymentLinkAlreadySent: boolean = false;
    paymentSentDate: any;
    getQuoteData(){
      this.travellerInfo = []
      this.user.getSavedQuoteById(this.savedQuotesID).pipe().subscribe(data => {
        if (data.data.effectiveDate) {
          this.startDate = data.data.effectiveDate;
        }
        this.minDateArrival = this.startDate;
        if (data.data.expiryDate) {
          this.expiryDate = data.data.expiryDate;
        }
        if (data.data.noOfDays) {
          this.calculatedDays = data.data.noOfDays;
        }
        this.savedQuotePolicyInsuredArray = data.data.policyInsureds;
        this.quoteName = data.data.quoteName
        this.quoteDescriptions = data.data.quoteDescription
        for (let i = 0; i < data.data.policyInsureds.length; i++) {
          var obj1 = {};
          obj1["age"] = data.data.policyInsureds[i].age;
          obj1["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
          obj1["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth;
          obj1["waitPeroid"] = data.data.policyInsureds[i].waitPeroid;
          this.travellerInfo.push(obj1);
        }
        this.selectedQuestionprovince1 = data.data.province
        this.NonResidentCountry = data.data.purchaserAddressCountry
        if (this.selectedQuestionprovince1 == "Non-Resident of Canada") {
          this.NonResidentSelected = true
          this.purchaseProvince = data.data.province
          this.shownew = true
          this.purchaseProvince = data.data.province
        } else {
          this.purchaseProvince = data.data.purchaserAddressProvince
          this.shownew = false
          this.NonResidentSelected = false;
        }
        this.address1 = data.data.primaryAddress1;
        this.address2 = data.data.primaryAddress2;
        this.City = data.data.primaryAddressCity;
        this.PostalCode = data.data.primaryAddressPostalCode;
        this.Province = data.data.primaryAddressProvince;
        this.purchaserAddressSame = data.data.isSameAddress;
        this.purchaserFirstName = data.data.purchaserFirstName
        this.purchaserLastName = data.data.purchaserLastName
        this.purchaserAddress1 = data.data.purchaserAddress1
        this.purchaserAddress2 = data.data.purchaserAddress2
        this.purchaseEmail = data.data.purchaserEmailAddress
        this.purchaseEmailConfirm = data.data.purchaserEmailAddress
        this.purchasePhone2 = data.data.purchaserPhone2
        this.purchasePhone1 = data.data.purchaserPhone1
        this.purchaseCity = data.data.purchaserAddressCity
        this.isPaymentLinkAlreadySent = data.data.isPaymentLinkAlreadySent;
        this.paymentSentDate = data.data.paymentSentDate
        // this.purchaseProvince=data.data.purchaserAddressProvince
        if (this.purchaseProvince == "Non-Resident of Canada") {
          this.NonResidentSelected = true
        } else {
          this.NonResidentSelected = false;
        }
        this.purchasePostalCode = data.data.purchaserAddressPostalCode
        this.selectedQuestionlanguages1 = data.data.language;
        if (data.data.creditCardDetails.length != 0) {
          for (let i = 0; i < data.data.creditCardDetails.length; i++) {
            try { this.expDate1ToSend = data.data.creditCardDetails[i].sslExpDate.slice(0, 2) } catch { }
            try { this.expDateYearToSend = data.data.creditCardDetails[i].sslExpDate.slice(2, 4) } catch { }
            this.cardNoToSend = data.data.creditCardDetails[i].sslCardNumber
            this.cardType = data.data.creditCardDetails[i].sslCardType
            this.creditCardDetailsID = data.data.creditCardDetails[i].id
            this.onBlur()
          }
        }
        this.beneficiary = data.data.beneficary
        this.comment = data.data.comment
        if (data.data.plans != null) {
          this.planQuoteResponses = []
          this.planQuoteResponses.push(data.data.plans);

          this.planQuoteResponses[0].totalAmount = data.data.policyPremium
          this.planQuoteResponses[0].planId = data.data.plans.id
        }
        var obj1 = {};
        obj1["planId"] = data.data?.plans.id
        obj1["planName"] = data.data?.plans.planName
        this.selectedPlanSend = obj1;
        this.travellerInformation.push(data.data.policyQuestionAnswers)
        this.insuredCount = data.data.policyInsureds.length
        this.travellerInformation = []
        for (let i = 0; i < data.data.policyInsureds.length; i++) {
          var obj = {}
          obj["age"] = data.data.policyInsureds[i].age
          obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada
          obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth
          obj["waitPeroid"] = data.data.policyInsureds[i].waitPeroid
          obj["notEligibleFlag"] = false
          obj["checkDeclaration"] = false
          obj["age"] = data.data.policyInsureds[i].age
          obj["arrivalDateInCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
          obj["arrivalDateOfCanada"] = data.data.policyInsureds[i].arrivalDateOfCanada;
          obj["homeCountry"] = data.data.policyInsureds[i].homeCountry;
          obj["dateOfBirth"] = data.data.policyInsureds[i].dateOfBirth;
          obj["dayTimePhone"] = ""
          obj["deductableOptionId"] = ""
          obj["departureCity"] = data.data.policyInsureds[i].homeCountry;
          obj["eligable"] = "true"
          obj["emailAddress"] = ""
          obj["firstName"] = data.data.policyInsureds[i].firstName;
          obj["insitute"] = data.data.policyInsureds[i].insitute
          obj["language"] = this.selectedQuestionlanguages1
          obj["lastName"] = data.data.policyInsureds[i].lastName;
          obj["premium"] = ""
          obj["insuredId"] = data.data.policyInsureds[i].id;

          obj["question"] =
            [
              { question: "" },
              { question: "" },
              { question: "" },
              { question: "" }
            ]
          obj["quetionId"] =
            [
              { quetionId: "" },
              { quetionId: "" },
              { quetionId: "" },
              { quetionId: "" }
            ]
          obj["ans"] =
            [
              { ans: "" },
              { ans: "" },
              { ans: "" },
              { ans: "" }
            ]
          obj["answer"] = [
            { answer: false },
            { answer: false },
            { answer: false },
            { answer: false }
          ]
          obj["quetionAnswerId"] = [
            { quetionAnswerId: "" },
            { quetionAnswerId: "" },
            { quetionAnswerId: "" },
            { quetionAnswerId: "" }
          ]
          this.travellerInformation.push(obj);
          for (let j = 0; j < data.data.policyInsureds[i].policyQuestionAnswers.length; j++) {
            if (data.data.policyInsureds[i].policyQuestionAnswers[j].question != null) {
              this.travellerInformation[i].question[j].question = data.data.policyInsureds[i].policyQuestionAnswers[j].question.question;
              this.travellerInformation[i].quetionId[j].quetionId = data.data.policyInsureds[i].policyQuestionAnswers[j].question.id;
            }
            this.travellerInformation[i].ans[j].ans = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
            this.travellerInformation[i].answer[j].answer = data.data.policyInsureds[i].policyQuestionAnswers[j].answer;
            this.travellerInformation[i].quetionAnswerId[j].quetionAnswerId = data.data.policyInsureds[i].policyQuestionAnswers[j].id;

          }

        }






      },
        error => {

        });
    }
    clickQuote()
    {

      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }

    goToQuotePurchase(){

      if (this.hideQuotePurchase != "true" && this.agentIdActive == 'true') {
        this.router.navigateByUrl('/dashboard/Quotes-Purchase');
      } else {
        if (this.hideQuotePurchase == "true") {
          Swal.fire("", "We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.", "info")
        }
      }
    }
    selectPlanDetails: any = [];
    saveQuoteStep1Active: boolean = false;
    saveQuoteStep2Active: boolean = false;
    saveQuoteStep3Active: boolean = false;
    saveAndEmailQuoteStep1(){

      var flag = true;
      if (!this.quoteName) { this.quoteNameFlag = true; flag = false } else { this.quoteNameFlag = false }
      if (flag == true) {
        //   this.saveQuotesPopup=false;
        //   Swal.fire('',"Please Select Plan On Step 2",'info');
        this.showSendSaveQuoteEmail = true;
        this.quoteNameFlag = false;
        this.saveQuotesPopup = false;
        this.saveQuotesPopup1 = false;
        this.saveQuotesPopup2 = false;
        this.onClickToShowPlanInfo();
        this.showQuestionnaireQue = false;
        this.saveQuoteStep1Active = true;
        this.saveQuoteStep2Active = false;
        this.saveQuoteStep3Active = false;
        this.showDeclarationQuestionnaire = false;
        this.showChooseQuote = false;
        this.showIntStudPlan = false;
        this.showIntStudPlanStep1 = false;
        this.showIntStudPlanPlanOption = false;
        this.showQuestionnaire = false;
        this.showContactInfo = false;
        this.showPayment = false;
        this.showPaymentsDetails = false;
        this.showStudAccidentInsure = false;
        if (this.selectedPlanSendHtml.length != 0) {
          this.selectPlanDetails = []
          this.selectPlanDetails = this.selectedPlanSendHtml;
        }
      }
    }
    saveAndEmailQuoteStep2(){

      var flag = true;
      if (!this.quoteName) { this.quoteNameFlag = true; flag = false } else { this.quoteNameFlag = false }
      if (flag == true) {


        //  this.step2SaveQuote();
        //  if(this.selectedPlanSend.length!=0){
        this.showSendSaveQuoteEmail = true;
        this.quoteNameFlag = false;
        this.saveQuotesPopup = false;
        this.saveQuotesPopup1 = false;
        this.saveQuotesPopup2 = false;
        this.showQuestionnaireQue = false;
        this.saveQuoteStep1Active = false;
        this.saveQuoteStep2Active = true;
        this.saveQuoteStep3Active = false;
        this.showDeclarationQuestionnaire = false;
        this.showChooseQuote = false;
        this.showIntStudPlan = false;
        this.showIntStudPlanStep1 = false;
        this.showIntStudPlanPlanOption = false;
        this.showQuestionnaire = false;
        this.showContactInfo = false;
        this.showPayment = false;
        this.showPaymentsDetails = false;
        this.showStudAccidentInsure = false;

        if (this.selectedPlanSendHtml.length != 0) {
          this.selectPlanDetails = []
          this.selectPlanDetails = this.selectedPlanSendHtml;
        }
        else {
          this.selectedPlanSendHtml = null;
        }
        // }
        // else{
        //   this.saveQuotesPopup1=false;
        //   Swal.fire('',"Please Select Plan",'info');
        // }
      }
    }
    saveAndEmailQuoteStep3(){
      var flag = true;
      if (!this.quoteName) { this.quoteNameFlag = true; flag = false } else { this.quoteNameFlag = false }
      if (flag == true) {
        this.showSendSaveQuoteEmail = true;
        this.quoteNameFlag = false;
        this.saveQuotesPopup = false;
        this.saveQuotesPopup1 = false;
        this.saveQuotesPopup2 = false;
        this.saveQuoteStep1Active = false;
        this.saveQuoteStep2Active = false;
        this.saveQuoteStep3Active = true;
        this.showQuestionnaireQue = false;
        this.showDeclarationQuestionnaire = false;
        this.showChooseQuote = false;
        this.showIntStudPlan = false;
        this.showIntStudPlanStep1 = false;
        this.showIntStudPlanPlanOption = false;
        this.showQuestionnaire = false;
        this.showContactInfo = false;
        this.showPayment = false;
        this.showPaymentsDetails = false;
        this.showStudAccidentInsure = false;
        if (this.selectedPlanSendHtml.length != 0) {
          this.selectPlanDetails = []
          this.selectPlanDetails = this.selectedPlanSendHtml;
        }
      }
    }
    sendEmailofSavedPolicy: any = null;
    savedEmailTemplate: any;
    savedEmailTemplateName: any;
    savedQuoteEmailPlanName: any;
    showSendSaveQuoteEmail: boolean = false;
    sendEmailOfSavedQuotes(){
      var flag = true;
      if (this.sendEmailofSavedPolicy == null || this.sendEmailofSavedPolicy == "") { flag = false } else { flag = true }
      if (flag == true) {
        const request = {
          "email": this.sendEmailofSavedPolicy,
          "emailName": this.savedEmailTemplateName,
          "emailTemplate": this.savedEmailTemplate,
          "policyId": this.savedQuotesID
        }
        this.base.callPostService(this.config.sendEmailOfSavedQuotes, request).subscribe((data: any) => {
          if (data.status == true) {
            Swal.fire('', data.message, 'success');
          } else {
            Swal.fire('', data.message, 'error');
          }
        }, error => {

        }, () => { });
      } else {
        Swal.fire('', "Enter Email ID", 'error');
      }
    }
    gobackFromSaveQuoteEmail(){
      window.location.reload()
    }
    onSelectedBoxFile(index){
      // Test server 
      // this.fileId=973944120504
      // Prod

      // var fileId=973640479796
      this.user.getLeadPreviewLinkSales().pipe()
        .subscribe(
          data => {

            //(data.data)
            this.UrlBoxPolicy = data.data.previewLink;
            this.UrlBoxPolicyDownload = data.data.downloadLink;

          }, error => {



          }, () => { });
      if (index !== 3) {
        setTimeout(() => {
          this.viewPolicyDetailsPopup1 = !this.viewPolicyDetailsPopup1;
        },
          2000);
      }
    }
    downloadPolicyWording(){
      var win = window.open(this.UrlBoxPolicyDownload, '_blank');
    }

    onClickCancel(){
      Swal.fire({
        title: 'Are you sure?',
        text: "You want to cancel and return?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2778c4 !important;',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      })
    }
    removeEmailError(){
      this.showEmailError = true;
    }
    showEmailError: boolean = false;
    sendEmailOnstep1(){
      //
      var flag = true;
      if (this.sendEmailofSavedPolicy == null || this.sendEmailofSavedPolicy == "" || this.showEmailError == true) { flag = false, this.showEmailError = true } else { this.showEmailError = false; flag = true }
      if (flag == true) {
        this.saveQuoteStage1();
      }
    }
    sendEmailOnstep2(){
      //
      var flag = true;
      if (this.sendEmailofSavedPolicy == null || this.sendEmailofSavedPolicy == "" || this.showEmailError == true) { flag = false, this.showEmailError = true } else { this.showEmailError = false; flag = true }
      if (flag == true) {
        this.step2SaveQuote();
      }
    }
    sendEmailOnstep3(){
      //
      var flag = true;
      if (this.sendEmailofSavedPolicy == null || this.sendEmailofSavedPolicy == "" || this.showEmailError == true) { flag = false, this.showEmailError = true } else { this.showEmailError = false; flag = true }
      if (flag == true) {
        this.onSaveQuote3();
      }
    }
    sendemailNotValid: any;
    sendemailCheck(){
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.sendEmailofSavedPolicy.toLowerCase())) {
        this.sendemailNotValid = "Please enter valid Email";
        this.showEmailError = true;
      } else {
        this.sendemailNotValid = "";
        this.showEmailError = false;
      }
    }
    purchaserNonResidentCountryflagclick(p){

      this.purchaserAddressSame = false;
      this.purchaserAddress1 = "";
      this.purchaserAddress2 = "";
      this.purchaseCity = "";
      this.purchasePostalCode = "";
      this.purchaserNonResidentCountryflag = false;
      this.purchaserNonResidentCountryName = p.displayName

    }
    checkForCaptcha: boolean = false;
    errorCaptchmsg: boolean = false;
    resolved(captchaResponse: string) {
      if (captchaResponse == null) {
        this.checkForCaptcha = false;
        this.errorCaptchmsg = true;
      } else {
        this.checkForCaptcha = true;
        this.errorCaptchmsg = false;
      }
    }
    captchaCheck(){
      if (this.checkForCaptcha == false) {
        this.errorCaptchmsg = true;
      }
    }
    showPaymentLinkPop: boolean = false;
    onClickSendPaymentLink(){

      var errormsg = [];
      if (this.NonResidentSelected == true) {
        if (this.purchaserFirstName == "" || this.purchaserLastName == "" || this.purchaseEmail == "" || this.purchaseEmailConfirm == "" || this.confirmEmailMatch == true) {
          if (this.purchaserFirstName == "") { errormsg.push("'First Name'") }
          if (this.purchaserLastName == "") { errormsg.push("'Last Name'") }
          if (this.purchaseEmail == "") { errormsg.push("'Email Address'") }
          if (this.purchaseEmailConfirm == "") { errormsg.push("'Confirm Email Address'") }
          if (this.confirmEmailMatch == true) { errormsg.push("'Email and Confirm Email Address does not match'") }
          var errmsgfinal = errormsg.join(",");
          Swal.fire('', "To send the payment link to your client, complete the " + "<br>" + "<span class='fs-16 mt-1'>" + errmsgfinal + "</span>" + ' field.', 'warning')
        } else {
          this.showPaymentLinkPop = true;
          this.showSendSaveQuoteEmail = false;
        }
      } else {
        if (this.purchaserFirstName == "" || this.purchaserLastName == "" || this.purchaserAddress1 == "" || this.purchaseProvince == null || this.purchasePostalCode == "" || this.purchasePhone1 == "" || this.purchaseEmail == "" || this.purchaseEmailConfirm == "" || this.purchaseCity == "" || this.confirmEmailMatch == true) {
          if (this.purchaserFirstName == "") { errormsg.push("'First Name'") }
          if (this.purchaserLastName == "") { errormsg.push("'Last Name'") }
          if (this.purchaserAddress1 == "") { errormsg.push("'Address 1'") }
          if (this.purchaseCity == "") { errormsg.push("'City'") }
          if (this.purchaseProvince == null) { errormsg.push("'Province'") }
          if (this.purchasePostalCode == "") { errormsg.push("'Postal Code'") }
          if (this.purchasePhone1 == "") { errormsg.push("'Phone 1'") }
          if (this.purchaseEmail == "") { errormsg.push("'Email Address'") }
          if (this.purchaseEmailConfirm == "") { errormsg.push("'Confirm Email Address'") }
          if (this.confirmEmailMatch == true) { errormsg.push("'Email and Confirm Email Address does not match'") }
          var errmsgfinal = errormsg.join(", ");
          Swal.fire('', "To send the payment link to your client, complete the " + "<br>" + "<span class='fs-16 mt-1'>" + errmsgfinal + "</span>" + ' field.', 'warning')
        } else {
          this.showPaymentLinkPop = true;
          this.showSendSaveQuoteEmail = false;
        }
      }
    }
    onClickSaveQuotePaymentLink(){
      this.onSaveQuote3()
    }
    sendPaymentLink(){
      const now = new Date();
      this.currentTime = now.toString();
      this.currentTime=this.datePipe.transform(this.currentTime, "hh:mm a")
      const request = {
        "email": this.purchaseEmail,
        "emailName": "",
        "emailTemplate": "",
        "policyId": this.savedQuotesID,
        "brokerTime":this.currentTime
      }
      this.base.callPostService(this.config.sendPaymentLink, request).subscribe((data: any) => {
        if (data.status == true) {
          this.showPaymentLinkPop = false;
          Swal.fire('', 'The payment link was successfully sent to ' + this.purchaseEmail + '.<br/>Note: payment links are valid for 72 hours.', 'success')
          this.router.navigateByUrl('/dashboard/Save-Quotes');
        } else {
          Swal.fire('', data.message, 'error');
        }

      }, error => {
      }, () => { });
    }
    getLeadAgentsCodes(){
      this.user.getLeadAgentsCodes(this.leadsId).pipe()
        .subscribe(
          data => {
            // console.log(data);
            // this.agentcodedata=[];

            // this.agentIdActive=sessionStorage.getItem('agentIdActive');
            for (let i = 0; i < data.data.agentCodes.length; i++) {
              if (this.agentId == data.data.agentCodes[i].id) {
                if (data.data.agentCodes[i].status == "Active" || data.data.agentCodes[i].status == "Primary") {
                  this.agentIdActive = 'true'
                }
                else {
                  this.agentIdActive = 'false'
                }
              }
              // this.agentcodedata.push(data.data.agentCodes[i])
              // console.log(this.agentcodedata)
            }
          }, error => {

            // if (error.status == 400 || error.status == 417) {
            //   this.error = error.error.data;
            // }
            // else {
            //   this.error = "Something went wrong. Please check username and password.";
            // }
          }, () => { });
    }
    goToSalesHome(){
      if (this.agentIdActive == 'true') {
        this.router.navigateByUrl('/dashboard/sales-home');
      } else {
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }

    }
    goToPolicySearch(){
      if (this.agentIdActive == 'true') {
        this.router.navigateByUrl('/dashboard/policy-search');
      } else {
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }

    }
    goToSaveQuote(){

      if (this.agentIdActive == 'true') {
        this.router.navigateByUrl('/dashboard/Save-Quotes');
      } else {
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }
    }
    goToforms(){

      if (this.agentIdActive == 'true') {
        this.router.navigateByUrl('/dashboard/forms');
      } else {
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }
    }
    goToResources(){
      if (this.agentIdActive == 'true') {
        this.router.navigateByUrl('/dashboard/resources');
      } else {
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }

    }
    onCloseRefresh(){
      window.location.reload();
    }
    gotBackToQuestionnaire1(){
      window.scrollTo(0, 0);
      this.showChooseQuote = false;
      this.showIntStudPlan = true;
      this.showIntStudPlanStep1 = false;
      this.showIntStudPlanPlanOption = true;
      this.showQuestionnaire = false;
      this.showContactInfo = false;
      this.showPayment = false;
      this.showPaymentsDetails = false;
      if (this.showSaveQuotesVal == "true") {
        this.declarationErrorFlag = true
      }
    }
  
  
selectedNonResident:any="Yes";
changeNonResident(selectedNonResident){
  
  if(selectedNonResident=="No" ){
    this.shownew=true
    this.NonResidentSelected=true;
    this.selectedQuestionprovince1="Non-Resident of Canada"
  }else{
    this.selectedQuestionprovince1=null
    this.shownew=false
    this.NonResidentSelected=false; 
  }
}
onInput(event: any): void {
  const rawValue = event.target.value.replace(/\D/g, ''); // Only digits
  if (rawValue.length > 16) return;

  this.cardNoToSend = rawValue;
  this.showMaskedCard = false;
}

onBlur(): void {
  this.showMaskedCard = true;
  this.displayMaskedCard();
}

displayMaskedCard(): void {
  if (!this.cardNoToSend || this.cardNoToSend.length < 6) {
    this.displayCardNumber = this.cardNoToSend;
    return;
  }

  const start = this.cardNoToSend.slice(0, 2);
  const end = this.cardNoToSend.slice(-4);
  const masked = '*'.repeat(this.cardNoToSend.length - 6);
  this.displayCardNumber = `${start}${masked}${end}`;
}
}
